import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue';
import MainApp from './MainApp.vue';
import QuickVideoPlay from './components/quick/QuickVideoPlay.vue'
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import DialogService from 'primevue/dialogservice';
import ConfirmationService from 'primevue/confirmationservice';
import VueClipboard from 'vue3-clipboard'
import './assets/iconfont/iconfont.css'
import 'primevue/resources/themes/saga-blue/theme.css'       //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css';
import common from './utils/common'
import { createRouter,createWebHistory } from 'vue-router'

const routes = [
  { 
    path: '/video-play',
    name: 'video-play', 
    component: QuickVideoPlay
  },
  { 
    path: '/:k/:s/:p', 
    name:'appksp',
    component: MainApp
  },
  { 
    path: '/:k/:s', 
    name:'appks',
    component: MainApp
  },
  { 
    path: '/:k', 
    name:'appk',
    component: MainApp
  },
  { path: '/', component: MainApp }
]

const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHistory(),
  routes, // short for `routes: routes`
})

// 1. Ready translated locale messages
// The structure of the locale message is the hierarchical object structure with each locale as the top property
const messages = {
  en: {
    message: {
      // start of App.vue
      qr_redirect_url: 'The QR code will redirect to following url, it might not be safe:',
      user_or_guest: "The QR code functions differently according to scanner's identity. Are you a registered user or a guest?",
      input_username: 'Enter username',
      input_password: 'Enter password',
      login: 'Login',
      i_am_a_guest: 'I am a guest',
      loading_qr: 'Loading QR code ...',
      invalid_qr: 'Invalid QR code',
      campaign_not_start: "The QR code campaign hasn't started",
      campaign_end: 'The QR code campaign has ended',
      subscription_expired: 'The QR code is unavailable, because it is under a plan which has expired.',
      max_scan_reached: 'The QR code is unavailable, because maximum scan allowed for the plan of this QR code is reached.',
      not_allowed: 'You are not allowed to visit this QR.',
      qr_closed:'This QR code is closed.',
      password_protected: 'The QR code is password protected, please validate password',
      validate: 'Validate',
      pleasesave: "Dynamic QR Code doesn't work before it is saved. If you see this page, please save it.",
      invalid_password: 'Invalid password',
      password_validation_error: 'An error occurred while validating password.',
      invalid_username_password:'Invalid username or password.',
      login_error: 'An error occurred while logining.',
      scan_error: 'An error occurred while scanning QR code.',
      powered_by_top_qr: 'Powered by TOP QR',
      powered_by_88E: 'Powered by TOP QR',
      title_top_qr: 'TOP QR',
      title_88E: 'TOP QR',
      go:'Go',
      // end of App.vue

      // start of componentcontainer
      invalid_operation:'Invalid operation.',
      submit_require_login:'You are required to login to submit data.',
      submit_not_allowed:'You are not allowed to submit data.',
      ok:'Ok',
      cancel:'Cancel',
      // end of componentcontainer

      // start of files.vue
      download_file:'Download',
      download_forbidden:'Forbidden',
      // end of files.vlue

      // start of contact.vue
      phone_number_required:'Empty phone number can not be dialed.',
      email_required:'Email address is required.',
      email_copied:'Email address was copied.',
      navigation_disabled:'Navigation is disabled.',
      // end of contact.vlue

      // start of audiovideo.vue
      audio_not_support:"Your explorer doesn't support audio tag.",
      video_not_support:"Your explorer doesn't support video tag.",
      unkown:'Unknown',
      fail_play_media:'Failed to play media.',
      error_play_media:'An error occurred while playing media.',
      // end of audiovideo.vue

      // start of wechat.vue
      wechat_name:"Click to get Wechat name.",
      form_unavailable_h5:"Form control works only with Wechat miniapp, please scan the QR code again with Wechat.",
      // end of wechat.vue

      // start of video.vue
      upload_video:"Upload video.",
      // end of video.vue 

      // start of time.vue
      is_required:"is required.",
      // end of time.vue

      // start of table.vue
      cells_required:"Highlighted cells are invalid.",
      // end of table.vue 

      // start of signature.vue
      click_sign:"Click to sign",
      // end of signature.vue  

      // start of photo.vue
      upload_picture:"Upload picture",
      // end of photo.vue 

      // start of number.vue
      enter_number:"Enter number",
      // end of number.vue 

      // start of name.vue
      enter_name:"Enter name",
      // end of name.vue 

      // start of multitext.vue
      enter_text:"Enter text",
      // end of multitext.vue

      // start of mobile.vue
      enter_mobile:"Enter mobile",
      // end of mobile.vue 

      // start of message.vue
      welcome_to_top_qr:'Welcome to TOP QR',
      welcome_to_88E:'Welcome to TOP QR',
      // end of message.vue 

      // start of login.vue
      username_required:'Username is required.',
      password_required:'Password is required.',
      signing_in:'Signing in',
      sign_in:'Sign in',
      please_login:'Please login',
      invalid_user_or_password:'Invalid username or password.',
      fail_login:'Failed to login.',
      // end of login.vue 

      // start of location.vue
      enter_location:'Enter location',
      // end of location.vue

      // start of id.vue
      enter_id:'Enter ID',
      // end of id.vue

      // start of gonghao.vue
      enter_employee_number:'Enter employee number',
      // end of gonghao.vue

      // start of gender.vue
      male:'Male',
      female:'Female',
      // end of gender.vue

      // start of file.vue
      upload_file:'Upload file',
      // end of file.vue

      // start of duoji.vue
      pick_cascade_data:'Pick cascade data',
      // end of duoji.vue

      // start of checkbox.vue
      must_check_one_item:'You must check at least one item.',
      // end of checkbox.vue

      // start of audio.vue
      record:'Record',
      // end of audio.vue

      // start of address.vue
      pick_a_district:'Pick a district',
      enter_address:'Enter address',
      // end of address.vue

      // start of field.vue
      serial_number:'Serial number',
      current_value:'Value',
      update_message:'Updated by xxx at xxxx-xx-xx xx:xx:xx',
      // end of field.vue

      // start of common.js
      scan_with_wechat:'Wechat miniapp could not be opened in browser. Please scan the QR code with Wechat',
      // end of common.js

      // start of selectlanguage.vue
      select_language_title:'This QR code supports following languages. Please select a language.',
      // end of selectlanguage.vue

      geo_restricted:"This QR code can only be scanned in restricted area."
    }
  },
  hans: {
    message: {
      // start of App.vue
      qr_redirect_url: '二维码将跳转到以下网址，该网址可能不安全：',
      user_or_guest: "该二维码设置为不同的扫码者扫出的内容不尽相同，请问您是注册用户还是游客？",
      input_username: '请输入用户名',
      input_password: '请输入密码',
      login: '登录',
      i_am_a_guest: '我是游客',
      loading_qr: '正在加载二维码 ...',
      invalid_qr: '无效的二维码',
      campaign_not_start: "二维码活动还未开始",
      campaign_end: '二维码活动已结束',
      subscription_expired: '该二维码无法扫码，因为其对应的套餐已过期。',
      max_scan_reached: '该二维码无法扫码，因为扫码量已经达到了该二维码的最大扫码量。',
      password_protected: '该二维码受密码保护，请验证密码。',
      validate: '验证',
      pleasesave: "动态二维码需要保存才可以正常显示，如果您看到本页面，请先保存动态二维码。",
      invalid_password: '密码错误',
      password_validation_error: '验证密码时发生错误。',
      invalid_username_password:'无效的用户名或密码。',
      login_error: '登录时发生错误。',
      scan_error: '扫码时发生错误。',
      powered_by_top_qr: '技术支持 TOP QR',
      powered_by_88E: '技术支持 88 二维码',
      title_top_qr: 'TOP QR',
      title_88E: '88 二维码',
      go:'前往访问',
      // end of App.vue

      // start of componentcontainer
      invalid_operation:'非法操作。',
      submit_require_login:'您需要登录才能提交数据。',
      submit_not_allowed:'您无权提交数据。',
      ok:'确认',
      cancel:'取消',
      // end of componentcontainer

      // start of files.vue
      download_file:'下载文件',
      download_forbidden:'禁止下载',
      // end of files.vlue

      // start of contact.vue
      phone_number_required:'无法拨打空电话号码。',
      email_required:'邮箱地址必填。',
      email_copied:'邮箱地址已复制。',
      navigation_disabled:'禁止导航。',
      // end of contact.vlue

      // start of audiovideo.vue
      audio_not_support:"浏览器不支持 audio 标签。",
      video_not_support:"浏览器不支持 video 标签。",
      unkown:'未知',
      fail_play_media:'播放失败。',
      error_play_media:'播放时发生错误。',
      // end of audiovideo.vue

      // start of wechat.vue
      wechat_name:"单击读取微信名。",
      form_unavailable_h5:"表单控件只能在微信小程序里使用，请用微信重新扫码。",
      // end of wechat.vue

      // start of video.vue
      upload_video:"上传视频。",
      // end of video.vue 

      // start of time.vue
      is_required:"必填。",
      // end of time.vue  

      // start of table.vue
      cells_required:"突出显示的单元格必填。",
      // end of table.vue

      // start of signature.vue
      click_sign:"单击以签名",
      // end of signature.vue

      // start of photo.vue
      upload_picture:"上传图片",
      // end of photo.vue

      // start of number.vue
      enter_number:"请输入数字",
      // end of number.vue 

      // start of name.vue
      enter_name:"请输入姓名",
      // end of name.vue

      // start of multitext.vue
      enter_text:"请输入文本",
      // end of multitext.vue 

      // start of mobile.vue
      enter_mobile:"请输入手机号",
      // end of mobile.vue 

      // start of message.vue
      welcome_to_top_qr:'欢迎使用 TOP QR',
      welcome_to_88E:'欢迎使用 88 二维码',
      // end of message.vue

      // start of login.vue
      username_required:'用户名必填。',
      password_required:'密码必填。',
      signing_in:'正在登录',
      sign_in:'登录',
      please_login:'请登录',
      invalid_user_or_password:'无效的用户名或密码。',
      fail_login:'登录失败。',
      // end of login.vue

      // start of location.vue
      enter_location:'请输入位置',
      // end of location.vue

      // start of id.vue
      enter_id:'请输入身份证号码',
      // end of id.vue 

      // start of gonghao.vue
      enter_employee_number:'请输入工号',
      // end of gonghao.vue

      // start of gender.vue
      male:'男',
      female:'女',
      // end of gender.vue

      // start of file.vue
      upload_file:'上传文件',
      // end of file.vue

      // start of duoji.vue
      pick_cascade_data:'选择多级数据',
      // end of duoji.vue

      // start of checkbox.vue
      must_check_one_item:'您必须至少选择一项。',
      // end of checkbox.vue

      // start of audio.vue
      record:'录音',
      // end of audio.vue

      // start of address.vue
      pick_a_district:'请选择省市区',
      enter_address:'请输入地址',
      // end of address.vue 

      // start of field.vue
      serial_number:'序列号',
      current_value:'当前数值',
      update_message:'xxx 于 xxxx-xx-xx xx:xx:xx 更新',
      // end of field.vue

      // start of common.js
      scan_with_wechat:'微信小程序无法在浏览器中打开，请用微信扫码。',
      // end of common.js

      // start of selectlanguage.vue
      select_language_title:'本二维码支持下列语言，请选择一种语言。',
      // end of selectlanguage.vue
      
      geo_restricted:"该二维码仅可在指定的地理区域扫描。"
    }
  },
  hant: {
    message: {
      // start of App.vue
      qr_redirect_url: '二維碼將跳轉到以下網址，該網址可能不安全：',
      user_or_guest: "該二維碼設置為不同的掃碼者掃出的內容不盡相同，請問您是註冊用戶還是遊客？",
      input_username: '請輸入用戶名',
      input_password: '請輸入密碼',
      login: '登錄',
      i_am_a_guest: '我是遊客',
      loading_qr: '正在加載二維碼 ...',
      invalid_qr: '無效的二維碼',
      campaign_not_start: "二維碼活動還未開始",
      campaign_end: '二維碼活動已結束',
      subscription_expired: '該二維碼無法掃碼，因為其對應的套餐已過期。',
      max_scan_reached: '該二維碼無法掃碼，因為掃碼量已經達到了該二維碼的最大掃碼量。',
      password_protected: '該二維碼受密碼保護，請驗證密碼。',
      validate: '驗證',
      pleasesave: "動態二維碼需要保存才可以正常顯示，如果您看到本頁面，請先保存動態二維碼。",
      invalid_password: '密碼錯誤',
      password_validation_error: '驗證密碼時發生錯誤。',
      invalid_username_password:'無效的用戶名或密碼。',
      login_error: '登錄時發生錯誤。',
      scan_error: '掃碼時發生錯誤。',
      powered_by_top_qr: '技術支持 TOP QR',
      powered_by_88E: '技術支持 88 二維碼',
      title_top_qr: 'TOP QR',
      title_88E: '88 二維碼',
      go:'前往訪問',
      // end of App.vue

      // start of componentcontainer
      invalid_operation:'非法操作。',
      submit_require_login:'您需要登錄才能提交數據。',
      submit_not_allowed:'您無權提交數據。',
      ok:'確認',
      cancel:'取消',
      // end of componentcontainer

      // start of files.vue
      download_file:'下載檔',
      download_forbidden:'禁止下載',
      // end of files.vlue

      // start of contact.vue
      phone_number_required:'無法撥打空電話號碼。',
      email_required:'郵箱地址必填。',
      email_copied:'郵箱地址已複製。',
      navigation_disabled:'禁止導航。',
      // end of contact.vlue

      // start of audiovideo.vue
      audio_not_support:"流覽器不支持 audio 標籤。",
      video_not_support:"流覽器不支持 video 標籤。",
      unkown:'未知',
      fail_play_media:'播放失敗。',
      error_play_media:'播放時發生錯誤。',
      // end of audiovideo.vue

      // start of wechat.vue
      wechat_name:"單擊讀取微信名。",
      form_unavailable_h5:"表單控件只能在微信小程式裏使用，請用微信重新掃碼。",
      // end of wechat.vue

      // start of video.vue
      upload_video:"上傳視頻。",
      // end of video.vue 

      // start of time.vue
      is_required:"必填。",
      // end of time.vue  

      // start of table.vue
      cells_required:"突出顯示的單元格必填。",
      // end of table.vue

      // start of signature.vue
      click_sign:"單擊以簽名",
      // end of signature.vue

      // start of photo.vue
      upload_picture:"上傳圖片",
      // end of photo.vue

      // start of number.vue
      enter_number:"請輸入數字",
      // end of number.vue 

      // start of name.vue
      enter_name:"請輸入姓名",
      // end of name.vue

      // start of multitext.vue
      enter_text:"請輸入文本",
      // end of multitext.vue 

      // start of mobile.vue
      enter_mobile:"請輸入手機號",
      // end of mobile.vue 

      // start of message.vue
      welcome_to_top_qr:'歡迎使用 TOP QR',
      welcome_to_88E:'歡迎使用 88 二維碼',
      // end of message.vue

      // start of login.vue
      username_required:'用戶名必填。',
      password_required:'密碼必填。',
      signing_in:'正在登錄',
      sign_in:'登錄',
      please_login:'請登錄',
      invalid_user_or_password:'無效的用戶名或密碼。',
      fail_login:'登錄失敗。',
      // end of login.vue

      // start of location.vue
      enter_location:'請輸入位置',
      // end of location.vue

      // start of id.vue
      enter_id:'請輸入身份證號碼',
      // end of id.vue 

      // start of gonghao.vue
      enter_employee_number:'請輸入工號',
      // end of gonghao.vue

      // start of gender.vue
      male:'男',
      female:'女',
      // end of gender.vue

      // start of file.vue
      upload_file:'上傳檔',
      // end of file.vue

      // start of duoji.vue
      pick_cascade_data:'選擇多級數據',
      // end of duoji.vue

      // start of checkbox.vue
      must_check_one_item:'您必須至少選擇一項。',
      // end of checkbox.vue

      // start of audio.vue
      record:'錄音',
      // end of audio.vue

      // start of address.vue
      pick_a_district:'請選擇省市區',
      enter_address:'請輸入地址',
      // end of address.vue 

      // start of field.vue
      serial_number:'序列號',
      current_value:'當前數值',
      update_message:'xxx 於 xxxx-xx-xx xx:xx:xx 更新',
      // end of field.vue

      // start of common.js
      scan_with_wechat:'微信小程式無法在流覽器中打開，請用微信掃碼。',
      // end of common.js

      // start of selectlanguage.vue
      select_language_title:'本二維碼支持下列語言，請選擇一種語言。',
      // end of selectlanguage.vue 
      
      geo_restricted:"該二維碼僅可在指定的地理區域掃描。"
    }
  },
  de: {
    message: {
      qr_redirect_url :"Der QR-Code leitet auf folgende URL um, er ist möglicherweise nicht sicher:",
      user_or_guest :"Der QR-Code funktioniert je nach Identität des Scanners unterschiedlich. Sind Sie ein registrierter Benutzer oder ein Gast?",
      input_username :"Benutzername eingeben",
      input_password :"Passwort eingeben",
      login :"Einloggen",
      i_am_a_guest :"Ich bin Gast",
      loading_qr :"QR-Code wird geladen ...",
      invalid_qr :"Ungültiger QR-Code",
      campaign_not_start :"Die QR-Code-Kampagne hat nicht begonnen",
      campaign_end :"Die QR-Code-Kampagne ist beendet",
      subscription_expired :"Der QR-Code ist nicht verfügbar, da er unter einem abgelaufenen Plan steht.",
      max_scan_reached :"Der QR-Code ist nicht verfügbar, da der maximal zulässige Scan für den Plan dieses QR-Codes erreicht ist.",
      password_protected :"Der QR-Code ist passwortgeschützt, bitte Passwort bestätigen",
      validate :"Validieren",
      pleasesave :"Dynamischer QR-Code funktioniert nicht, bevor er gespeichert wird. Wenn Sie diese Seite sehen, speichern Sie sie bitte.",
      invalid_password :"Ungültiges Kennwort",
      password_validation_error :"Beim Überprüfen des Kennworts ist ein Fehler aufgetreten.",
      invalid_username_password:"Ungültiger Benutzername oder ungültiges Kennwort.",
      login_error :"Bei der Anmeldung ist ein Fehler aufgetreten.",
      scan_error :"Beim Scannen des QR-Codes ist ein Fehler aufgetreten.",
      powered_by_top_qr :"Unterstützt von TOP QR",
      powered_by_88E :"Unterstützt von TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Los",
      invalid_operation:"Ungültiger Vorgang.",
      submit_require_login:"Sie müssen sich anmelden, um Daten zu übermitteln.",
      submit_not_allowed:"Sie dürfen keine Daten übermitteln.",
      ok:"Okay",
      cancel:"Abbrechen",
      download_file:"Herunterladen",
      download_forbidden:"Verboten",
      phone_number_required:"Leere Telefonnummer kann nicht gewählt werden.",
      email_required:"E-Mail-Adresse ist erforderlich.",
      email_copied:"Die E-Mail-Adresse wurde kopiert.",
      navigation_disabled:"Die Navigation ist deaktiviert.",
      audio_not_support:"Ihr Explorer unterstützt kein Audio-Tag.",
      video_not_support:"Ihr Explorer unterstützt kein Video-Tag.",
      unkown:"Unbekannt",
      fail_play_media:"Medien konnten nicht wiedergegeben werden.",
      error_play_media:"Bei der Medienwiedergabe ist ein Fehler aufgetreten.",
      wechat_name:"Klicken Sie hier, um den Wechat-Namen zu erhalten.",
      form_unavailable_h5:"Formularsteuerung funktioniert nur mit Wechat Miniapp, bitte scannen Sie den QR-Code erneut mit Wechat.",
      upload_video:"Video hochladen.",
      is_required:"ist erforderlich.",
      cells_required:"Hervorgehobene Zellen sind ungültig.",
      click_sign:"Klicken Sie hier, um zu unterschreiben",
      upload_picture:"Bild hochladen",
      enter_number:"Nummer eingeben",
      enter_name:"Name eingeben",
      enter_text:"Text eingeben",
      enter_mobile:"Mobile eingeben",
      welcome_to_top_qr:"Willkommen bei TOP QR",
      welcome_to_88E:"Willkommen bei TOP QR",
      username_required:"Benutzername ist erforderlich.",
      password_required:"Passwort ist erforderlich.",
      signing_in:"Anmelden",
      sign_in:"Anmelden",
      please_login:"Bitte loggen Sie sich ein",
      invalid_user_or_password:"Ungültiger Benutzername oder ungültiges Kennwort.",
      fail_login:"Anmeldung fehlgeschlagen.",
      enter_location:"Standort eingeben",
      enter_id:"ID eingeben",
      enter_employee_number:"Mitarbeiternummer eingeben",
      male:"Männlich",
      female:"Weiblich",
      upload_file:"Datei hochladen",
      pick_cascade_data:"Kaskadendaten auswählen",
      must_check_one_item:"Sie müssen mindestens einen Punkt überprüfen.",
      record:"Aufzeichnung",
      pick_a_district:"Wählen Sie einen Bezirk",
      enter_address:"Adresse eingeben",
      serial_number:"Seriennummer",
      current_value:"Wert",
      update_message:"Aktualisiert von xxx bei xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat Miniapp konnte nicht im Browser geöffnet werden. Bitte scannen Sie den QR-Code mit Wechat",
      select_language_title:"Dieser QR-Code unterstützt folgende Sprachen. Bitte wählen Sie eine Sprache aus.", 
      geo_restricted: "Dieser QR-Code kann nur in einem eingeschränkten Bereich gescannt werden."     
    }
  },
  sp: {
    message: {
      qr_redirect_url :"El código QR redirigirá a la siguiente url, puede que no sea seguro:",
      user_or_guest :"El código QR funciona de manera diferente según la identidad del escáner. ¿Eres un usuario registrado o un invitado?",
      input_username :"Introduzca el nombre de usuario",
      input_password :"Introduzca la contraseña",
      login :"Iniciar sesión",
      i_am_a_guest :"Soy un invitado",
      loading_qr :"Cargando código QR ...",
      invalid_qr :"Código QR no válido",
      campaign_not_start :"La campaña de códigos QR no ha comenzado",
      campaign_end :"La campaña de códigos QR ha finalizado",
      subscription_expired :"El código QR no está disponible, porque está bajo un plan que ha expirado.",
      max_scan_reached :"El código QR no está disponible, porque se alcanza el escaneo máximo permitido para el plan de este código QR.",
      password_protected :"El código QR está protegido por contraseña, valide la contraseña",
      validate :"Validar",
      pleasesave :"El código QR dinámico no funciona antes de guardarse. Si ve esta página, guárdela.",
      invalid_password :"Contraseña no válida",
      password_validation_error :"Se ha producido un error al validar la contraseña.",
      invalid_username_password:"Nombre de usuario o contraseña no válidos.",
      login_error :"Se ha producido un error al iniciar sesión.",
      scan_error :"Se ha producido un error al escanear el código QR.",
      powered_by_top_qr :"Desarrollado por TOP QR",
      powered_by_88E :"Desarrollado por TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Ir",
      invalid_operation:"Operación no válida.",
      submit_require_login:"Debe iniciar sesión para enviar datos.",
      submit_not_allowed:"No se le permite enviar datos.",
      ok:"De acuerdo",
      cancel:"Cancelar",
      download_file:"Descargar",
      download_forbidden:"Prohibido",
      phone_number_required:"El número de teléfono vacío no se puede marcar.",
      email_required:"Se requiere una dirección de correo electrónico.",
      email_copied:"Se copió la dirección de correo electrónico.",
      navigation_disabled:"La navegación está deshabilitada.",
      audio_not_support:"El explorador no admite etiquetas de audio.",
      video_not_support:"El explorador no admite etiquetas de vídeo.",
      unkown:"Desconocido",
      fail_play_media:"Error al reproducir multimedia.",
      error_play_media:"Se ha producido un error al reproducir contenido multimedia.",
      wechat_name:"Haga clic para obtener el nombre de Wechat.",
      form_unavailable_h5:"El control de formularios solo funciona con la miniaplicación Wechat, escanee el código QR nuevamente con Wechat.",
      upload_video:"Sube vídeo.",
      is_required:"es obligatorio.",
      cells_required:"Las celdas resaltadas no son válidas.",
      click_sign:"Haga clic para firmar",
      upload_picture:"Subir imagen",
      enter_number:"Introduzca el número",
      enter_name:"Introduzca el nombre",
      enter_text:"Introducir texto",
      enter_mobile:"Entra en el móvil",
      welcome_to_top_qr:"Bienvenido a TOP QR",
      welcome_to_88E:"Bienvenido a TOP QR",
      username_required:"Se requiere nombre de usuario.",
      password_required:"Se requiere contraseña.",
      signing_in:"Inicio de sesión",
      sign_in:"Inicia sesión",
      please_login:"Por favor inicie sesión",
      invalid_user_or_password:"Nombre de usuario o contraseña no válidos.",
      fail_login:"Error al iniciar sesión.",
      enter_location:"Introduzca la ubicación",
      enter_id:"Introduzca el ID",
      enter_employee_number:"Introduzca el número de empleado",
      male:"Masculino",
      female:"Hembra",
      upload_file:"Subir archivo",
      pick_cascade_data:"Seleccionar datos en cascada",
      must_check_one_item:"Debe marcar al menos un elemento.",
      record:"Grabar",
      pick_a_district:"Elige un distrito",
      enter_address:"Introduzca la dirección",
      serial_number:"Número de serie",
      current_value:"Valor",
      update_message:"Actualizado por xxx en xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"La miniaplicación Wechat no se pudo abrir en el navegador. Por favor, escanee el código QR con Wechat",
      select_language_title:"Este código QR admite los siguientes idiomas. Seleccione un idioma.", 
      geo_restricted:"Este código QR solo se puede escanear en un área restringida"          
    }
  },
  pt: {
    message: {
      qr_redirect_url :"O código QR irá redirecionar para o seguinte url, pode não ser seguro:",
      user_or_guest :"O código QR funciona de forma diferente de acordo com a identidade do scanner. É um utilizador registado ou um convidado?",
      input_username :"Insira o nome de usuário",
      input_password :"Introduza a palavra-passe",
      login :"Iniciar sessão",
      i_am_a_guest :"Eu sou um convidado",
      loading_qr :"Carregando código QR ...",
      invalid_qr :"Código QR inválido",
      campaign_not_start :"A campanha do código QR ainda não começou",
      campaign_end :"A campanha de QR code terminou",
      subscription_expired :"O código QR não está disponível, porque está sob um plano que expirou.",
      max_scan_reached :"O código QR não está disponível, porque o máximo de digitalização permitido para o plano deste código QR é atingido.",
      password_protected :"O código QR é protegido por senha, por favor, valide a senha",
      validate :"Validar",
      pleasesave :"O QR Code dinâmico não funciona antes de ser salvo. Se vir esta página, guarde-a.",
      invalid_password :"Palavra-passe inválida",
      password_validation_error :"Ocorreu um erro ao validar a palavra-passe.",
      invalid_username_password:"Nome de utilizador ou palavra-passe inválidos.",
      login_error :"Ocorreu um erro durante o início de sessão.",
      scan_error :"Ocorreu um erro ao digitalizar o código QR.",
      powered_by_top_qr :"Desenvolvido por TOP QR",
      powered_by_88E :"Desenvolvido por TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Ir",
      invalid_operation:"Operação inválida.",
      submit_require_login:"É necessário iniciar sessão para enviar dados.",
      submit_not_allowed:"Não é permitido enviar dados.",
      ok:"Ok",
      cancel:"Cancelar",
      download_file:"Baixar",
      download_forbidden:"Proibido",
      phone_number_required:"O número de telefone vazio não pode ser discado.",
      email_required:"O endereço de e-mail é obrigatório.",
      email_copied:"O endereço de e-mail foi copiado.",
      navigation_disabled:"A navegação está desativada.",
      audio_not_support:"O explorador não suporta etiquetas de áudio.",
      video_not_support:"O seu explorador não suporta etiquetas de vídeo.",
      unkown:"Desconhecido",
      fail_play_media:"Falha ao reproduzir mídia.",
      error_play_media:"Ocorreu um erro ao reproduzir multimédia.",
      wechat_name:"Clique para obter o nome do Wechat.",
      form_unavailable_h5:"O controle de formulário funciona apenas com o miniapp Wechat, digitalize o código QR novamente com o Wechat.",
      upload_video:"Carregue vídeo.",
      is_required:"é obrigatório.",
      cells_required:"As células realçadas são inválidas.",
      click_sign:"Clique para assinar",
      upload_picture:"Carregar imagem",
      enter_number:"Insira o número",
      enter_name:"Insira o nome",
      enter_text:"Inserir texto",
      enter_mobile:"Entre em dispositivos móveis",
      welcome_to_top_qr:"Bem-vindo ao TOP QR",
      welcome_to_88E:"Bem-vindo ao TOP QR",
      username_required:"O nome de utilizador é obrigatório.",
      password_required:"É necessária uma palavra-passe.",
      signing_in:"Iniciar sessão",
      sign_in:"Iniciar sessão",
      please_login:"Por favor faça login",
      invalid_user_or_password:"Nome de utilizador ou palavra-passe inválidos.",
      fail_login:"Falha ao iniciar sessão.",
      enter_location:"Insira a localização",
      enter_id:"Insira o ID",
      enter_employee_number:"Insira o número do funcionário",
      male:"Masculino",
      female:"Feminino",
      upload_file:"Carregar ficheiro",
      pick_cascade_data:"Escolher dados em cascata",
      must_check_one_item:"Você deve verificar pelo menos um item.",
      record:"Recorde",
      pick_a_district:"Escolha um distrito",
      enter_address:"Insira o endereço",
      serial_number:"Número de série",
      current_value:"Valor",
      update_message:"Atualizado por xxx em xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Não foi possível abrir o miniaplicativo Wechat no navegador. Por favor, digitalize o código QR com Wechat",
      select_language_title:"Este código QR suporta os seguintes idiomas. Selecione um idioma.", 
      geo_restricted:"Este código QR só pode ser escaneado em área restrita."          
    }
  },
  fr: {
    message: {
      qr_redirect_url :"Le code QR redirigera vers l’URL suivante, il pourrait ne pas être sûr:",
      user_or_guest :"Le code QR fonctionne différemment selon l’identité du scanner. Êtes-vous un utilisateur enregistré ou un invité?",
      input_username :"Entrez le nom d’utilisateur",
      input_password :"Entrez le mot de passe",
      login :"Connectez-vous",
      i_am_a_guest :"Je suis un invité",
      loading_qr :"Chargement du code QR ...",
      invalid_qr :"Code QR non valide",
      campaign_not_start :"La campagne de QR code n’a pas commencé",
      campaign_end :"La campagne de QR code est terminée",
      subscription_expired :"Le code QR n’est pas disponible, car il est sous un plan qui a expiré.",
      max_scan_reached :"Le code QR n’est pas disponible, car le scan maximum autorisé pour le plan de ce code QR est atteint.",
      password_protected :"Le code QR est protégé par mot de passe, veuillez valider le mot de passe",
      validate :"Valider",
      pleasesave :"Le code QR dynamique ne fonctionne pas avant d’être enregistré. Si vous voyez cette page, veuillez l’enregistrer.",
      invalid_password :"Mot de passe non valide",
      password_validation_error :"Une erreur s’est produite lors de la validation du mot de passe.",
      invalid_username_password:"Nom d’utilisateur ou mot de passe non valide.",
      login_error :"Une erreur s’est produite lors de la connexion.",
      scan_error :"Une erreur s’est produite lors de la numérisation du code QR.",
      powered_by_top_qr :"Propulsé par TOP QR",
      powered_by_88E :"Propulsé par TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Aller",
      invalid_operation:"Opération non valide.",
      submit_require_login:"Vous devez vous connecter pour soumettre des données.",
      submit_not_allowed:"Vous n’êtes pas autorisé à soumettre des données.",
      ok:"D’accord",
      cancel:"Annuler",
      download_file:"Télécharger",
      download_forbidden:"Interdit",
      phone_number_required:"Le numéro de téléphone vide ne peut pas être composé.",
      email_required:"L’adresse e-mail est requise.",
      email_copied:"L’adresse e-mail a été copiée.",
      navigation_disabled:"La navigation est désactivée.",
      audio_not_support:"Votre explorateur ne prend pas en charge les balises audio.",
      video_not_support:"Votre explorateur ne prend pas en charge le tag vidéo.",
      unkown:"Inconnu",
      fail_play_media:"Impossible de lire le média.",
      error_play_media:"Une erreur s’est produite lors de la lecture du média.",
      wechat_name:"Cliquez pour obtenir le nom Wechat.",
      form_unavailable_h5:"Le contrôle de formulaire ne fonctionne qu’avec la mini-application Wechat, veuillez scanner à nouveau le code QR avec Wechat.",
      upload_video:"Télécharger une vidéo.",
      is_required:"est obligatoire.",
      cells_required:"Les cellules en surbrillance ne sont pas valides.",
      click_sign:"Cliquez pour signer",
      upload_picture:"Télécharger une photo",
      enter_number:"Entrez le numéro",
      enter_name:"Entrez le nom",
      enter_text:"Saisir du texte",
      enter_mobile:"Entrez dans le mobile",
      welcome_to_top_qr:"Bienvenue chez TOP QR",
      welcome_to_88E:"Bienvenue chez TOP QR",
      username_required:"Le nom d’utilisateur est obligatoire.",
      password_required:"Un mot de passe est requis.",
      signing_in:"Connexion",
      sign_in:"Connexion",
      please_login:"Veuillez vous connecter",
      invalid_user_or_password:"Nom d’utilisateur ou mot de passe non valide.",
      fail_login:"Impossible de se connecter.",
      enter_location:"Entrez l’emplacement",
      enter_id:"Entrez l’ID",
      enter_employee_number:"Entrez le numéro d’employé",
      male:"Mâle",
      female:"Femelle",
      upload_file:"Télécharger un fichier",
      pick_cascade_data:"Choisir des données en cascade",
      must_check_one_item:"Vous devez cocher au moins un élément.",
      record:"Enregistrer",
      pick_a_district:"Choisissez un quartier",
      enter_address:"Entrez l’adresse",
      serial_number:"Matricule",
      current_value:"Valeur",
      update_message:"Mis à jour par xxx à xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"La mini-application Wechat n’a pas pu être ouverte dans le navigateur. Veuillez scanner le code QR avec Wechat",
      select_language_title:"Ce code QR prend en charge les langues suivantes. Veuillez sélectionner une langue.", 
      geo_restricted:"Ce code QR ne peut être scanné que dans une zone restreinte."          
    }
  },
  ru: {
    message: {
      qr_redirect_url :"QR-код перенаправит на следующий URL, это может быть небезопасно:",
      user_or_guest :"QR-код функционирует по-разному в зависимости от личности сканера. Вы зарегистрированный пользователь или гость?",
      input_username :"Введите имя пользователя",
      input_password :"Введите пароль",
      login :"Логин",
      i_am_a_guest :"Я гость",
      loading_qr :"Загрузка QR-кода ...",
      invalid_qr :"Неверный QR-код",
      campaign_not_start :"Кампания QR-кодов не началась",
      campaign_end :"Кампания QR-кодов завершена",
      subscription_expired :"QR-код недоступен, потому что он находится под планом, срок действия которого истек.",
      max_scan_reached :"QR-код недоступен, потому что достигнуто максимальное сканирование, разрешенное для плана этого QR-кода.",
      password_protected :"QR-код защищен паролем, пожалуйста, подтвердите пароль",
      validate :"Обосновывать",
      pleasesave :"Динамический QR-код не работает до его сохранения. Если вы видите эту страницу, пожалуйста, сохраните ее.",
      invalid_password :"Неверный пароль",
      password_validation_error :"Произошла ошибка при проверке пароля.",
      invalid_username_password:"Неверное имя пользователя или пароль.",
      login_error :"Произошла ошибка при входе в систему.",
      scan_error :"Произошла ошибка при сканировании QR-кода.",
      powered_by_top_qr :"Работает на TOP QR",
      powered_by_88E :"Работает на TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Идти",
      invalid_operation:"Недопустимая операция.",
      submit_require_login:"Вы должны войти в систему, чтобы отправить данные.",
      submit_not_allowed:"Вам не разрешается предоставлять данные.",
      ok:"Хорошо",
      cancel:"Отмена",
      download_file:"Загружать",
      download_forbidden:"Запретный",
      phone_number_required:"Пустой номер телефона нельзя набирать.",
      email_required:"Адрес электронной почты обязателен.",
      email_copied:"Адрес электронной почты был скопирован.",
      navigation_disabled:"Навигация отключена.",
      audio_not_support:"Проводник не поддерживает тег audio.",
      video_not_support:"Ваш проводник не поддерживает тег видео.",
      unkown:"Неизвестный",
      fail_play_media:"Не удалось воспроизвести мультимедиа.",
      error_play_media:"Произошла ошибка при воспроизведении мультимедиа.",
      wechat_name:"Нажмите, чтобы получить название Wechat.",
      form_unavailable_h5:"Контроль формы работает только с мини-приложением Wechat, пожалуйста, отсканируйте QR-код еще раз с помощью Wechat.",
      upload_video:"Загрузите видео.",
      is_required:"обязательно.",
      cells_required:"Выделенные ячейки недопустимы.",
      click_sign:"Нажмите, чтобы подписаться",
      upload_picture:"Загрузить картинку",
      enter_number:"Введите номер",
      enter_name:"Введите имя",
      enter_text:"Введите текст",
      enter_mobile:"Введите мобильный",
      welcome_to_top_qr:"Добро пожаловать в TOP QR",
      welcome_to_88E:"Добро пожаловать в TOP QR",
      username_required:"Имя пользователя обязательно.",
      password_required:"Пароль обязателен.",
      signing_in:"Вход в систему",
      sign_in:"Войти",
      please_login:"Пожалуйста, войдите в систему",
      invalid_user_or_password:"Неверное имя пользователя или пароль.",
      fail_login:"Не удалось войти в систему.",
      enter_location:"Введите местоположение",
      enter_id:"Введите ID",
      enter_employee_number:"Введите номер сотрудника",
      male:"Мужской",
      female:"Женский",
      upload_file:"Загрузить файл",
      pick_cascade_data:"Выбор каскадных данных",
      must_check_one_item:"Необходимо проверить хотя бы один элемент.",
      record:"Запись",
      pick_a_district:"Выберите район",
      enter_address:"Введите адрес",
      serial_number:"Порядковый номер",
      current_value:"Ценность",
      update_message:"Обновлено xxx в xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Мини-приложение Wechat не может быть открыто в браузере. Пожалуйста, отсканируйте QR-код с помощью Wechat",
      select_language_title:"Этот QR-код поддерживает следующие языки. Пожалуйста, выберите язык.", 
      geo_restricted:"Этот QR-код можно отсканировать только в зоне ограниченного доступа."          
    }
  },
  ja: {
    message: {
      input_password :"パスワードを入力",
      login :"ログイン",
      i_am_a_guest :"私はゲストです",
      loading_qr :"QRコードを読み込んでいます...",
      invalid_qr :"無効なQRコード",
      campaign_not_start :"QRコードキャンペーンが開始されていない",
      campaign_end :"QRコードキャンペーンは終了しました",
      subscription_expired :"QRコードは有効期限が切れたプランの下にあるため、利用できません。",
      max_scan_reached :"このQRコードのプランで許可されている最大スキャン数に達したため、QRコードは使用できません。",
      password_protected :"QRコードはパスワードで保護されていますので、パスワードを検証してください",
      validate :"検証",
      pleasesave :"ダイナミックQRコードは、保存する前には機能しません。このページが表示された場合は、保存してください。",
      invalid_password :"無効なパスワード",
      password_validation_error :"パスワードの検証中にエラーが発生しました。",
      invalid_username_password:"ユーザー名またはパスワードが無効です。",
      login_error :"ログイン中にエラーが発生しました。",
      scan_error :"QRコードのスキャン中にエラーが発生しました。",
      powered_by_top_qr :"TOP QRを搭載",
      powered_by_88E :"TOP QRを搭載",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"行く",
      invalid_operation:"無効な操作です。",
      submit_require_login:"データを送信するにはログインする必要があります。",
      submit_not_allowed:"データの送信は許可されていません。",
      ok:"わかりました",
      cancel:"キャンセル",
      download_file:"ダウンロード",
      download_forbidden:"禁じられた",
      phone_number_required:"空の電話番号はダイヤルできません。",
      email_required:"メールアドレスは必須です。",
      email_copied:"メールアドレスがコピーされました",
      navigation_disabled:"ナビゲーションは無効です。",
      audio_not_support:"エクスプローラーはオーディオタグをサポートしていません。",
      video_not_support:"エクスプローラーが video タグをサポートしていません。",
      unkown:"不明",
      fail_play_media:"メディアの再生に失敗しました。",
      error_play_media:"メディアの再生中にエラーが発生しました。",
      wechat_name:"クリックしてWechat名を取得します。",
      form_unavailable_h5:"フォームコントロールはWechatミニアプリでのみ機能しますので、WechatでQRコードをもう一度スキャンしてください。",
      upload_video:"動画をアップロードします。",
      is_required:"は必須です。",
      cells_required:"強調表示されたセルは無効です。",
      click_sign:"クリックして署名",
      upload_picture:"画像をアップロード",
      enter_number:"番号を入力",
      enter_name:"名前を入力",
      enter_text:"テキストを入力",
      enter_mobile:"モバイルに入る",
      welcome_to_top_qr:"TOP QR へようこそ",
      welcome_to_88E:"TOP QR へようこそ",
      username_required:"ユーザー名は必須です。",
      password_required:"パスワードは必須です。",
      signing_in:"サインイン",
      sign_in:"サインイン",
      please_login:"ログインしてください",
      invalid_user_or_password:"ユーザー名またはパスワードが無効です。",
      fail_login:"ログインに失敗しました。",
      enter_location:"場所を入力",
      enter_id:"ID を入力",
      enter_employee_number:"従業員番号を入力",
      male:"男性",
      female:"女性",
      upload_file:"ファイルのアップロード",
      pick_cascade_data:"カスケードデータの選択",
      must_check_one_item:"少なくとも 1 つの項目をチェックする必要があります。",
      record:"記録",
      pick_a_district:"地区を選ぶ",
      enter_address:"住所を入力",
      serial_number:"シリアル番号",
      current_value:"価値",
      update_message:"によって更新されました xxx で xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechatミニアプリをブラウザで開くことができませんでした。微信でQRコードをスキャンしてください",
      select_language_title:"このQRコードは、次の言語をサポートしています。言語を選択してください。",  
      geo_restricted:"このQRコードは制限区域でのみスキャンできます。"         
    }
  },
  ko: {
    message: {
      qr_redirect_url :"QR 코드는 다음 URL로 리디렉션되며 안전하지 않을 수 있습니다.",
      user_or_guest :"QR 코드는 스캐너의 ID에 따라 다르게 작동합니다. 등록된 사용자입니까 아니면 게스트입니까?",
      input_username :"사용자 이름 입력",
      input_password :"비밀번호 입력",
      login :"로그인",
      i_am_a_guest :"게스트입니다.",
      loading_qr :"QR 코드로드 중 ...",
      invalid_qr :"유효하지 않은 QR 코드",
      campaign_not_start :"QR 코드 캠페인이 시작되지 않았습니다.",
      campaign_end :"QR 코드 캠페인이 종료되었습니다",
      subscription_expired :"QR 코드는 만료 된 요금제에 있으므로 사용할 수 없습니다.",
      max_scan_reached :"이 QR 코드의 계획에 허용되는 최대 스캔에 도달했기 때문에 QR 코드를 사용할 수 없습니다.",
      password_protected :"QR 코드는 비밀번호로 보호되어 있으므로 비밀번호를 확인하십시오.",
      validate :"확인",
      pleasesave :"동적 QR 코드는 저장되기 전에 작동하지 않습니다. 이 페이지가 보이면 저장하십시오.",
      invalid_password :"잘못된 암호",
      password_validation_error :"암호의 유효성을 검사하는 동안 오류가 발생했습니다.",
      invalid_username_password:"잘못된 사용자 이름 또는 암호입니다.",
      login_error :"로그인하는 동안 오류가 발생했습니다.",
      scan_error :"QR 코드를 스캔하는 동안 오류가 발생했습니다.",
      powered_by_top_qr :"TOP QR 로 구동",
      powered_by_88E :"TOP QR 로 구동",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"바둑",
      invalid_operation:"잘못된 작업입니다.",
      submit_require_login:"데이터를 제출하려면 로그인해야 합니다.",
      submit_not_allowed:"데이터를 제출할 수 없습니다.",
      ok:"그래",
      cancel:"취소",
      download_file:"다운로드",
      download_forbidden:"금지된",
      phone_number_required:"빈 전화 번호로 전화를 걸 수 없습니다.",
      email_required:"이메일 주소가 필요합니다.",
      email_copied:"이메일 주소가 복사되었습니다.",
      navigation_disabled:"탐색을 사용할 수 없습니다.",
      audio_not_support:"탐색기가 오디오 태그를 지원하지 않습니다.",
      video_not_support:"탐색기가 비디오 태그를 지원하지 않습니다.",
      unkown:"알려지지 않은",
      fail_play_media:"미디어를 재생하지 못했습니다.",
      error_play_media:"미디어를 재생하는 동안 오류가 발생했습니다.",
      wechat_name:"위챗 이름을 얻으려면 클릭하십시오.",
      form_unavailable_h5:"양식 제어는 위챗 미니 앱에서만 작동하므로 위챗으로 QR 코드를 다시 스캔하십시오.",
      upload_video:"동영상을 업로드합니다.",
      is_required:"필수입니다.",
      cells_required:"강조 표시된 셀은 유효하지 않습니다.",
      click_sign:"클릭하여 서명",
      upload_picture:"사진 업로드",
      enter_number:"번호 입력",
      enter_name:"이름 입력",
      enter_text:"텍스트 입력",
      enter_mobile:"모바일 진입",
      welcome_to_top_qr:"TOP QR 에 오신 것을 환영합니다",
      welcome_to_88E:"TOP QR 에 오신 것을 환영합니다",
      username_required:"사용자 이름은 필수입니다.",
      password_required:"비밀번호가 필요합니다.",
      signing_in:"로그인",
      sign_in:"서명하세요",
      please_login:"로그인하십시오",
      invalid_user_or_password:"잘못된 사용자 이름 또는 암호입니다.",
      fail_login:"로그인하지 못했습니다.",
      enter_location:"위치 입력",
      enter_id:"아이디 입력",
      enter_employee_number:"사원 번호 입력",
      male:"남성",
      female:"여성",
      upload_file:"파일 업로드",
      pick_cascade_data:"캐스케이드 데이터 선택",
      must_check_one_item:"하나 이상의 항목을 확인해야 합니다.",
      record:"기록",
      pick_a_district:"지구 선택",
      enter_address:"주소 입력",
      serial_number:"일련 번호",
      current_value:"값",
      update_message:"xxxx-xx-xx xx xx : xx에 의해 업데이트 됨",
      scan_with_wechat:"위챗 미니 앱을 브라우저에서 열 수 없습니다. 위챗으로 QR 코드를 스캔하세요",
      select_language_title:"이 QR 코드는 다음 언어를 지원합니다. 언어를 선택하십시오.",
      geo_restricted:"이 QR 코드는 제한 구역에서만 스캔할 수 있습니다."          
    }
  },
  ar: {
    message: {
      qr_redirect_url :"سيتم إعادة توجيه رمز الاستجابة السريعة إلى عنوان url التالي ، وقد لا يكون آمنا:",
      user_or_guest :"يعمل رمز الاستجابة السريعة بشكل مختلف وفقا لهوية الماسح الضوئي. هل أنت مستخدم مسجل أو ضيف؟",
      input_username :"أدخل اسم المستخدم",
      input_password :"أدخل كلمة المرور",
      login :"تسجيل الدخول",
      i_am_a_guest :"أنا ضيف",
      loading_qr :"جاري تحميل رمز الاستجابة السريعة ...",
      invalid_qr :"رمز الاستجابة السريعة غير صالح",
      campaign_not_start :"لم تبدأ حملة رمز الاستجابة السريعة",
      campaign_end :"انتهت حملة رمز الاستجابة السريعة",
      subscription_expired :"رمز الاستجابة السريعة غير متوفر ، لأنه يخضع لخطة انتهت صلاحيتها.",
      max_scan_reached :"رمز الاستجابة السريعة غير متوفر ، لأنه تم الوصول إلى الحد الأقصى المسموح به للمسح الضوئي لخطة رمز الاستجابة السريعة هذا.",
      password_protected :"رمز الاستجابة السريعة محمي بكلمة مرور ، يرجى التحقق من صحة كلمة المرور",
      validate :"التحقق",
      pleasesave :"لا يعمل رمز الاستجابة السريعة الديناميكي قبل حفظه. إذا رأيت هذه الصفحة ، يرجى حفظها.",
      invalid_password :"كلمة المرور غير صالحة",
      password_validation_error :"حدث خطأ أثناء التحقق من صحة كلمة المرور.",
      invalid_username_password:"اسم المستخدم أو كلمة المرور غير صالحة.",
      login_error :"حدث خطأ أثناء تسجيل الدخول.",
      scan_error :"حدث خطأ أثناء مسح رمز الاستجابة السريعة.",
      powered_by_top_qr :"مدعوم من TOP QR",
      powered_by_88E :"مدعوم من TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"ذهب",
      invalid_operation:"عملية غير صالحة.",
      submit_require_login:"أنت مطالب بتسجيل الدخول لإرسال البيانات.",
      submit_not_allowed:"لا يسمح لك بتقديم البيانات.",
      ok:"موافق",
      cancel:"إلغاء الأمر",
      download_file:"تحميل",
      download_forbidden:"ممنوع",
      phone_number_required:"لا يمكن طلب رقم الهاتف الفارغ.",
      email_required:"عنوان البريد الإلكتروني مطلوب.",
      email_copied:"تم نسخ عنوان البريد الإلكتروني.",
      navigation_disabled:"تم تعطيل التنقل.",
      audio_not_support:"لا يدعم المستكشف علامة الصوت.",
      video_not_support:"لا يدعم المستكشف علامة الفيديو.",
      unkown:"مجهول",
      fail_play_media:"فشل في تشغيل الوسائط.",
      error_play_media:"حدث خطأ أثناء تشغيل الوسائط.",
      wechat_name:"انقر للحصول على اسم Wechat.",
      form_unavailable_h5:"يعمل التحكم في النموذج فقط مع تطبيق Wechat المصغر ، يرجى مسح رمز الاستجابة السريعة ضوئيا مرة أخرى باستخدام Wechat.",
      upload_video:"تحميل الفيديو.",
      is_required:"مطلوب.",
      cells_required:"الخلايا المميزة غير صالحة.",
      click_sign:"انقر للتوقيع",
      upload_picture:"تحميل الصورة",
      enter_number:"أدخل الرقم",
      enter_name:"أدخل الاسم",
      enter_text:"أدخل النص",
      enter_mobile:"أدخل رقم الجوال",
      welcome_to_top_qr:"مرحبا بكم في TOP QR",
      welcome_to_88E:"مرحبا بكم في TOP QR",
      username_required:"اسم المستخدم مطلوب.",
      password_required:"كلمة المرور مطلوبة.",
      signing_in:"تسجيل الدخول",
      sign_in:"تسجيل الدخول",
      please_login:"يرجى تسجيل الدخول",
      invalid_user_or_password:"اسم المستخدم أو كلمة المرور غير صالحة.",
      fail_login:"فشل تسجيل الدخول.",
      enter_location:"أدخل الموقع",
      enter_id:"أدخل الرقم",
      enter_employee_number:"أدخل رقم الموظف",
      male:"ذكر",
      female:"أنثى",
      upload_file:"تحميل الملف",
      pick_cascade_data:"اختيار البيانات المتتالية",
      must_check_one_item:"يجب عليك التحقق من عنصر واحد على الأقل.",
      record:"سجل",
      pick_a_district:"اختر منطقة",
      enter_address:"أدخل العنوان",
      serial_number:"الرقم التسلسلي",
      current_value:"قيمة",
      update_message:"تم التحديث بواسطة xxx في xxxx-xx-xx xx: xx: xx",
      scan_with_wechat:"تعذر فتح تطبيق Wechat المصغر في المتصفح. يرجى مسح رمز الاستجابة السريعة ضوئيا باستخدام Wechat",
      select_language_title:"يدعم رمز الاستجابة السريعة هذا اللغات التالية. الرجاء اختيار لغة.",
      geo_restricted: "لا يمكن مسح رمز الاستجابة السريعة هذا إلا في منطقة محظورة."
      }
  },
  cs: {
    message: {
      qr_redirect_url :"QR kód přesměruje na následující adresu URL, nemusí být bezpečný:",
      user_or_guest :"QR kód funguje odlišně podle identity skeneru. Jste registrovaný uživatel nebo host?",
      input_username :"Zadejte uživatelské jméno",
      input_password :"Zadejte heslo",
      login :"Přihlášení do systému",
      i_am_a_guest :"Jsem host",
      loading_qr :"Načítání QR kódu ...",
      invalid_qr :"Neplatný QR kód",
      campaign_not_start :"Kampaň s QR kódy nebyla spuštěna",
      campaign_end :"Kampaň s QR kódem skončila",
      subscription_expired :"QR kód není k dispozici, protože se jedná o plán, jehož platnost vypršela.",
      max_scan_reached :"Kód QR není k dispozici, protože je dosaženo maximálního možného skenování pro plán tohoto kódu QR.",
      password_protected :"QR kód je chráněn heslem, ověřte heslo",
      validate :"Ověřit",
      pleasesave :"Dynamický kód QR před uložením nefunguje. Pokud uvidíte tuto stránku, uložte ji.",
      invalid_password :"Neplatné heslo",
      password_validation_error :"Při ověřování hesla došlo k chybě.",
      invalid_username_password:"Neplatné uživatelské jméno nebo heslo.",
      login_error :"Při protokolování došlo k chybě.",
      scan_error :"Při skenování kódu QR došlo k chybě.",
      powered_by_top_qr :"Běží na TOP QR",
      powered_by_88E :"Běží na TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Jít",
      invalid_operation:"Neplatná operace.",
      submit_require_login:"Chcete-li odeslat údaje, musíte se přihlásit.",
      submit_not_allowed:"Údaje odesílat nesmíte.",
      ok:"Ok",
      cancel:"Zrušit",
      download_file:"Stáhnout",
      download_forbidden:"Zakázaný",
      phone_number_required:"Prázdné telefonní číslo nelze vytočit.",
      email_required:"E-mailová adresa je povinná.",
      email_copied:"E-mailová adresa byla zkopírována.",
      navigation_disabled:"Navigace je zakázána.",
      audio_not_support:"Průzkumník nepodporuje zvukovou značku.",
      video_not_support:"Průzkumník nepodporuje značku videa.",
      unkown:"Neznámý",
      fail_play_media:"Přehrávání médií se nezdařilo.",
      error_play_media:"Při přehrávání médií došlo k chybě.",
      wechat_name:"Klikněte pro získání názvu Wechat.",
      form_unavailable_h5:"Ovládání formulářů funguje pouze s miniaplikací Wechat, naskenujte prosím QR kód znovu pomocí Wechatu.",
      upload_video:"Nahrajte video.",
      is_required:"je povinné.",
      cells_required:"Zvýrazněné buňky jsou neplatné.",
      click_sign:"Kliknutím se podepište",
      upload_picture:"Nahrát obrázek",
      enter_number:"Zadejte číslo",
      enter_name:"Zadejte název",
      enter_text:"Zadejte text",
      enter_mobile:"Zadejte mobilní zařízení",
      welcome_to_top_qr:"Vítejte v TOP QR",
      welcome_to_88E:"Vítejte v TOP QR",
      username_required:"Uživatelské jméno je povinné.",
      password_required:"Heslo je povinné.",
      signing_in:"Přihlášení",
      sign_in:"Přihlásit se",
      please_login:"Prosím přihlašte se",
      invalid_user_or_password:"Neplatné uživatelské jméno nebo heslo.",
      fail_login:"Nepodařilo se přihlásit.",
      enter_location:"Zadejte lokalitu",
      enter_id:"Zadejte ID",
      enter_employee_number:"Zadejte číslo zaměstnance",
      male:"Muž",
      female:"Ženský",
      upload_file:"Nahrát soubor",
      pick_cascade_data:"Výběr kaskádových dat",
      must_check_one_item:"Musíte zkontrolovat alespoň jednu položku.",
      record:"Záznam",
      pick_a_district:"Vyberte okres",
      enter_address:"Zadejte adresu",
      serial_number:"Sériové číslo",
      current_value:"Hodnota",
      update_message:"Aktualizováno uživatelem xxx v xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Miniaplikaci Wechat nelze otevřít v prohlížeči. Naskenujte QR kód pomocí Wechatu",
      select_language_title:"Tento QR kód podporuje následující jazyky. Vyberte prosím jazyk.", 
      geo_restricted:"Tento QR kód může být naskenován pouze v zakázané oblasti."                    
    }
  },
  da: {
    message: {
      qr_redirect_url :"QR-koden omdirigerer til følgende url, det er muligvis ikke sikkert:",
      user_or_guest :"QR-koden fungerer forskelligt alt efter scannerens identitet. Er du registreret bruger eller gæst?",
      input_username :"Indtast brugernavn",
      input_password :"Indtast adgangskode",
      login :"Login",
      i_am_a_guest :"Jeg er gæst",
      loading_qr :"Indlæser QR-kode ...",
      invalid_qr :"Ugyldig QR-kode",
      campaign_not_start :"QR-kodekampagnen er ikke startet",
      campaign_end :"QR-kodekampagnen er afsluttet",
      subscription_expired :"QR-koden er ikke tilgængelig, fordi den er under en plan, der er udløbet.",
      max_scan_reached :"QR-koden er ikke tilgængelig, fordi maksimal scanning tilladt for planen for denne QR-kode er nået.",
      password_protected :"QR-koden er beskyttet med adgangskode, valider venligst adgangskoden",
      validate :"Bekræfte",
      pleasesave :"Dynamisk QR-kode fungerer ikke, før den gemmes. Hvis du ser denne side, skal du gemme den.",
      invalid_password :"Ugyldig adgangskode",
      password_validation_error :"Der opstod en fejl under validering af adgangskode.",
      invalid_username_password:"Ugyldigt brugernavn eller adgangskode.",
      login_error :"Der opstod en fejl under login.",
      scan_error :"Der opstod en fejl under scanning af QR-kode.",
      powered_by_top_qr :"Drevet af TOP QR",
      powered_by_88E :"Drevet af TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Gå",
      invalid_operation:"Ugyldig handling.",
      submit_require_login:"Du skal logge ind for at indsende data.",
      submit_not_allowed:"Du har ikke tilladelse til at indsende data.",
      ok:"Ok",
      cancel:"Aflyse",
      download_file:"Downloade",
      download_forbidden:"Forbudt",
      phone_number_required:"Tomt telefonnummer kan ikke ringes op.",
      email_required:"E-mail-adresse er påkrævet.",
      email_copied:"E-mail-adressen blev kopieret.",
      navigation_disabled:"Navigation er deaktiveret.",
      audio_not_support:"Din opdagelsesrejsende understøtter ikke lydtag.",
      video_not_support:"Din opdagelsesrejsende understøtter ikke videotag.",
      unkown:"Ukendt",
      fail_play_media:"Kunne ikke afspille medier.",
      error_play_media:"Der opstod en fejl under afspilning af medier.",
      wechat_name:"Klik for at få Wechat-navn.",
      form_unavailable_h5:"Formularkontrol fungerer kun med Wechat miniapp, scan QR-koden igen med Wechat.",
      upload_video:"Upload video.",
      is_required:"er påkrævet.",
      cells_required:"Fremhævede celler er ugyldige.",
      click_sign:"Klik for at underskrive",
      upload_picture:"Upload billede",
      enter_number:"Indtast nummer",
      enter_name:"Indtast navn",
      enter_text:"Indtast tekst",
      enter_mobile:"Indtast mobil",
      welcome_to_top_qr:"Velkommen til TOP QR",
      welcome_to_88E:"Velkommen til TOP QR",
      username_required:"Brugernavn er påkrævet.",
      password_required:"Adgangskode er påkrævet.",
      signing_in:"Log ind",
      sign_in:"Log på",
      please_login:"Log venligst ind",
      invalid_user_or_password:"Ugyldigt brugernavn eller adgangskode.",
      fail_login:"Logget kunne ikke logge ind.",
      enter_location:"Indtast placering",
      enter_id:"Indtast ID",
      enter_employee_number:"Indtast medarbejdernummer",
      male:"Mandlig",
      female:"Kvindelig",
      upload_file:"Upload fil",
      pick_cascade_data:"Vælg kaskadedata",
      must_check_one_item:"Du skal kontrollere mindst et element.",
      record:"Rekord",
      pick_a_district:"Vælg et distrikt",
      enter_address:"Indtast adresse",
      serial_number:"Serienummer",
      current_value:"Værdi",
      update_message:"Opdateret af xxx på xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp kunne ikke åbnes i browseren. Scan QR-koden med Wechat",
      select_language_title:"Denne QR-kode understøtter følgende sprog. Vælg et sprog.", 
      geo_restricted:"Denne QR-kode kan kun scannes i begrænset område."                         
    }
  },
  el: {
    message: {
      qr_redirect_url :"Ο κωδικός QR θα ανακατευθύνει στην ακόλουθη διεύθυνση URL, ενδέχεται να μην είναι ασφαλής:",
      user_or_guest :"Ο κωδικός QR λειτουργεί διαφορετικά ανάλογα με την ταυτότητα του σαρωτή. Είστε εγγεγραμμένος χρήστης ή επισκέπτης;",
      input_username :"Εισαγωγή ονόματος χρήστη",
      input_password :"Εισαγωγή κωδικού πρόσβασης",
      login :"Σύνδεση",
      i_am_a_guest :"Είμαι επισκέπτης",
      loading_qr :"Φόρτωση κωδικού QR ...",
      invalid_qr :"Μη έγκυρος κωδικός QR",
      campaign_not_start :"Η καμπάνια με κωδικό QR δεν έχει ξεκινήσει",
      campaign_end :"Η καμπάνια με κωδικό QR έχει λήξει",
      subscription_expired :"Ο κωδικός QR δεν είναι διαθέσιμος, επειδή βρίσκεται κάτω από ένα σχέδιο που έχει λήξει.",
      max_scan_reached :"Ο κωδικός QR δεν είναι διαθέσιμος, επειδή επιτυγχάνεται η μέγιστη σάρωση που επιτρέπεται για το σχέδιο αυτού του κωδικού QR.",
      password_protected :"Ο κωδικός QR προστατεύεται με κωδικό πρόσβασης, επικυρώστε τον κωδικό πρόσβασης",
      validate :"Επικυρώνω",
      pleasesave :"Ο δυναμικός κωδικός QR δεν λειτουργεί πριν αποθηκευτεί. Αν δείτε αυτή τη σελίδα, αποθηκεύστε την.",
      invalid_password :"Μη έγκυρος κωδικός πρόσβασης",
      password_validation_error :"Παρουσιάστηκε σφάλμα κατά την επικύρωση του κωδικού πρόσβασης.",
      invalid_username_password:"Μη έγκυρο όνομα χρήστη ή κωδικός πρόσβασης.",
      login_error :"Παρουσιάστηκε σφάλμα κατά τη σύνδεση.",
      scan_error :"Παρουσιάστηκε σφάλμα κατά τη σάρωση του κωδικού QR.",
      powered_by_top_qr :"Με την υποστήριξη του TOP QR",
      powered_by_88E :"Με την υποστήριξη του TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Πηγαίνω",
      invalid_operation:"Μη έγκυρη λειτουργία.",
      submit_require_login:"Πρέπει να συνδεθείτε για να υποβάλετε δεδομένα.",
      submit_not_allowed:"Δεν επιτρέπεται η υποβολή δεδομένων.",
      ok:"Ok",
      cancel:"Ακυρώνω",
      download_file:"Καταφόρτωση",
      download_forbidden:"Απαγορευμένος",
      phone_number_required:"Δεν είναι δυνατή η κλήση κενού αριθμού τηλεφώνου.",
      email_required:"Η διεύθυνση ηλεκτρονικού ταχυδρομείου είναι υποχρεωτική.",
      email_copied:"Η διεύθυνση ηλεκτρονικού ταχυδρομείου αντιγράφηκε.",
      navigation_disabled:"Η πλοήγηση είναι απενεργοποιημένη.",
      audio_not_support:"Ο εξερευνητής σας δεν υποστηρίζει ετικέτα ήχου.",
      video_not_support:"Ο εξερευνητής σας δεν υποστηρίζει ετικέτα βίντεο.",
      unkown:"Άγνωστος",
      fail_play_media:"Αποτυχία αναπαραγωγής πολυμέσων.",
      error_play_media:"Παρουσιάστηκε σφάλμα κατά την αναπαραγωγή πολυμέσων.",
      wechat_name:"Κάντε κλικ για να λάβετε το όνομα Wechat.",
      form_unavailable_h5:"Ο έλεγχος φόρμας λειτουργεί μόνο με τη μίνι εφαρμογή Wechat, σαρώστε ξανά τον κωδικό QR με το Wechat.",
      upload_video:"Ανεβάστε βίντεο.",
      is_required:"απαιτείται.",
      cells_required:"Τα επισημασμένα κελιά δεν είναι έγκυρα.",
      click_sign:"Κάντε κλικ για να υπογράψετε",
      upload_picture:"Ανεβάστε εικόνα",
      enter_number:"Εισαγωγή αριθμού",
      enter_name:"Εισαγωγή ονόματος",
      enter_text:"Εισαγωγή κειμένου",
      enter_mobile:"Είσοδος στο κινητό",
      welcome_to_top_qr:"Καλώς ήρθατε στο TOP QR",
      welcome_to_88E:"Καλώς ήρθατε στο TOP QR",
      username_required:"Το όνομα χρήστη είναι υποχρεωτικό.",
      password_required:"Απαιτείται κωδικός πρόσβασης.",
      signing_in:"Σύνδεση",
      sign_in:"Είσοδος",
      please_login:"Παρακαλώ συνδεθείτε",
      invalid_user_or_password:"Μη έγκυρο όνομα χρήστη ή κωδικός πρόσβασης.",
      fail_login:"Αποτυχία σύνδεσης.",
      enter_location:"Εισαγωγή τοποθεσίας",
      enter_id:"Εισαγωγή αναγνωριστικού",
      enter_employee_number:"Εισαγωγή αριθμού υπαλλήλου",
      male:"Αρσενικός",
      female:"Θηλυκός",
      upload_file:"Μεταφόρτωση αρχείου",
      pick_cascade_data:"Επιλογή διαδοχικών δεδομένων",
      must_check_one_item:"Πρέπει να ελέγξετε τουλάχιστον ένα στοιχείο.",
      record:"Καταγράφω",
      pick_a_district:"Επιλέξτε μια περιοχή",
      enter_address:"Εισαγωγή διεύθυνσης",
      serial_number:"Αύξων αριθμός",
      current_value:"Τιμή",
      update_message:"Ενημερώθηκε από xxx στις xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Δεν ήταν δυνατό το άνοιγμα της μίνι εφαρμογής Wechat στο πρόγραμμα περιήγησης. Σαρώστε τον κωδικό QR με το Wechat",
      select_language_title:"Αυτός ο κωδικός QR υποστηρίζει τις ακόλουθες γλώσσες. Επιλέξτε μια γλώσσα.", 
      geo_restricted:"Αυτός ο κωδικός QR μπορεί να σαρωθεί μόνο σε περιορισμένη περιοχή."                              
    }
  },
  fa: {
    message: {
      qr_redirect_url :"کد QR به آدرس زیر تغییر مسیر خواهد داد، ممکن است امن ن باشد:",
      user_or_guest :"کد QR با توجه به هویت اسکنر متفاوت عمل می کند. آیا شما یک کاربر ثبت نام شده یا مهمان هستید؟",
      input_username :"نام کاربری را وارد کنید",
      input_password :"رمز عبور را وارد کنید",
      login :"ورود",
      i_am_a_guest :"من مهمان هستم",
      loading_qr :"بارگذاری کد QR ...",
      invalid_qr :"کد QR نامعتبر",
      campaign_not_start :"کمپین کد QR آغاز نشده است",
      campaign_end :"کمپین کد QR به پایان رسیده است",
      subscription_expired :"کد QR در دسترس نیست، زیرا تحت طرحی است که منقضی شده است.",
      max_scan_reached :"کد QR در دسترس نیست، زیرا حداکثر اسکن مجاز برای طرح این کد QR رسیده است.",
      password_protected :"کد QR رمز عبور محافظت شده است، لطفا اعتبار رمز عبور",
      validate :"اعتبار",
      pleasesave :"کد QR پویا قبل از ذخیره کار نمی کند. اگر این صفحه را مشاهده می کنید، لطفا آن را ذخیره کنید.",
      invalid_password :"رمز عبور نامعتبر",
      password_validation_error :"خطایی هنگام اعتبار بخشیدن به رمز عبور رخ داد.",
      invalid_username_password:"نام کاربری یا رمز عبور نامعتبر.",
      login_error :"خطایی هنگام ورود رخ داد.",
      scan_error :"خطایی هنگام اسکن کد QR رخ داد.",
      powered_by_top_qr :"شده توسط TOP QR",
      powered_by_88E :"شده توسط TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"رفتن",
      invalid_operation:"عمليات نامعتبر .",
      submit_require_login:"شما ملزم به ورود به سیستم برای ارسال داده ها هستید.",
      submit_not_allowed:"شما اجازه ارسال داده ها را داري.",
      ok:"باشه",
      cancel:"لغو",
      download_file:"دانلود",
      download_forbidden:"ممنوع",
      phone_number_required:"شماره تلفن خالی قابل شماره گیری نیست.",
      email_required:"آدرس ایمیل مورد نیاز است.",
      email_copied:"آدرس ایمیل کپی شد.",
      navigation_disabled:"ناوبری غیر فعال است.",
      audio_not_support:"کاوشگر شما از تگ صوتی پشتیبانی نمی کند.",
      video_not_support:"کاوشگر شما از تگ تصویری پشتیبانی نمی کند.",
      unkown:"ناشناخته",
      fail_play_media:"موفق به بازی رسانه ای نشد.",
      error_play_media:"خطایی هنگام پخش رسانه ها رخ داد.",
      wechat_name:"برای دریافت نام ویچت کلیک کنید.",
      form_unavailable_h5:"کنترل فرم کار می کند تنها با مینی اپ ویچت، لطفا اسکن کد QR دوباره با ویچت.",
      upload_video:"آپلود ویدیو.",
      is_required:"مورد نیاز است.",
      cells_required:"سلول های برجسته نامعتبر هستند.",
      click_sign:"برای امضا کلیک کنید",
      upload_picture:"آپلود تصویر",
      enter_number:"شماره را وارد کنید",
      enter_name:"نام را وارد کنید",
      enter_text:"متن را وارد کنید",
      enter_mobile:"موبایل را وارد کنید",
      welcome_to_top_qr:"خوش آمدید به TOP QR",
      welcome_to_88E:"خوش آمدید به TOP QR",
      username_required:"نام کاربری مورد نیاز است.",
      password_required:"رمز عبور مورد نیاز است.",
      signing_in:"ورود به",
      sign_in:"ورود به برنامه",
      please_login:"لطفا وارد شوید",
      invalid_user_or_password:"نام کاربری یا رمز عبور نامعتبر.",
      fail_login:"موفق به ورود نشد.",
      enter_location:"مکان را وارد کنید",
      enter_id:"شناسه را وارد کنید",
      enter_employee_number:"شماره کارمند را وارد کنید",
      male:"مرد",
      female:"زن",
      upload_file:"آپلود فایل",
      pick_cascade_data:"انتخاب داده های آبشار",
      must_check_one_item:"شما باید حداقل یک مورد را بررسی کنید.",
      record:"رکورد",
      pick_a_district:"انتخاب یک منطقه",
      enter_address:"آدرس را وارد کنید",
      serial_number:"شماره سریال",
      current_value:"ارزش",
      update_message:"به روز شده توسط xxx در xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"مینی اپ ویچت را نمی توان در مرورگر باز کرد. لطفا کد QR را با ویچت اسکن کنید",
      select_language_title:"این کد QR از زبان های زیر پشتیبانی می کند. لطفا یک زبان را انتخاب کنید.",
      geo_restricted: "این کد QR تنها می تواند در منطقه محدود اسکن شود."                                    
    }
  },
  fi: {
    message: {
      qr_redirect_url :"QR-koodi ohjaa seuraavaan URL-osoitteeseen, se ei ehkä ole turvallista:",
      user_or_guest :"QR-koodi toimii eri tavalla skannerin identiteetin mukaan. Oletko rekisteröitynyt käyttäjä tai vieras?",
      input_username :"Anna käyttäjänimi",
      input_password :"Anna salasana",
      login :"Sisäänkirjautuminen",
      i_am_a_guest :"Olen vieras",
      loading_qr :"Ladataan QR-koodia ...",
      invalid_qr :"Virheellinen QR-koodi",
      campaign_not_start :"QR-koodikampanja ei ole alkanut",
      campaign_end :"QR-koodikampanja on päättynyt",
      subscription_expired :"QR-koodi ei ole käytettävissä, koska se on vanhentunut suunnitelma.",
      max_scan_reached :"QR-koodi ei ole käytettävissä, koska tämän QR-koodin suunnitelman suurin sallittu skannaus saavutetaan.",
      password_protected :"QR-koodi on suojattu salasanalla, vahvista salasana",
      validate :"Vahvistaa",
      pleasesave :"Dynaaminen QR-koodi ei toimi ennen kuin se on tallennettu. Jos näet tämän sivun, tallenna se.",
      invalid_password :"Virheellinen salasana",
      password_validation_error :"Salasanan vahvistamisessa tapahtui virhe.",
      invalid_username_password:"Virheellinen käyttäjätunnus tai salasana.",
      login_error :"Loggingin aikana tapahtui virhe.",
      scan_error :"QR-koodin skannauksen aikana tapahtui virhe.",
      powered_by_top_qr :"Powered by TOP QR",
      powered_by_88E :"Powered by TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Mennä",
      invalid_operation:"Virheellinen toiminto.",
      submit_require_login:"Sinun on kirjauduttava sisään lähettääksesi tietoja.",
      submit_not_allowed:"Et saa lähettää tietoja.",
      ok:"Okei",
      cancel:"Perua",
      download_file:"Ladata",
      download_forbidden:"Kielletty",
      phone_number_required:"Tyhjää puhelinnumeroa ei voi valita.",
      email_required:"Sähköpostiosoite on pakollinen.",
      email_copied:"Sähköpostiosoite kopioitiin.",
      navigation_disabled:"Navigointi on poistettu käytöstä.",
      audio_not_support:"Tutkimusmatkailijasi ei tue äänitunnistetta.",
      video_not_support:"Tutkimusmatkailijasi ei tue videotunnistetta.",
      unkown:"Tuntematon",
      fail_play_media:"Median toistaminen epäonnistui.",
      error_play_media:"Mediaa toistettaessa tapahtui virhe.",
      wechat_name:"Napsauta saadaksesi Wechat-nimen.",
      form_unavailable_h5:"Lomakkeen hallinta toimii vain Wechat-minisovelluksen kanssa, skannaa QR-koodi uudelleen Wechatilla.",
      upload_video:"Lataa video.",
      is_required:"on pakollinen.",
      cells_required:"Korostetut solut ovat virheellisiä.",
      click_sign:"Allekirjoita napsauttamalla",
      upload_picture:"Lataa kuva",
      enter_number:"Syötä numero",
      enter_name:"Kirjoita nimi",
      enter_text:"Kirjoita teksti",
      enter_mobile:"Siirry matkapuhelimeen",
      welcome_to_top_qr:"Tervetuloa TOP QR:ään",
      welcome_to_88E:"Tervetuloa TOP QR:ään",
      username_required:"Käyttäjänimi on pakollinen.",
      password_required:"Salasana vaaditaan.",
      signing_in:"Kirjautuminen",
      sign_in:"Kirjaudu sisään",
      please_login:"Ole hyvä ja kirjaudu sisään",
      invalid_user_or_password:"Virheellinen käyttäjätunnus tai salasana.",
      fail_login:"Kirjautuminen epäonnistui.",
      enter_location:"Anna sijainti",
      enter_id:"Anna tunnus",
      enter_employee_number:"Anna työntekijän numero",
      male:"Mies",
      female:"Naispuolinen",
      upload_file:"Lataa tiedosto",
      pick_cascade_data:"Valitse kaskaditiedot",
      must_check_one_item:"Sinun on tarkistettava vähintään yksi kohde.",
      record:"Ennätys",
      pick_a_district:"Valitse piiri",
      enter_address:"Anna osoite",
      serial_number:"Sarjanumero",
      current_value:"Arvo",
      update_message:"Päivitetty xxx osoitteessa xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniappia ei voitu avata selaimessa. Skannaa QR-koodi Wechatilla",
      select_language_title:"Tämä QR-koodi tukee seuraavia kieliä. Valitse kieli.", 
      geo_restricted:"Tämä QR-koodi voidaan skannata vain rajoitetulla alueella."                                        
    }
  },
  hi: {
    message: {
      qr_redirect_url :"QR कोड निम्न URL पर रीडायरेक्ट हो जाएगा, यह सुरक्षित नहीं हो सकता है:",
      user_or_guest :"क्यूआर कोड स्कैनर की पहचान के अनुसार अलग-अलग काम करता है। क्या आप एक पंजीकृत उपयोगकर्ता या अतिथि हैं?",
      input_username :"उपयोगकर्ता नाम दर्ज करें",
      input_password :"पासवर्ड दर्ज करें",
      login :"लॉगिन",
      i_am_a_guest :"मैं एक मेहमान हूँ",
      loading_qr :"क्यूआर कोड लोड कर रहा है ...",
      invalid_qr :"अमान्य QR कोड",
      campaign_not_start :"QR कोड अभियान शुरू नहीं हुआ है",
      campaign_end :"QR कोड अभियान समाप्त हो गया है",
      subscription_expired :"QR कोड अनुपलब्ध है, क्योंकि यह एक योजना के तहत है जिसकी समय सीमा समाप्त हो गई है।",
      max_scan_reached :"QR कोड अनुपलब्ध है, क्योंकि इस QR कोड की योजना के लिए अनुमत अधिकतम स्कैन पहुँच गया है.",
      password_protected :"QR कोड पासवर्ड सुरक्षित है, कृपया पासवर्ड मान्य करें",
      validate :"मान्य",
      pleasesave :"डायनेमिक QR कोड सहेजे जाने से पहले काम नहीं करता है. यदि आप इस पृष्ठ को देखते हैं, तो कृपया इसे सहेजें।",
      invalid_password :"अमान्य पासवर्ड",
      password_validation_error :"पासवर्ड मान्य करते समय कोई त्रुटि उत्पन्न हुई.",
      invalid_username_password:"अमान्य उपयोगकर्ता नाम या पासवर्ड.",
      login_error :"लॉगिन करते समय कोई त्रुटि उत्पन्न हुई.",
      scan_error :"QR कोड स्कैन करते समय कोई त्रुटि उत्पन्न हुई.",
      powered_by_top_qr :"TOP QR द्वारा संचालित",
      powered_by_88E :"TOP QR द्वारा संचालित",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"जा",
      invalid_operation:"अमान्य कार्रवाई.",
      submit_require_login:"डेटा सबमिट करने के लिए आपको लॉगिन करना होगा।",
      submit_not_allowed:"आपको डेटा सबमिट करने की अनुमति नहीं है.",
      ok:"ठीक है",
      cancel:"रद्द करना",
      download_file:"डाउनलोड",
      download_forbidden:"वर्जित",
      phone_number_required:"खाली फ़ोन नंबर डायल नहीं किया जा सकता.",
      email_required:"ईमेल पता आवश्यक है।",
      email_copied:"ईमेल पते की प्रतिलिपि बनाई गई थी.",
      navigation_disabled:"नेविगेशन अक्षम किया गया है.",
      audio_not_support:"आपका एक्सप्लोरर ऑडियो टैग का समर्थन नहीं करता है।",
      video_not_support:"आपका एक्सप्लोरर वीडियो टैग का समर्थन नहीं करता है.",
      unkown:"अज्ञात",
      fail_play_media:"मीडिया खेलने में विफल रहा।",
      error_play_media:"मीडिया चलाते समय कोई त्रुटि उत्पन्न हुई.",
      wechat_name:"Wechat नाम प्राप्त करने के लिए क्लिक करें.",
      form_unavailable_h5:"फॉर्म नियंत्रण केवल वीचैट मिनिआप के साथ काम करता है, कृपया वेचैट के साथ क्यूआर कोड को फिर से स्कैन करें।",
      upload_video:"वीडियो अपलोड करें.",
      is_required:"आवश्यक है.",
      cells_required:"हाइलाइट किए गए कक्ष अमान्य हैं.",
      click_sign:"हस्ताक्षर करने के लिए क्लिक करें",
      upload_picture:"चित्र अपलोड करें",
      enter_number:"नंबर दर्ज करें",
      enter_name:"नाम दर्ज करें",
      enter_text:"पाठ दर्ज करें",
      enter_mobile:"मोबाइल दर्ज करें",
      welcome_to_top_qr:"TOP QR में आपका स्वागत है",
      welcome_to_88E:"TOP QR में आपका स्वागत है",
      username_required:"उपयोगकर्ता नाम आवश्यक है।",
      password_required:"पासवर्ड आवश्यक है.",
      signing_in:"साइन इन करें",
      sign_in:"साइन इन करें",
      please_login:"कृपया लॉगिन करें",
      invalid_user_or_password:"अमान्य उपयोगकर्ता नाम या पासवर्ड.",
      fail_login:"लॉगिन करने में विफल.",
      enter_location:"स्थान दर्ज करें",
      enter_id:"ID दर्ज करें",
      enter_employee_number:"कर्मचारी नंबर दर्ज करें",
      male:"नर",
      female:"मादा",
      upload_file:"फ़ाइल अपलोड करें",
      pick_cascade_data:"कैस्केड डेटा चुनें",
      must_check_one_item:"आपको कम से कम एक आइटम की जाँच करनी होगी.",
      record:"रिकॉर्ड",
      pick_a_district:"एक जिला चुनें",
      enter_address:"पता दर्ज करें",
      serial_number:"सीरियल नंबर",
      current_value:"मूल्य",
      update_message:"xxxx-xx-xx xx:xx:xx पर XXX द्वारा अद्यतन",
      scan_with_wechat:"वेचैट मिनिआप्प ब्राउज़र में नहीं खोला जा सका. कृपया QR कोड को Wechat के साथ स्कैन करें",
      select_language_title:"यह QR कोड निम्नलिखित भाषाओं का समर्थन करता है। कृपया किसी भाषा का चयन करें.", 
      geo_restricted:"इस क्यूआर कोड को केवल प्रतिबंधित क्षेत्र में स्कैन किया जा सकता है"                                             
    }
  },
  hu: {
    message: {
      qr_redirect_url :"A QR-kód átirányít a következő URL-re, előfordulhat, hogy nem biztonságos:",
      user_or_guest :"A QR-kód a szkenner személyazonosságától függően eltérően működik. Ön regisztrált felhasználó vagy vendég?",
      input_username :"Adja meg a felhasználónevet",
      input_password :"Jelszó megadása",
      login :"Bejelentkezés",
      i_am_a_guest :"Vendég vagyok",
      loading_qr :"QR-kód betöltése ...",
      invalid_qr :"Érvénytelen QR-kód",
      campaign_not_start :"A QR-kód kampány még nem indult el",
      campaign_end :"A QR-kód kampány véget ért",
      subscription_expired :"A QR-kód nem érhető el, mert lejárt terv alatt áll.",
      max_scan_reached :"A QR-kód nem érhető el, mert a QR-kód tervéhez megengedett maximális beolvasás elérhető.",
      password_protected :"A QR-kód jelszóval védett, kérjük, érvényesítse a jelszót",
      validate :"Érvényesít",
      pleasesave :"A dinamikus QR-kód nem működik a mentés előtt. Ha látja ezt az oldalt, kérjük, mentse el.",
      invalid_password :"Érvénytelen jelszó",
      password_validation_error :"Hiba történt a jelszó érvényesítésekor.",
      invalid_username_password:"Érvénytelen felhasználónév vagy jelszó.",
      login_error :"Hiba történt bejelentkezés közben.",
      scan_error :"Hiba történt a QR-kód beolvasása közben.",
      powered_by_top_qr :"A TOP QR-rel működik",
      powered_by_88E :"A TOP QR-rel működik",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Megy",
      invalid_operation:"Érvénytelen művelet.",
      submit_require_login:"Az adatok elküldéséhez be kell jelentkeznie.",
      submit_not_allowed:"Ön nem küldhet be adatokat.",
      ok:"Oké",
      cancel:"Érvénytelenít",
      download_file:"Letöltés",
      download_forbidden:"Tiltott",
      phone_number_required:"Az üres telefonszámot nem lehet tárcsázni.",
      email_required:"Az e-mail cím megadása kötelező.",
      email_copied:"Az e-mail címet lemásolták.",
      navigation_disabled:"A navigáció le van tiltva.",
      audio_not_support:"A felfedező nem támogatja a hangcímkét.",
      video_not_support:"A felfedező nem támogatja a videocímkét.",
      unkown:"Ismeretlen",
      fail_play_media:"Nem sikerült lejátszani a médiát.",
      error_play_media:"Hiba történt a média lejátszása közben.",
      wechat_name:"Kattintson a Wechat név megszerzéséhez.",
      form_unavailable_h5:"Az űrlapvezérlés csak a Wechat minialkalmazással működik, kérjük, olvassa be újra a QR-kódot a Wechat segítségével.",
      upload_video:"Videó feltöltése.",
      is_required:"kötelező.",
      cells_required:"A kiemelt cellák érvénytelenek.",
      click_sign:"Kattintson az aláíráshoz",
      upload_picture:"Kép feltöltése",
      enter_number:"Írja be a számot",
      enter_name:"Név beírása",
      enter_text:"Szöveg beírása",
      enter_mobile:"Lépjen be a mobilba",
      welcome_to_top_qr:"Üdvözöljük a TOP QR-ben",
      welcome_to_88E:"Üdvözöljük a TOP QR-ben",
      username_required:"A felhasználónév megadása kötelező.",
      password_required:"Jelszó megadása kötelező.",
      signing_in:"Bejelentkezés",
      sign_in:"Bejelentkezés",
      please_login:"Kérjük, jelentkezzen be",
      invalid_user_or_password:"Érvénytelen felhasználónév vagy jelszó.",
      fail_login:"Nem sikerült bejelentkezni.",
      enter_location:"Adja meg a helyet",
      enter_id:"Adja meg az azonosítót",
      enter_employee_number:"Adja meg az alkalmazott számát",
      male:"Férfi",
      female:"Nőstény",
      upload_file:"Fájl feltöltése",
      pick_cascade_data:"Kaszkádadatok kiválasztása",
      must_check_one_item:"Legalább egy elemet ellenőriznie kell.",
      record:"Rekord",
      pick_a_district:"Válasszon egy kerületet",
      enter_address:"Adja meg a címet",
      serial_number:"Sorozatszám",
      current_value:"Érték",
      update_message:"Frissítve: xxx at xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"A Wechat miniapp nem nyitható meg böngészőben. Kérjük, olvassa be a QR-kódot a Wechat segítségével",
      select_language_title:"Ez a QR-kód támogatja a következő nyelveket. Kérjük, válasszon nyelvet.",
      geo_restricted:"Ezt a QR-kódot csak korlátozott területen lehet beolvasni."                                                   
    }
  },
  it: {
    message: {
      qr_redirect_url :"Il codice QR reindirizzerà al seguente URL, potrebbe non essere sicuro:",
      user_or_guest :"Il codice QR funziona in modo diverso in base all'identità dello scanner. Sei un utente registrato o un ospite?",
      input_username :"Inserisci il nome utente",
      input_password :"Inserisci la password",
      login :"Accesso",
      i_am_a_guest :"Sono un ospite",
      loading_qr :"Caricamento codice QR ...",
      invalid_qr :"Codice QR non valido",
      campaign_not_start :"La campagna QR code non è ancora iniziata",
      campaign_end :"La campagna QR code è terminata",
      subscription_expired :"Il codice QR non è disponibile, perché è sotto un piano che è scaduto.",
      max_scan_reached :"Il codice QR non è disponibile, perché viene raggiunta la scansione massima consentita per il piano di questo codice QR.",
      password_protected :"Il codice QR è protetto da password, si prega di convalidare la password",
      validate :"Convalidare",
      pleasesave :"Il codice QR dinamico non funziona prima di essere salvato. Se vedi questa pagina, per favore salvala.",
      invalid_password :"Password non valida",
      password_validation_error :"Si è verificato un errore durante la convalida della password.",
      invalid_username_password:"Nome utente o password non validi.",
      login_error :"Si è verificato un errore durante l'accesso.",
      scan_error :"Si è verificato un errore durante la scansione del codice QR.",
      powered_by_top_qr :"Realizzato da TOP QR",
      powered_by_88E :"Realizzato da TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Andare",
      invalid_operation:"Operazione non valida.",
      submit_require_login:"È necessario effettuare il login per inviare i dati.",
      submit_not_allowed:"Non è consentito inviare dati.",
      ok:"Ok",
      cancel:"Annulla",
      download_file:"Scaricare",
      download_forbidden:"Vietato",
      phone_number_required:"Il numero di telefono vuoto non può essere composto.",
      email_required:"L'indirizzo e-mail è obbligatorio.",
      email_copied:"L'indirizzo e-mail è stato copiato.",
      navigation_disabled:"La navigazione è disabilitata.",
      audio_not_support:"Explorer non supporta i tag audio.",
      video_not_support:"Esplora risorse non supporta i tag video.",
      unkown:"Sconosciuto",
      fail_play_media:"Impossibile riprodurre file multimediali.",
      error_play_media:"Si è verificato un errore durante la riproduzione di file multimediali.",
      wechat_name:"Fai clic per ottenere il nome Wechat.",
      form_unavailable_h5:"Il controllo del modulo funziona solo con la miniapp Wechat, scansiona nuovamente il codice QR con Wechat.",
      upload_video:"Carica video.",
      is_required:"è obbligatorio.",
      cells_required:"Le celle evidenziate non sono valide.",
      click_sign:"Clicca per firmare",
      upload_picture:"Carica foto",
      enter_number:"Inserisci il numero",
      enter_name:"Inserisci il nome",
      enter_text:"Inserisci testo",
      enter_mobile:"Entra nel cellulare",
      welcome_to_top_qr:"Benvenuti in TOP QR",
      welcome_to_88E:"Benvenuti in TOP QR",
      username_required:"Il nome utente è obbligatorio.",
      password_required:"La password è obbligatoria.",
      signing_in:"Accesso",
      sign_in:"Accedi",
      please_login:"Effettua il login",
      invalid_user_or_password:"Nome utente o password non validi.",
      fail_login:"Impossibile accedere.",
      enter_location:"Inserisci la posizione",
      enter_id:"Inserisci ID",
      enter_employee_number:"Inserisci il numero del dipendente",
      male:"Maschio",
      female:"Femmina",
      upload_file:"Carica file",
      pick_cascade_data:"Scegli i dati a cascata",
      must_check_one_item:"È necessario controllare almeno un elemento.",
      record:"Registrazione",
      pick_a_district:"Scegli un distretto",
      enter_address:"Inserisci indirizzo",
      serial_number:"Numero di serie",
      current_value:"Valore",
      update_message:"Aggiornato da xxx a xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Non è stato possibile aprire la miniapp Wechat nel browser. Si prega di scansionare il codice QR con Wechat",
      select_language_title:"Questo codice QR supporta le seguenti lingue. Si prega di selezionare una lingua.",
      geo_restricted:"Questo codice QR può essere scansionato solo in un'area riservata."                                                        
    }
  },
  no: {
    message: {
      qr_redirect_url :"QR-koden vil omdirigere til følgende url, det er kanskje ikke trygt:",
      user_or_guest :"QR-koden fungerer forskjellig i henhold til skannerens identitet. Er du en registrert bruker eller gjest?",
      input_username :"Skriv inn brukernavn",
      input_password :"Skriv inn passord",
      login :"Pålogging",
      i_am_a_guest :"Jeg er gjest",
      loading_qr :"Laster inn QR-kode ...",
      invalid_qr :"Ugyldig QR-kode",
      campaign_not_start :"QR-kodekampanjen har ikke startet",
      campaign_end :"QR-kodekampanjen er avsluttet",
      subscription_expired :"QR-koden er utilgjengelig, fordi den er under en plan som er utløpt.",
      max_scan_reached :"QR-koden er utilgjengelig, fordi maksimal skanning tillatt for planen for denne QR-koden er nådd.",
      password_protected :"QR-koden er passordbeskyttet, vennligst valider passord",
      validate :"Validere",
      pleasesave :"Dynamisk QR-kode fungerer ikke før den lagres. Hvis du ser denne siden, kan du lagre den.",
      invalid_password :"Ugyldig passord",
      password_validation_error :"Det oppstod en feil under validering av passord.",
      invalid_username_password:"Ugyldig brukernavn eller passord.",
      login_error :"Det oppstod en feil under pålogging.",
      scan_error :"Det oppstod en feil under skanning av QR-kode.",
      powered_by_top_qr :"Drevet av TOP QR",
      powered_by_88E :"Drevet av TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Gå",
      invalid_operation:"Ugyldig operasjon.",
      submit_require_login:"Du må logge inn for å sende inn data.",
      submit_not_allowed:"Du har ikke lov til å sende inn data.",
      ok:"Ok",
      cancel:"Annullere",
      download_file:"Laste ned",
      download_forbidden:"Forbudt",
      phone_number_required:"Tomt telefonnummer kan ikke ringes.",
      email_required:"E-postadresse er påkrevd.",
      email_copied:"E-postadressen ble kopiert.",
      navigation_disabled:"Navigasjon er deaktivert.",
      audio_not_support:"Utforskeren din støtter ikke lydkode.",
      video_not_support:"Utforskeren din støtter ikke videotaggen.",
      unkown:"Ukjent",
      fail_play_media:"Kunne ikke spille av medier.",
      error_play_media:"Det oppstod en feil under avspilling av medier.",
      wechat_name:"Klikk for å få Wechat-navn.",
      form_unavailable_h5:"Skjemakontroll fungerer bare med Wechat miniapp, vennligst skann QR-koden igjen med Wechat.",
      upload_video:"Last opp video.",
      is_required:"er nødvendig.",
      cells_required:"Uthevede celler er ugyldige.",
      click_sign:"Klikk for å signere",
      upload_picture:"Last opp bilde",
      enter_number:"Skriv inn nummer",
      enter_name:"Skriv inn navn",
      enter_text:"Skriv inn tekst",
      enter_mobile:"Gå inn på mobil",
      welcome_to_top_qr:"Velkommen til TOP QR",
      welcome_to_88E:"Velkommen til TOP QR",
      username_required:"Brukernavn er påkrevd.",
      password_required:"Passord kreves.",
      signing_in:"Logge på",
      sign_in:"Logg inn",
      please_login:"Vennligst logg inn",
      invalid_user_or_password:"Ugyldig brukernavn eller passord.",
      fail_login:"Kunne ikke logge inn.",
      enter_location:"Angi plassering",
      enter_id:"Skriv inn ID",
      enter_employee_number:"Angi ansattnummer",
      male:"Mannlig",
      female:"Kvinnelig",
      upload_file:"Last opp fil",
      pick_cascade_data:"Velg kaskadedata",
      must_check_one_item:"Du må sjekke minst ett element.",
      record:"Rekord",
      pick_a_district:"Velg et distrikt",
      enter_address:"Skriv inn adresse",
      serial_number:"Serienummer",
      current_value:"Verdi",
      update_message:"Oppdatert av xxx på xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp kunne ikke åpnes i nettleseren. Vennligst skann QR-koden med Wechat",
      select_language_title:"Denne QR-koden støtter følgende språk. Velg et språk.",
      geo_restricted:"Denne QR-koden kan bare skannes i begrenset område."                                                             
    }
  },
  nl: {
    message: {
      qr_redirect_url :"De QR-code wordt omgeleid naar de volgende url, het is mogelijk niet veilig:",
      user_or_guest :"De QR-code functioneert anders afhankelijk van de identiteit van de scanner. Bent u een geregistreerde gebruiker of een gast?",
      input_username :"Gebruikersnaam invoeren",
      input_password :"Voer wachtwoord in",
      login :"Inloggen",
      i_am_a_guest :"Ik ben te gast",
      loading_qr :"Qr-code laden ...",
      invalid_qr :"Ongeldige QR-code",
      campaign_not_start :"De QR-codecampagne is nog niet gestart",
      campaign_end :"De QR-code campagne is afgelopen",
      subscription_expired :"De QR-code is niet beschikbaar, omdat deze onder een plan valt dat is verlopen.",
      max_scan_reached :"De QR-code is niet beschikbaar, omdat de maximale scan die is toegestaan voor het plan van deze QR-code is bereikt.",
      password_protected :"De QR-code is beveiligd met een wachtwoord, valideer het wachtwoord",
      validate :"Valideren",
      pleasesave :"Dynamische QR-code werkt niet voordat deze is opgeslagen. Als u deze pagina ziet, sla deze dan op.",
      invalid_password :"Ongeldig wachtwoord",
      password_validation_error :"Er is een fout opgetreden tijdens het valideren van het wachtwoord.",
      invalid_username_password:"Ongeldige gebruikersnaam of wachtwoord.",
      login_error :"Er is een fout opgetreden tijdens het inloggen.",
      scan_error :"Er is een fout opgetreden tijdens het scannen van de QR-code.",
      powered_by_top_qr :"Aangedreven door TOP QR",
      powered_by_88E :"Aangedreven door TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Gaan",
      invalid_operation:"Ongeldige bewerking.",
      submit_require_login:"U bent verplicht om in te loggen om gegevens in te dienen.",
      submit_not_allowed:"Het is niet toegestaan om gegevens in te dienen.",
      ok:"OK",
      cancel:"Annuleren",
      download_file:"Downloaden",
      download_forbidden:"Verboden",
      phone_number_required:"Leeg telefoonnummer kan niet worden gebeld.",
      email_required:"E-mailadres is vereist.",
      email_copied:"E-mailadres is gekopieerd.",
      navigation_disabled:"Navigatie is uitgeschakeld.",
      audio_not_support:"Uw verkenner ondersteunt geen audiotag.",
      video_not_support:"Uw verkenner ondersteunt geen videotag.",
      unkown:"Onbekend",
      fail_play_media:"Kan media niet afspelen.",
      error_play_media:"Er is een fout opgetreden tijdens het afspelen van media.",
      wechat_name:"Klik om de Naam van Wechat te krijgen.",
      form_unavailable_h5:"Formulierbeheer werkt alleen met Wechat miniapp, scan de QR-code opnieuw met Wechat.",
      upload_video:"Video uploaden.",
      is_required:"is vereist.",
      cells_required:"Gemarkeerde cellen zijn ongeldig.",
      click_sign:"Klik om te ondertekenen",
      upload_picture:"Foto uploaden",
      enter_number:"Voer nummer in",
      enter_name:"Voer naam in",
      enter_text:"Tekst invoeren",
      enter_mobile:"Voer mobiel in",
      welcome_to_top_qr:"Welkom bij TOP QR",
      welcome_to_88E:"Welkom bij TOP QR",
      username_required:"Gebruikersnaam is vereist.",
      password_required:"Wachtwoord is vereist.",
      signing_in:"Aanmelden",
      sign_in:"Aanmelden",
      please_login:"Gelieve in te loggen",
      invalid_user_or_password:"Ongeldige gebruikersnaam of wachtwoord.",
      fail_login:"Kan niet inloggen.",
      enter_location:"Voer locatie in",
      enter_id:"Voer ID in",
      enter_employee_number:"Voer het werknemersnummer in",
      male:"Mannelijk",
      female:"Vrouwelijk",
      upload_file:"Bestand uploaden",
      pick_cascade_data:"Trapsgewijze gegevens kiezen",
      must_check_one_item:"U moet ten minste één item controleren.",
      record:"Record",
      pick_a_district:"Kies een wijk",
      enter_address:"Voer adres in",
      serial_number:"Serienummer",
      current_value:"Waarde",
      update_message:"Bijgewerkt door xxx op xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp kan niet worden geopend in de browser. Scan de QR-code met Wechat",
      select_language_title:"Deze QR-code ondersteunt de volgende talen. Selecteer een taal.",
      geo_restricted: "Deze QR-code kan alleen worden gescand in een beperkt gebied."                                                                  
    }
  },
  pl: {
    message: {
      qr_redirect_url :"Kod QR przekieruje do następującego adresu URL, może nie być bezpieczny:",
      user_or_guest :"Kod QR działa inaczej w zależności od tożsamości skanera. Jesteś zarejestrowanym użytkownikiem lub gościem?",
      input_username :"Wpisz nazwę użytkownika",
      input_password :"Wprowadź hasło",
      login :"Login",
      i_am_a_guest :"Jestem gościem",
      loading_qr :"Ładowanie kodu QR ...",
      invalid_qr :"Nieprawidłowy kod QR",
      campaign_not_start :"Kampania z kodami QR jeszcze się nie rozpoczęła",
      campaign_end :"Kampania z kodem QR dobiegła końca",
      subscription_expired :"Kod QR jest niedostępny, ponieważ jest objęty planem, który wygasł.",
      max_scan_reached :"Kod QR jest niedostępny, ponieważ osiągnięto maksymalną liczbę skanowań dozwolonych dla planu tego kodu QR.",
      password_protected :"Kod QR jest chroniony hasłem, sprawdź hasło",
      validate :"Walidować",
      pleasesave :"Dynamiczny kod QR Code nie działa przed zapisaniem. Jeśli widzisz tę stronę, zapisz ją.",
      invalid_password :"Nieprawidłowe hasło",
      password_validation_error :"Wystąpił błąd podczas sprawdzania poprawności hasła.",
      invalid_username_password:"Nieprawidłowa nazwa użytkownika lub hasło.",
      login_error :"Wystąpił błąd podczas logowania.",
      scan_error :"Wystąpił błąd podczas skanowania kodu QR.",
      powered_by_top_qr :"Obsługiwane przez TOP QR",
      powered_by_88E :"Obsługiwane przez TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Iść",
      invalid_operation:"Nieprawidłowa operacja.",
      submit_require_login:"Musisz się zalogować, aby przesłać dane.",
      submit_not_allowed:"Nie możesz przesyłać danych.",
      ok:"Ok",
      cancel:"Anuluj",
      download_file:"Pobierać",
      download_forbidden:"Zakazany",
      phone_number_required:"Nie można wybrać pustego numeru telefonu.",
      email_required:"Wymagany jest adres e-mail.",
      email_copied:"Adres e-mail został skopiowany.",
      navigation_disabled:"Nawigacja jest wyłączona.",
      audio_not_support:"Eksplorator nie obsługuje znaczników audio.",
      video_not_support:"Twój eksplorator nie obsługuje tagu wideo.",
      unkown:"Nieznany",
      fail_play_media:"Nie udało się odtworzyć multimediów.",
      error_play_media:"Wystąpił błąd podczas odtwarzania multimediów.",
      wechat_name:"Kliknij, aby uzyskać nazwę Wechat.",
      form_unavailable_h5:"Kontrola formularza działa tylko z miniaplikacją Wechat, ponownie zeskanuj kod QR za pomocą Wechat.",
      upload_video:"Prześlij wideo.",
      is_required:"jest wymagane.",
      cells_required:"Wyróżnione komórki są nieprawidłowe.",
      click_sign:"Kliknij, aby podpisać",
      upload_picture:"Prześlij zdjęcie",
      enter_number:"Wpisz numer",
      enter_name:"Wpisz imię i nazwisko",
      enter_text:"Wpisz tekst",
      enter_mobile:"Wpisz telefon komórkowy",
      welcome_to_top_qr:"Witamy w TOP QR",
      welcome_to_88E:"Witamy w TOP QR",
      username_required:"Nazwa użytkownika jest wymagana.",
      password_required:"Hasło jest wymagane.",
      signing_in:"Logowanie",
      sign_in:"Rejestrowanie",
      please_login:"Proszę się zalogować",
      invalid_user_or_password:"Nieprawidłowa nazwa użytkownika lub hasło.",
      fail_login:"Nie udało się zalogować.",
      enter_location:"Wprowadź lokalizację",
      enter_id:"Wpisz identyfikator",
      enter_employee_number:"Wprowadź numer pracownika",
      male:"Mężczyzna",
      female:"Kobieta",
      upload_file:"Prześlij plik",
      pick_cascade_data:"Wybieranie danych kaskadowych",
      must_check_one_item:"Musisz sprawdzić co najmniej jeden przedmiot.",
      record:"Rekord",
      pick_a_district:"Wybierz dzielnicę",
      enter_address:"Wpisz adres",
      serial_number:"Numer seryjny",
      current_value:"Wartość",
      update_message:"Zaktualizowane przez xxx o xxxx-xx-xx xx: xx: xx",
      scan_with_wechat:"Nie można otworzyć miniaplikacji Wechat w przeglądarce. Zeskanuj kod QR za pomocą Wechat",
      select_language_title:"Ten kod QR obsługuje następujące języki. Wybierz język.", 
      geo_restricted:"Ten kod QR można zeskanować tylko w obszarze o ograniczonym dostępie."                                                                     
    }
  },
  ro: {
    message: {
      qr_redirect_url :"Codul QR va redirecționa către următorul URL, este posibil să nu fie sigur:",
      user_or_guest :"Codul QR funcționează diferit în funcție de identitatea scanerului. Sunteți un utilizator înregistrat sau un oaspete?",
      input_username :"Introduceți numele de utilizator",
      input_password :"Introduceți parola",
      login :"Login",
      i_am_a_guest :"Sunt oaspete",
      loading_qr :"Incarcarea codului QR ...",
      invalid_qr :"Cod QR nevalid",
      campaign_not_start :"Campania de coduri QR nu a început",
      campaign_end :"Campania de coduri QR s-a încheiat",
      subscription_expired :"Codul QR nu este disponibil, deoarece se află sub un plan care a expirat.",
      max_scan_reached :"Codul QR nu este disponibil, deoarece scanarea maximă permisă pentru planul acestui cod QR este atinsă.",
      password_protected :"Codul QR este protejat prin parolă, vă rugăm să validați parola",
      validate :"Valida",
      pleasesave :"Codul QR dinamic nu funcționează înainte de a fi salvat. Dacă vedeți această pagină, vă rugăm să o salvați.",
      invalid_password :"Parolă nevalidă",
      password_validation_error :"A apărut o eroare la validarea parolei.",
      invalid_username_password:"Nume de utilizator sau parolă nevalidă.",
      login_error :"A apărut o eroare în timpul conectării.",
      scan_error :"A apărut o eroare la scanarea codului QR.",
      powered_by_top_qr :"Powered by TOP QR",
      powered_by_88E :"Powered by TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Merge",
      invalid_operation:"Funcționare nevalidă.",
      submit_require_login:"Vi se cere să vă conectați pentru a trimite date.",
      submit_not_allowed:"Nu aveți voie să trimiteți date.",
      ok:"Ok",
      cancel:"Anula",
      download_file:"Descărca",
      download_forbidden:"Interzis",
      phone_number_required:"Numărul de telefon gol nu poate fi format.",
      email_required:"Este necesară adresa de e-mail.",
      email_copied:"Adresa de e-mail a fost copiată.",
      navigation_disabled:"Navigarea este dezactivată.",
      audio_not_support:"Exploratorul nu acceptă eticheta audio.",
      video_not_support:"Exploratorul nu acceptă eticheta video.",
      unkown:"Necunoscut",
      fail_play_media:"Nu a reușit să redea conținut media.",
      error_play_media:"A apărut o eroare în timpul redării conținutului media.",
      wechat_name:"Faceți clic pentru a obține numele Wechat.",
      form_unavailable_h5:"Controlul formularului funcționează numai cu miniapp Wechat, vă rugăm să scanați din nou codul QR cu Wechat.",
      upload_video:"Încărcați video.",
      is_required:"este necesar.",
      cells_required:"Celulele evidențiate nu sunt valide.",
      click_sign:"Faceți clic pentru a semna",
      upload_picture:"Încărcați o imagine",
      enter_number:"Introduceți numărul",
      enter_name:"Introduceți numele",
      enter_text:"Introducerea textului",
      enter_mobile:"Introduceți telefonul mobil",
      welcome_to_top_qr:"Bine ati venit la TOP QR",
      welcome_to_88E:"Bine ati venit la TOP QR",
      username_required:"Numele de utilizator este necesar.",
      password_required:"Parola este necesară.",
      signing_in:"Conectarea",
      sign_in:"Conectează-te",
      please_login:"Vă rugăm să vă autentificați",
      invalid_user_or_password:"Nume de utilizator sau parolă nevalidă.",
      fail_login:"Nu a reușit să vă conectați.",
      enter_location:"Introduceți locația",
      enter_id:"Introduceți ID-ul",
      enter_employee_number:"Introduceți numărul angajatului",
      male:"Mascul",
      female:"Feminin",
      upload_file:"Încărcați fișierul",
      pick_cascade_data:"Alegerea datelor în cascadă",
      must_check_one_item:"Trebuie să verificați cel puțin un element.",
      record:"Disc",
      pick_a_district:"Alegeți un district",
      enter_address:"Introduceți adresa",
      serial_number:"Numărul de serie",
      current_value:"Valoare",
      update_message:"Actualizat de xxx la xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Miniapp-ul Wechat nu a putut fi deschis în browser. Vă rugăm să scanați codul QR cu Wechat",
      select_language_title:"Acest cod QR acceptă următoarele limbi. Vă rugăm să selectați o limbă.",
      geo_restricted:"Acest cod QR poate fi scanat numai într-o zonă restricționată."                                                                           
    }
  },
  sv: {
    message: {
      qr_redirect_url :"QR-koden omdirigeras till följande url, det kanske inte är säkert:",
      user_or_guest :"QR-koden fungerar annorlunda beroende på skannerns identitet. Är du en registrerad användare eller gäst?",
      input_username :"Ange användarnamn",
      input_password :"Ange lösenord",
      login :"Logga in",
      i_am_a_guest :"Jag är gäst",
      loading_qr :"Laddar QR-kod ...",
      invalid_qr :"Ogiltig QR-kod",
      campaign_not_start :"QR-kodkampanjen har inte startat",
      campaign_end :"QR-kodkampanjen har avslutats",
      subscription_expired :"QR-koden är inte tillgänglig eftersom den är under en plan som har gått ut.",
      max_scan_reached :"QR-koden är inte tillgänglig, eftersom maximal genomsökning tillåten för planen för denna QR-kod har uppnåtts.",
      password_protected :"QR-koden är lösenordsskyddad, validera lösenordet",
      validate :"Validera",
      pleasesave :"Dynamisk QR-kod fungerar inte innan den sparas. Om du ser den här sidan, spara den.",
      invalid_password :"Ogiltigt lösenord",
      password_validation_error :"Ett fel uppstod vid validering av lösenord.",
      invalid_username_password:"Ogiltigt användarnamn eller lösenord.",
      login_error :"Ett fel inträffade vid inloggning.",
      scan_error :"Ett fel inträffade vid skanning av QR-kod.",
      powered_by_top_qr :"Drivs av TOP QR",
      powered_by_88E :"Drivs av TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Gå",
      invalid_operation:"Ogiltig åtgärd.",
      submit_require_login:"Du måste logga in för att skicka in data.",
      submit_not_allowed:"Du får inte skicka in uppgifter.",
      ok:"Okej",
      cancel:"Annullera",
      download_file:"Ladda ned",
      download_forbidden:"Förbjuden",
      phone_number_required:"Tomt telefonnummer kan inte ringas.",
      email_required:"E-postadress krävs.",
      email_copied:"E-postadressen kopierades.",
      navigation_disabled:"Navigering är inaktiverad.",
      audio_not_support:"Utforskaren stöder inte ljudtaggen.",
      video_not_support:"Utforskaren stöder inte videotaggen.",
      unkown:"Okänd",
      fail_play_media:"Det gick inte att spela upp media.",
      error_play_media:"Ett fel inträffade när media spelades upp.",
      wechat_name:"Klicka för att få Wechat-namn.",
      form_unavailable_h5:"Formulärkontroll fungerar bara med Wechat miniapp, skanna QR-koden igen med Wechat.",
      upload_video:"Ladda upp video.",
      is_required:"krävs.",
      cells_required:"Markerade celler är ogiltiga.",
      click_sign:"Klicka för att signera",
      upload_picture:"Ladda upp bild",
      enter_number:"Ange nummer",
      enter_name:"Ange namn",
      enter_text:"Ange text",
      enter_mobile:"Gå in i mobilen",
      welcome_to_top_qr:"Välkommen till TOP QR",
      welcome_to_88E:"Välkommen till TOP QR",
      username_required:"Användarnamn krävs.",
      password_required:"Lösenord krävs.",
      signing_in:"Logga in",
      sign_in:"Logga in",
      please_login:"Vänligen logga in",
      invalid_user_or_password:"Ogiltigt användarnamn eller lösenord.",
      fail_login:"Det gick inte att logga in.",
      enter_location:"Ange plats",
      enter_id:"Ange ID",
      enter_employee_number:"Ange anställningsnummer",
      male:"Manlig",
      female:"Kvinnlig",
      upload_file:"Ladda upp fil",
      pick_cascade_data:"Välj överlappande data",
      must_check_one_item:"Du måste kontrollera minst ett objekt.",
      record:"Rekord",
      pick_a_district:"Välj ett distrikt",
      enter_address:"Ange adress",
      serial_number:"Serienummer",
      current_value:"Värde",
      update_message:"Uppdaterad av xxx på xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp kunde inte öppnas i webbläsaren. Skanna QR-koden med Wechat",
      select_language_title:"Denna QR-kod stöder följande språk. Välj ett språk.",
      geo_restricted:"Denna QR-kod kan endast skannas i ett begränsat område."                                                                           
    }
  },
  uk: {
    message: {
      qr_redirect_url :"QR-код перенаправить на наступну URL-адресу, це може бути небезпечно:",
      user_or_guest :"QR-код функціонує по-різному залежно від особистості сканера. Ви зареєстрований користувач або гість?",
      input_username :"Введіть ім'я користувача",
      input_password :"Введіть пароль",
      login :"Логін",
      i_am_a_guest :"Я гість",
      loading_qr :"Завантаження QR-коду ...",
      invalid_qr :"Недійсний QR-код",
      campaign_not_start :"Кампанія QR-коду не розпочалася",
      campaign_end :"Завершилася кампанія QR-коду",
      subscription_expired :"QR-код недоступний, оскільки він відповідає плану, термін дії якого закінчився.",
      max_scan_reached :"QR-код недоступний, оскільки досягнуто максимального сканування, дозволеного для плану цього QR-коду.",
      password_protected :"QR-код захищений паролем, будь ласка, перевірте пароль",
      validate :"Перевірити",
      pleasesave :"Динамічний QR-код не працює до його збереження. Якщо ви бачите цю сторінку, будь ласка, збережіть її.",
      invalid_password :"Невірний пароль",
      password_validation_error :"Під час перевірки пароля сталася помилка.",
      invalid_username_password:"Неприпустиме ім'я користувача або пароль.",
      login_error :"Під час входу в систему сталася помилка.",
      scan_error :"Під час сканування QR-коду сталася помилка.",
      powered_by_top_qr :"Працює від TOP QR",
      powered_by_88E :"Працює від TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Іти",
      invalid_operation:"Недійсна операція.",
      submit_require_login:"Ви повинні увійти, щоб подати дані.",
      submit_not_allowed:"Ви не маєте права надсилати дані.",
      ok:"Гаразд",
      cancel:"Скасувати",
      download_file:"Завантажити",
      download_forbidden:"Заборонений",
      phone_number_required:"Порожній номер телефону неможливо набрати.",
      email_required:"Адреса електронної пошти обов'язкова.",
      email_copied:"Адреса електронної пошти була скопійована.",
      navigation_disabled:"Навігацію вимкнуто.",
      audio_not_support:"Провідник не підтримує аудіотег.",
      video_not_support:"Ваш провідник не підтримує тег відео.",
      unkown:"Невідомий",
      fail_play_media:"Не вдалося відтворити медіа.",
      error_play_media:"Під час відтворення носіїв сталася помилка.",
      wechat_name:"Натисніть, щоб отримати ім'я Wechat.",
      form_unavailable_h5:"Контроль форми працює тільки з міні-додатком Wechat, будь ласка, відскануйте QR-код ще раз за допомогою Wechat.",
      upload_video:"Завантажте відео.",
      is_required:"є обов'язковим.",
      cells_required:"Виділені клітинки неприпустимі.",
      click_sign:"Натисніть, щоб підписати",
      upload_picture:"Передавання зображення",
      enter_number:"Введіть номер",
      enter_name:"Введіть ім'я",
      enter_text:"Введіть текст",
      enter_mobile:"Введіть мобільний",
      welcome_to_top_qr:"Ласкаво просимо в TOP QR",
      welcome_to_88E:"Ласкаво просимо в TOP QR",
      username_required:"Ім'я користувача обов'язкове.",
      password_required:"Пароль обов'язковий.",
      signing_in:"Вхід",
      sign_in:"Ввійти",
      please_login:"Будь ласка, увійдіть",
      invalid_user_or_password:"Неприпустиме ім'я користувача або пароль.",
      fail_login:"Не вдалося авторизуватися.",
      enter_location:"Введіть місцезнаходження",
      enter_id:"Введіть ID",
      enter_employee_number:"Введіть номер співробітника",
      male:"Чоловічий",
      female:"Жіночий",
      upload_file:"Завантажити файл",
      pick_cascade_data:"Вибір каскадних даних",
      must_check_one_item:"Необхідно перевірити хоча б один пункт.",
      record:"Запис",
      pick_a_district:"Виберіть район",
      enter_address:"Введіть адресу",
      serial_number:"Серійний номер",
      current_value:"Цінність",
      update_message:"Оновлено xxx на xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Міні-додаток Wechat не вдалося відкрити в браузері. Будь ласка, відскануйте QR-код за допомогою Wechat",
      select_language_title:"Цей QR-код підтримує наступні мови. Будь ласка, виберіть мову.",
      geo_restricted:"Цей QR-код можна відсканувати лише в забороненій зоні."                                                                             
    }
  },
  vi: {
    message: {
      qr_redirect_url :"Mã QR sẽ chuyển hướng đến url sau, nó có thể không an toàn:",
      user_or_guest :"Mã QR hoạt động khác nhau tùy theo danh tính của máy quét. Bạn là người dùng đã đăng ký hay khách?",
      input_username :"Nhập tên người dùng",
      input_password :"Nhập mật khẩu",
      login :"Đăng nhập",
      i_am_a_guest :"Tôi là khách",
      loading_qr :"Đang tải mã QR ...",
      invalid_qr :"Mã QR không hợp lệ",
      campaign_not_start :"Chiến dịch mã QR chưa bắt đầu",
      campaign_end :"Chiến dịch mã QR đã kết thúc",
      subscription_expired :"Mã QR không khả dụng, vì nó thuộc gói đã hết hạn.",
      max_scan_reached :"Mã QR không khả dụng, vì đã đạt đến mức quét tối đa cho phép đối với gói mã QR này.",
      password_protected :"Mã QR được bảo vệ bằng mật khẩu, vui lòng xác thực mật khẩu",
      validate :"Xác nhận",
      pleasesave :"Mã QR động không hoạt động trước khi được lưu. Nếu bạn thấy trang này, vui lòng lưu nó.",
      invalid_password :"Mật khẩu không hợp lệ",
      password_validation_error :"Đã xảy ra lỗi khi xác thực mật khẩu.",
      invalid_username_password:"Tên người dùng hoặc mật khẩu không hợp lệ.",
      login_error :"Đã xảy ra lỗi khi đăng nhập.",
      scan_error :"Đã xảy ra lỗi khi quét mã QR.",
      powered_by_top_qr :"Được cung cấp bởi TOP QR",
      powered_by_88E :"Được cung cấp bởi TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Đi",
      invalid_operation:"Thao tác không hợp lệ.",
      submit_require_login:"Bạn được yêu cầu đăng nhập để gửi dữ liệu.",
      submit_not_allowed:"Bạn không được phép gửi dữ liệu.",
      ok:"Ok",
      cancel:"Hủy",
      download_file:"Tải xuống",
      download_forbidden:"Bị cấm",
      phone_number_required:"Số điện thoại trống không thể được quay số.",
      email_required:"Địa chỉ email là bắt buộc.",
      email_copied:"Địa chỉ email đã được sao chép.",
      navigation_disabled:"Điều hướng bị tắt.",
      audio_not_support:"Trình thám hiểm của bạn không hỗ trợ thẻ âm thanh.",
      video_not_support:"Trình thám hiểm của bạn không hỗ trợ thẻ video.",
      unkown:"Không biết",
      fail_play_media:"Không phát được nội dung nghe nhìn.",
      error_play_media:"Đã xảy ra lỗi khi phát phương tiện.",
      wechat_name:"Nhấp để lấy tên Wechat.",
      form_unavailable_h5:"Kiểm soát biểu mẫu chỉ hoạt động với ứng dụng nhỏ Wechat, vui lòng quét lại mã QR bằng Wechat.",
      upload_video:"Tải video lên.",
      is_required:"là bắt buộc.",
      cells_required:"Các ô được tô sáng không hợp lệ.",
      click_sign:"Nhấp để ký",
      upload_picture:"Tải lên hình ảnh",
      enter_number:"Nhập số",
      enter_name:"Nhập tên",
      enter_text:"Nhập văn bản",
      enter_mobile:"Nhập thiết bị di động",
      welcome_to_top_qr:"Chào mừng bạn đến với TOP QR",
      welcome_to_88E:"Chào mừng bạn đến với TOP QR",
      username_required:"Tên người dùng là bắt buộc.",
      password_required:"Mật khẩu là bắt buộc.",
      signing_in:"Đăng nhập",
      sign_in:"Đăng nhập",
      please_login:"Vui lòng đăng nhập",
      invalid_user_or_password:"Tên người dùng hoặc mật khẩu không hợp lệ.",
      fail_login:"Không thể đăng nhập.",
      enter_location:"Nhập vị trí",
      enter_id:"Nhập ID",
      enter_employee_number:"Nhập số nhân viên",
      male:"Đực",
      female:"Cái",
      upload_file:"Tải lên tập tin",
      pick_cascade_data:"Chọn dữ liệu xếp tầng",
      must_check_one_item:"Bạn phải kiểm tra ít nhất một mục.",
      record:"Ghi",
      pick_a_district:"Chọn một quận",
      enter_address:"Nhập địa chỉ",
      serial_number:"Số sê-ri",
      current_value:"Giá trị",
      update_message:"Cập nhật bởi xxx tại xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Không thể mở ứng dụng Wechat miniapp trong trình duyệt. Vui lòng quét mã QR bằng Wechat",
      select_language_title:"Mã QR này hỗ trợ các ngôn ngữ sau. Vui lòng chọn một ngôn ngữ.",
      geo_restricted: "Mã QR này chỉ có thể được quét trong khu vực hạn chế."                                                                                  
    }
  },
  af: {
    message: {
      qr_redirect_url :"Die QR-kode sal na die volgende url verwys, dit is dalk nie veilig nie:",
      user_or_guest :"Die QR-kode funksioneer anders volgens die identiteit van die skandeerder. Is jy 'n geregistreerde gebruiker of 'n gas?",
      input_username :"Voer gebruikersnaam in",
      input_password :"Voer wagwoord in",
      login :"Aanteken",
      i_am_a_guest :"Ek is 'n gas",
      loading_qr :"Laai QR-kode ...",
      invalid_qr :"Ongeldige QR-kode",
      campaign_not_start :"Die QR-kodeveldtog het nie begin nie",
      campaign_end :"Die QR-kodeveldtog het geëindig",
      subscription_expired :"Die QR-kode is nie beskikbaar nie, want dit is onder 'n plan wat verval het.",
      max_scan_reached :"Die QR-kode is nie beskikbaar nie, omdat maksimum skandering wat vir die plan van hierdie QR-kode toegelaat word, bereik word.",
      password_protected :"Die QR-kode word met 'n wagwoord beskerm, bevestig asseblief wagwoord",
      validate :"Valideer",
      pleasesave :"Dinamiese QR-kode werk nie voordat dit gestoor word nie. As jy hierdie bladsy sien, stoor dit asseblief.",
      invalid_password :"Ongeldige wagwoord",
      password_validation_error :"N Fout het voorgekom tydens die validering van die wagwoord.",
      invalid_username_password:"Ongeldige gebruikersnaam of wagwoord.",
      login_error :"N Fout het voorgekom tydens aanmelding.",
      scan_error :"N Fout het voorgekom tydens die skandering van QR-kode.",
      powered_by_top_qr :"Aangedryf deur TOP QR",
      powered_by_88E :"Aangedryf deur TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Gaan",
      invalid_operation:"Ongeldige operasie.",
      submit_require_login:"U moet aanmeld om data in te dien.",
      submit_not_allowed:"U mag nie data indien nie.",
      ok:"Oukei",
      cancel:"Kanselleer",
      download_file:"Aflaai",
      download_forbidden:"Verbode",
      phone_number_required:"Leë telefoonnommer kan nie geskakel word nie.",
      email_required:"E-posadres word vereis.",
      email_copied:"E-posadres is gekopieer.",
      navigation_disabled:"Navigasie is gedeaktiveer.",
      audio_not_support:"Jou ontdekkingsreisiger ondersteun nie klanketiket nie.",
      video_not_support:"Jou ontdekkingsreisiger ondersteun nie videomerker nie.",
      unkown:"Onbekende",
      fail_play_media:"Kon nie media speel nie.",
      error_play_media:"N Fout het voorgekom tydens die speel van media.",
      wechat_name:"Klik om Wechat-naam te kry.",
      form_unavailable_h5:"Vormbeheer werk slegs met Wechat miniapp, skandeer asseblief weer die QR-kode met Wechat.",
      upload_video:"Laai video op.",
      is_required:"word vereis.",
      cells_required:"Gemerkte selle is ongeldig.",
      click_sign:"Klik om te teken",
      upload_picture:"Laai foto op",
      enter_number:"Voer nommer in",
      enter_name:"Voer naam in",
      enter_text:"Voer teks in",
      enter_mobile:"Voer selfoon in",
      welcome_to_top_qr:"Welkom by TOP QR",
      welcome_to_88E:"Welkom by TOP QR",
      username_required:"Gebruikersnaam word vereis.",
      password_required:"Wagwoord is nodig.",
      signing_in:"Aanteken",
      sign_in:"Teken aan",
      please_login:"Meld asseblief aan",
      invalid_user_or_password:"Ongeldige gebruikersnaam of wagwoord.",
      fail_login:"Kon nie aanmeld nie.",
      enter_location:"Voer ligging in",
      enter_id:"Voer ID in",
      enter_employee_number:"Voer werknemernommer in",
      male:"Manlike",
      female:"Vroulike",
      upload_file:"Laai lêer op",
      pick_cascade_data:"Kies kaskade data",
      must_check_one_item:"U moet ten minste een item nagaan.",
      record:"Rekord",
      pick_a_district:"Kies 'n distrik",
      enter_address:"Voer adres in",
      serial_number:"Reeksnommer",
      current_value:"Waarde",
      update_message:"Opgedateer deur xxx by xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp kon nie in die blaaier oopgemaak word nie. Skandeer asseblief die QR-kode met Wechat",
      select_language_title:"Hierdie QR-kode ondersteun die volgende tale. Kies asseblief 'n taal.",
      geo_restricted:"Hierdie QR-kode kan slegs in beperkte gebied geskandeer word."                                                                                       
    }
  },
  az: {
    message: {
      qr_redirect_url :"QR kodu aşağıdakı url-ə yönələcək, təhlükəsiz olmaya bilər:",
      user_or_guest :"QR kodu skanerin kimliyinə görə fərqli şəkildə fəaliyyət göstərir. Qeydiyyatdan keçmiş istifadəçisiniz, yoxsa qonaq?",
      input_username :"İstifadəçi adı daxil edin",
      input_password :"Şifrəni daxil edin",
      login :"Giriş",
      i_am_a_guest :"Mən qonaqam",
      loading_qr :"QR kodun yüklənməsi ...",
      invalid_qr :"Səhv QR kodu",
      campaign_not_start :"QR kod kampaniyası başlanmadı",
      campaign_end :"QR kod kampaniyası başa çatdı",
      subscription_expired :"Qr kodu əlçatmazdır, çünki o, müddəti bitmiş plan üzrədir.",
      max_scan_reached :"QR kodu əlçatmazdır, çünki bu QR kodun planı üçün icazə verilən maksimum skan edilir.",
      password_protected :"QR kodu parol qorunur, lütfən parolu təsdiq edin",
      validate :"Təsdiqlə",
      pleasesave :"Dinamik QR Kod qeyd olunmazdan əvvəl işləmir. Bu səhifəni görsəniz xahiş edirik qeyd edin.",
      invalid_password :"Səhv şifrə",
      password_validation_error :"Şifrə təsdiqlənərkən xəta oldu.",
      invalid_username_password:"Səhv istifadəçi adı və ya şifrə.",
      login_error :"Giriş zamanı xəta oldu.",
      scan_error :"QR kodu skan edərkən xəta baş verdi.",
      powered_by_top_qr :"Powered by TOP QR",
      powered_by_88E :"Powered by TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Get",
      invalid_operation:"Səhv əməliyyat.",
      submit_require_login:"Məlumat göndərmək üçün giriş tələb olunur.",
      submit_not_allowed:"Məlumat göndərməyə icazə verilmir.",
      ok:"Yaxşı",
      cancel:"Ləğv etmək",
      download_file:"Endir",
      download_forbidden:"Qadağandır",
      phone_number_required:"Boş telefon nömrəsini zəng etmək mümkün deyil.",
      email_required:"Elektron poçt ünvanı tələb olunur.",
      email_copied:"E-poçt ünvanı köçürüldü.",
      navigation_disabled:"Naviqasiya qeyri-fəaldır.",
      audio_not_support:"Səyyahınız audio etiketi dəstəkləmir.",
      video_not_support:"Səyyahınız video etiketi dəstəkləmir.",
      unkown:"Namə'lum",
      fail_play_media:"Media oynana bilmədi.",
      error_play_media:"Xəta media oynanarkən baş verdi.",
      wechat_name:"Wechat adını almaq üçün klikləyin.",
      form_unavailable_h5:"Forma idarəetməsi yalnız Wechat miniapp ilə işləyir. Zəhmət olmasa, WECHAT ilə qr kodu yenidən skan edin.",
      upload_video:"Video yukle.",
      is_required:"tələb olunur.",
      cells_required:"Vurğulanan hüceyrələr qüvvədə deyil.",
      click_sign:"İmzalamaq üçün klikləyin",
      upload_picture:"Şəkil yukle",
      enter_number:"Nömrəni daxil edin",
      enter_name:"Adı daxil edin",
      enter_text:"Mətni daxil edin",
      enter_mobile:"Mobil daxil olun",
      welcome_to_top_qr:"TOP QR-a xoş gəlmisiniz",
      welcome_to_88E:"TOP QR-a xoş gəlmisiniz",
      username_required:"İstifadəçi adı tələb olunur.",
      password_required:"Şifrə tələb olunur.",
      signing_in:"İmzalama",
      sign_in:"Daxil olmaq",
      please_login:"Zəhmət olmasa giriş",
      invalid_user_or_password:"Səhv istifadəçi adı və ya şifrə.",
      fail_login:"%s yüklənə bilmədi.",
      enter_location:"Yeri daxil edin",
      enter_id:"ID daxil edin",
      enter_employee_number:"İşçi nömrəsini daxil edin",
      male:"Kişi",
      female:"Qadın",
      upload_file:"Fayl yüklə",
      pick_cascade_data:"Cascade datalarını seç",
      must_check_one_item:"Ən azı bir əşyanı yoxlamalısınız.",
      record:"Qeyd",
      pick_a_district:"Vilayət seçin",
      enter_address:"Ünvanı daxil edin",
      serial_number:"Seriya nömrəsi",
      current_value:"Qiymət",
      update_message:"xxxx-xx-xx xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp brauzerdə açıla bilmədi. Zəhmət olmasa WECHAT ilə QR kodu skan edin",
      select_language_title:"Bu QR kodu aşağıdakı dilləri dəstəkləyir. Zəhmət olmasa dil seçin.",
      geo_restricted:"Bu QR kodu yalnız məhdudlaşdırılmış ərazidə skan etmək olar"                                                                                            
    }
  },
  be: {
    message: {
      qr_redirect_url :"QR-код будзе перанакіроўваць на наступны URL, гэта можа быць небяспечна:",
      user_or_guest :"QR-код функцыянуе па-рознаму ў залежнасці ад ідэнтыфікацыі сканера. Вы зарэгістраваны карыстальнік ці госць?",
      input_username :"Увядзіце імя карыстальніка",
      input_password :"Увядзіце пароль",
      login :"Увайсці",
      i_am_a_guest :"Я госць",
      loading_qr :"Загрузка QR-кода...",
      invalid_qr :"Няправільны QR-код",
      campaign_not_start :"Кампанія па QR-кодах не пачалася",
      campaign_end :"Кампанія па QR-кодах скончылася",
      subscription_expired :"QR-код недаступны, таму што ён знаходзіцца ў рамках плана, тэрмін дзеяння якога скончыўся.",
      max_scan_reached :"QR-код недаступны, таму што дасягнута максімальная колькасць сканавання, дазволеная для плана гэтага QR-кода.",
      password_protected :"QR-код абаронены паролем, пацвердзіце пароль",
      validate :"Праверыць",
      pleasesave :"Дынамічны QR-код не працуе, пакуль ён не захаваны. Калі вы бачыце гэтую старонку, захавайце яе.",
      invalid_password :"Няправільны пароль",
      password_validation_error :"Падчас праверкі пароля адбылася памылка.",
      invalid_username_password:"Няправільнае імя карыстальніка або пароль.",
      login_error :"Падчас уваходу адбылася памылка.",
      scan_error :"Падчас сканіравання QR-кода адбылася памылка.",
      powered_by_top_qr :"Працуе на TOP QR",
      powered_by_88E :"Працуе на TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Ідзі",
      invalid_operation:"Няправільная аперацыя.",
      submit_require_login:"Вам неабходна ўвайсці, каб адправіць дадзеныя.",
      submit_not_allowed:"Вы не маеце права адпраўляць дадзеныя.",
      ok:"Добра",
      cancel:"Адмяніць",
      download_file:"Спампаваць",
      download_forbidden:"Забаронена",
      phone_number_required:"Пусты нумар тэлефона нельга набраць.",
      email_required:"Адрас электроннай пошты абавязковы.",
      email_copied:"Адрас электроннай пошты скапіраваны.",
      navigation_disabled:"Навігацыя адключана.",
      audio_not_support:"Ваш аглядальнік не падтрымлівае гукавы тэг.",
      video_not_support:"Ваш аглядальнік не падтрымлівае тэгі відэа.",
      unkown:"Невядомы",
      fail_play_media:"Не ўдалося прайграць мультымедыя.",
      error_play_media:"Падчас прайгравання мультымедыя адбылася памылка.",
      wechat_name:"Націсніце, каб атрымаць назву WeChat.",
      form_unavailable_h5:"Упраўленне формамі працуе толькі з міні-праграмай Wechat, адсканіруйце QR-код яшчэ раз з дапамогай Wechat.",
      upload_video:"Загрузіць відэа.",
      is_required:"патрабуецца.",
      cells_required:"Выдзеленыя ячэйкі несапраўдныя.",
      click_sign:"Націсніце, каб падпісаць",
      upload_picture:"Загрузіць карцінку",
      enter_number:"Увядзіце нумар",
      enter_name:"Увядзіце імя",
      enter_text:"Увядзіце тэкст",
      enter_mobile:"Увядзіце мабільны",
      welcome_to_top_qr:"Сардэчна запрашаем у TOP QR",
      welcome_to_88E:"Сардэчна запрашаем у TOP QR",
      username_required:"Патрабуецца імя карыстальніка.",
      password_required:"Патрабуецца пароль.",
      signing_in:"Уваход",
      sign_in:"Увайсці",
      please_login:"Калі ласка, увайдзіце",
      invalid_user_or_password:"Няправільнае імя карыстальніка або пароль.",
      fail_login:"Не ўдалося ўвайсці.",
      enter_location:"Увядзіце месцазнаходжанне",
      enter_id:"Увядзіце ідэнтыфікатар",
      enter_employee_number:"Увядзіце нумар супрацоўніка",
      male:"мужчынскі",
      female:"жаночы",
      upload_file:"Загрузіць файл",
      pick_cascade_data:"Выберыце даныя каскаду",
      must_check_one_item:"Вы павінны адзначыць па меншай меры адзін пункт.",
      record:"Запіс",
      pick_a_district:"Выберыце раён",
      enter_address:"Увядзіце адрас",
      serial_number:"Серыйны нумар",
      current_value:"Каштоўнасць",
      update_message:"Абноўлена xxx у xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Не ўдалося адкрыць міні-прыкладанне Wechat у браўзеры. Адсканіруйце QR-код з дапамогай Wechat",
      select_language_title:"Гэты QR-код падтрымлівае наступныя мовы. Выберыце мову.",
      geo_restricted:"Bu QR kodu yalnız məhdud ərazidə skan edilə bilər."                                                                                                  
    }
  },
  bg: {
    message: {
      qr_redirect_url :"QR кодът ще пренасочи към следния URL адрес, може да не е безопасно:",
      user_or_guest :"QR кодът функционира по различен начин в зависимост от идентичността на скенера. Вие сте регистриран потребител или гост?",
      input_username :"Въведете потребителско име",
      input_password :"Въведете парола",
      login :"Вход",
      i_am_a_guest :"Аз съм гост",
      loading_qr :"Зареждане на QR код ...",
      invalid_qr :"Невалиден QR код",
      campaign_not_start :"Кампанията с QR код не е започнала",
      campaign_end :"Кампанията за QR код приключи",
      subscription_expired :"QR кодът не е наличен, защото е под план, който е изтекъл.",
      max_scan_reached :"QR кодът не е наличен, защото е достигнато максимално сканиране, разрешено за плана на този QR код.",
      password_protected :"QR кодът е защитен с парола, моля, валидирайте паролата",
      validate :"Ратифицирам",
      pleasesave :"Динамичният QR код не работи, преди да бъде записан. Ако виждате тази страница, моля, запазете я.",
      invalid_password :"Невалидна парола",
      password_validation_error :"Възникна грешка при проверка на паролата.",
      invalid_username_password:"Невалидно потребителско име или парола.",
      login_error :"Възникна грешка при влизане.",
      scan_error :"Възникна грешка при сканиране на QR код.",
      powered_by_top_qr :"Осъществено от TOP QR",
      powered_by_88E :"Осъществено от TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Вървя",
      invalid_operation:"Невалидна операция.",
      submit_require_login:"От вас се изисква да влезете, за да изпратите данни.",
      submit_not_allowed:"Нямате право да подавате данни.",
      ok:"OK",
      cancel:"Отмени",
      download_file:"Свалям",
      download_forbidden:"Забранено",
      phone_number_required:"Празният телефонен номер не може да бъде набран.",
      email_required:"Изисква се имейл адрес.",
      email_copied:"Имейл адресът е копиран.",
      navigation_disabled:"Навигацията е забранена.",
      audio_not_support:"Вашият изследовател не поддържа аудио етикет.",
      video_not_support:"Вашият изследовател не поддържа етикет за видео.",
      unkown:"Неизвестен",
      fail_play_media:"Неуспешно възпроизвеждане на медии.",
      error_play_media:"Възникна грешка при възпроизвеждане на мултимедия.",
      wechat_name:"Кликнете, за да получите името на Wechat.",
      form_unavailable_h5:"Контролът на формуляра работи само с миниап Wechat, моля, сканирайте QR кода отново с Wechat.",
      upload_video:"Качване на видео.",
      is_required:"се изисква.",
      cells_required:"Осветените клетки са невалидни.",
      click_sign:"Щракнете, за да подпишете",
      upload_picture:"Качване на картина",
      enter_number:"Въведете номер",
      enter_name:"Въведете име",
      enter_text:"Въвеждане на текст",
      enter_mobile:"Въведете мобилен",
      welcome_to_top_qr:"Добре дошли в TOP QR",
      welcome_to_88E:"Добре дошли в TOP QR",
      username_required:"Потребителското име е задължително.",
      password_required:"Паролата е задължителна.",
      signing_in:"Влизане",
      sign_in:"Влизане",
      please_login:"Моля, влезте",
      invalid_user_or_password:"Невалидно потребителско име или парола.",
      fail_login:"Неуспешно влизане.",
      enter_location:"Въведете местоположение",
      enter_id:"Въведете ИД",
      enter_employee_number:"Въведете номера на служителя",
      male:"Мъжки",
      female:"Жена",
      upload_file:"Качване на файл",
      pick_cascade_data:"Избор на каскадни данни",
      must_check_one_item:"Трябва да проверите поне един елемент.",
      record:"Запис",
      pick_a_district:"Изберете район",
      enter_address:"Въведете адрес",
      serial_number:"Сериен номер",
      current_value:"Стойност",
      update_message:"Актуализирано от xxx на xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Миниприложението Wechat не можа да бъде отворено в браузъра. Моля, сканирайте QR кода с Wechat",
      select_language_title:"Този QR код поддържа следните езици. Моля, изберете език.",
      geo_restricted:"Този QR код може да се сканира само в зона с ограничен достъп."                                                                                                       
    }
  },
  bs: {
    message: {
      qr_redirect_url :"QR kod će se preusmjeriti na sljedeći URL, možda neće biti siguran:",
      user_or_guest :"QR kod funkcioniše drugačije u zavisnosti od identiteta skenera. Da li ste registrovani korisnik ili gost?",
      input_username :"Unesite korisničko ime",
      input_password :"Unesite lozinku",
      login :"Prijava",
      i_am_a_guest :"Ja sam gost",
      loading_qr :"Učitavanje QR koda...",
      invalid_qr :"Nevažeći QR kod",
      campaign_not_start :"Kampanja QR koda nije počela",
      campaign_end :"Kampanja QR koda je završena",
      subscription_expired :"QR kod je nedostupan, jer je u okviru plana koji je istekao.",
      max_scan_reached :"QR kod je nedostupan, jer je dostignuto maksimalno skeniranje za plan ovog QR koda.",
      password_protected :"QR kod je zaštićen lozinkom, molimo potvrdite lozinku",
      validate :"Potvrdite",
      pleasesave :"Dinamički QR kod ne radi pre nego što se sačuva. Ukoliko vidite ovu stranicu, molimo vas da je sačuvate.",
      invalid_password :"Nevažeća lozinka",
      password_validation_error :"Pojavila se greška prilikom provjere lozinke.",
      invalid_username_password:"Nevažeće korisničko ime ili lozinka.",
      login_error :"Pojavila se greška prilikom prijavljivanja.",
      scan_error :"Pojavila se greška prilikom skeniranja QR koda.",
      powered_by_top_qr :"Podržano od strane TOP QR",
      powered_by_88E :"Podržano od strane TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Idi",
      invalid_operation:"Nevažeća operacija.",
      submit_require_login:"Potrebno je da se logujete da biste dostavili podatke.",
      submit_not_allowed:"Nije vam dozvoljeno da dostavljate podatke.",
      ok:"Ok",
      cancel:"Otkaži",
      download_file:"Preuzimanje",
      download_forbidden:"Zabranjeno",
      phone_number_required:"Prazan broj telefona se ne može birati.",
      email_required:"E-mail adresa je neophodna.",
      email_copied:"E-mail adresa je kopirana.",
      navigation_disabled:"Navigacija je onemogućena.",
      audio_not_support:"Vaš Explorer ne podržava audio tag.",
      video_not_support:"Vaš Explorer ne podržava video tag.",
      unkown:"Nepoznat",
      fail_play_media:"Nije uspjelo reproducirati medije.",
      error_play_media:"Pojavila se greška prilikom reproduciranja medija.",
      wechat_name:"Kliknite da dobijete Wechat ime.",
      form_unavailable_h5:"Kontrola obrasca radi samo sa Wechat miniaplikacijom, molimo vas da ponovo skenirate QR kod pomoću Wechat-a.",
      upload_video:"Upload video.",
      is_required:"je neophodna.",
      cells_required:"Istaknute ćelije su nevažeće.",
      click_sign:"Kliknite da potpišete",
      upload_picture:"Uploaduj sliku",
      enter_number:"Unesite broj",
      enter_name:"Unesite naziv",
      enter_text:"Unesite tekst",
      enter_mobile:"Unesite mobilni",
      welcome_to_top_qr:"Benvenuti su Top QR",
      welcome_to_88E:"Benvenuti su Top QR",
      username_required:"Korisničko ime je neophodno.",
      password_required:"Lozinka je neophodna.",
      signing_in:"Prijavljivanje",
      sign_in:"Prijavi se",
      please_login:"Molim vas prijavite se",
      invalid_user_or_password:"Nevažeće korisničko ime ili lozinka.",
      fail_login:"Nije uspjelo prijavljivanje.",
      enter_location:"Unesite lokaciju",
      enter_id:"Unesite ID",
      enter_employee_number:"Unesite broj zaposlenika",
      male:"Muški",
      female:"Ženski",
      upload_file:"Uploaduj fajl",
      pick_cascade_data:"Odaberi kaskadne podatke",
      must_check_one_item:"Morate da proverite bar jednu stavku.",
      record:"Dosije",
      pick_a_district:"Izaberi okrug",
      enter_address:"Unesite adresu",
      serial_number:"Serijski broj",
      current_value:"Vrijednost",
      update_message:"Ažurirano od strane xxx na xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniaplikacija se ne može otvoriti u pregledniku. Skeniranje QR koda pomoću Wechat-a",
      select_language_title:"Ovaj QR kod podržava sledeće jezike: Molim vas, odaberite jezik.", 
      geo_restricted: "Ovaj QR kod se može skenirati samo u ograničenom području."                                                                                                          
    }
  },
  ca: {
    message: {
      qr_redirect_url :"El codi QR es redirigirà a la següent url, pot ser que no sigui segur:",
      user_or_guest :"El codi QR funciona de manera diferent segons la identitat de l'escàner. Ets un usuari registrat o un convidat?",
      input_username :"Introduïu nom d'usuari",
      input_password :"Introduïu la contrasenya",
      login :"Connexió",
      i_am_a_guest :"Sóc un convidat",
      loading_qr :"Carregant codi QR ...",
      invalid_qr :"Codi QR no vàlid",
      campaign_not_start :"La campanya de codis QR no ha començat",
      campaign_end :"La campanya de codis QR ha finalitzat",
      subscription_expired :"El codi QR no està disponible, perquè està sota un pla que ha caducat.",
      max_scan_reached :"El codi QR no està disponible, ja que s'arriba al màxim d'escaneig permès per al pla d'aquest codi QR.",
      password_protected :"El codi QR està protegit amb contrasenya, valideu la contrasenya",
      validate :"Validar",
      pleasesave :"El QR Code dinàmic no funciona abans de desar-lo. Si veieu aquesta pàgina, deseu-la.",
      invalid_password :"Contrasenya no vàlida",
      password_validation_error :"S'ha produït un error en validar la contrasenya.",
      invalid_username_password:"Nom d'usuari o contrasenya no vàlids.",
      login_error :"S'ha produït un error en iniciar la sessió.",
      scan_error :"S'ha produït un error en escanejar el codi QR.",
      powered_by_top_qr :"Desenvolupat per TOP QR",
      powered_by_88E :"Desenvolupat per TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Anar",
      invalid_operation:"Funcionament no vàlid.",
      submit_require_login:"Heu d'iniciar sessió per enviar dades.",
      submit_not_allowed:"No està permès enviar dades.",
      ok:"D'acord",
      cancel:"Cancel·lar",
      download_file:"Descarregar",
      download_forbidden:"Prohibit",
      phone_number_required:"No es pot marcar el número de telèfon buit.",
      email_required:"L'adreça de correu electrònic és obligatòria.",
      email_copied:"S'ha copiat l'adreça electrònica.",
      navigation_disabled:"La navegació està desactivada.",
      audio_not_support:"L'explorador no admet l'etiqueta d'àudio.",
      video_not_support:"L'explorador no admet l'etiqueta de vídeo.",
      unkown:"Desconegut",
      fail_play_media:"No s'ha pogut reproduir en els mitjans de comunicació.",
      error_play_media:"Es va produir un error mentre es reproduïa als mitjans de comunicació.",
      wechat_name:"Feu clic per obtenir el nom de Wechat.",
      form_unavailable_h5:"El control de formulari només funciona amb Wechat miniapp, si us plau, escaneja el codi QR de nou amb Wechat.",
      upload_video:"Penja vídeo.",
      is_required:"és obligatori.",
      cells_required:"Les cel·les ressaltades no són vàlides.",
      click_sign:"Clica per signar",
      upload_picture:"Pujar imatge",
      enter_number:"Introduïu el número",
      enter_name:"Introduïu el nom",
      enter_text:"Introduïu el text",
      enter_mobile:"Entrar al mòbil",
      welcome_to_top_qr:"Benvingut a TOP QR",
      welcome_to_88E:"Benvingut a TOP QR",
      username_required:"El nom d'usuari és necessari.",
      password_required:"Es requereix contrasenya.",
      signing_in:"Inici de sessió",
      sign_in:"Registra't",
      please_login:"Si us plau, inicieu la sessió",
      invalid_user_or_password:"Nom d'usuari o contrasenya no vàlids.",
      fail_login:"No s'ha pogut iniciar la sessió.",
      enter_location:"Introduïu la ubicació",
      enter_id:"Introduïu l'identificador",
      enter_employee_number:"Introduïu el número d'empleat",
      male:"Mascle",
      female:"Femella",
      upload_file:"Pujar arxiu",
      pick_cascade_data:"Trieu les dades en cascada",
      must_check_one_item:"Heu de comprovar almenys un element.",
      record:"Rècord",
      pick_a_district:"Tria un districte",
      enter_address:"Introduïu l'adreça",
      serial_number:"Número de sèrie",
      current_value:"Valor",
      update_message:"Actualitzat per xxx a xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp no s'ha pogut obrir al navegador. Escaneja el codi QR amb Wechat",
      select_language_title:"Aquest codi QR admet els següents idiomes. Seleccioneu un idioma.", 
      geo_restricted:"Aquest codi QR només es pot escanejar en zona restringida."                                                                                                               
    }
  },
  et: {
    message: {
      qr_redirect_url :"QR-kood suunab järgmisele URL-ile, see ei pruugi olla ohutu:",
      user_or_guest :"QR-kood toimib erinevalt vastavalt skanneri identiteedile. Kas olete registreeritud kasutaja või külaline?",
      input_username :"Sisestage kasutajanimi",
      input_password :"Sisestage parool",
      login :"Login",
      i_am_a_guest :"Olen külaline",
      loading_qr :"QR-koodi laadimine ...",
      invalid_qr :"Kehtetu QR-kood",
      campaign_not_start :"QR-koodi kampaania pole alanud",
      campaign_end :"QR-koodi kampaania on lõppenud",
      subscription_expired :"QR-kood pole saadaval, kuna see on aegunud plaani all.",
      max_scan_reached :"QR-kood pole saadaval, kuna selle QR-koodi plaani jaoks lubatud maksimaalne skannimine on saavutatud.",
      password_protected :"QR-kood on parooliga kaitstud, palun valideerige parool",
      validate :"Kinnitada",
      pleasesave :"Dünaamiline QR-kood ei tööta enne salvestamist. Kui näete seda lehte, salvestage see.",
      invalid_password :"Sobimatu parool",
      password_validation_error :"Parooli valideerimisel ilmnes tõrge.",
      invalid_username_password:"Sobimatu kasutajanimi või parool.",
      login_error :"Sisselogimisel ilmnes tõrge.",
      scan_error :"QR-koodi skannimisel ilmnes viga.",
      powered_by_top_qr :"Toiteallikaks on TOP QR",
      powered_by_88E :"Toiteallikaks on TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Minema",
      invalid_operation:"Kehtetu toiming.",
      submit_require_login:"Andmete esitamiseks peate sisse logima.",
      submit_not_allowed:"Teil ei ole lubatud andmeid esitada.",
      ok:"Ok",
      cancel:"Tühistama",
      download_file:"Alla laadima",
      download_forbidden:"Keelatud",
      phone_number_required:"Tühja telefoninumbrit ei saa valida.",
      email_required:"E-posti aadress on kohustuslik.",
      email_copied:"E-posti aadress kopeeriti.",
      navigation_disabled:"Navigeerimine on keelatud.",
      audio_not_support:"Teie explorer ei toeta helimärgendit.",
      video_not_support:"Teie explorer ei toeta videomärgendit.",
      unkown:"Tundmatu",
      fail_play_media:"Meediat ei õnnestunud mängida.",
      error_play_media:"Meedia esitamisel ilmnes viga.",
      wechat_name:"Wechati nime saamiseks klõpsake.",
      form_unavailable_h5:"Vormi kontroll töötab ainult Wechati minirakendusega, palun skannige QR-kood uuesti Wechatiga.",
      upload_video:"Laadige video üles.",
      is_required:"on vajalik.",
      cells_required:"Esiletõstetud lahtrid on sobimatud.",
      click_sign:"Klõpsake allkirjastamiseks",
      upload_picture:"Laadi pilt üles",
      enter_number:"Sisestage number",
      enter_name:"Sisestage nimi",
      enter_text:"Teksti sisestamine",
      enter_mobile:"Sisene mobiili",
      welcome_to_top_qr:"Tere tulemast TOP QR-i",
      welcome_to_88E:"Tere tulemast TOP QR-i",
      username_required:"Kasutajanimi on kohustuslik.",
      password_required:"Parool on nõutav.",
      signing_in:"Sisselogimine",
      sign_in:"Logi sisse",
      please_login:"Palun logi sisse",
      invalid_user_or_password:"Sobimatu kasutajanimi või parool.",
      fail_login:"Sisselogimine ebaõnnestus.",
      enter_location:"Sisestage asukoht",
      enter_id:"Sisestage ID",
      enter_employee_number:"Sisestage töötaja number",
      male:"Meessoost",
      female:"Emane",
      upload_file:"Laadi fail üles",
      pick_cascade_data:"Kaskaadi andmete valimine",
      must_check_one_item:"Peate kontrollima vähemalt ühte üksust.",
      record:"Rekord",
      pick_a_district:"Valige piirkond",
      enter_address:"Sisestage aadress",
      serial_number:"Seerianumber",
      current_value:"Väärtus",
      update_message:"Uuendatud xxx poolt aadressil xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechati minirakendust ei saanud brauseris avada. Palun skannige QR-kood Wechatiga",
      select_language_title:"See QR-kood toetab järgmisi keeli. Palun valige keel.", 
      geo_restricted:"Seda QR-koodi saab skannida ainult piiratud alal."                                                                                                                     
    }
  },
  he: {
    message: {
      qr_redirect_url :"קוד ה- QR יפנה לכתובת האתר הבאה, ייתכן שהוא לא בטוח:",
      user_or_guest :"קוד ה- QR פועל באופן שונה בהתאם לזהות הסורק. האם אתה משתמש רשום או אורח?",
      input_username :"הזן שם משתמש",
      input_password :"הזן סיסמה",
      login :"כניסה",
      i_am_a_guest :"אני אורח",
      loading_qr :"טוען קוד QR ...",
      invalid_qr :"קוד QR לא חוקי",
      campaign_not_start :"קמפיין קוד QR לא התחיל",
      campaign_end :"קמפיין קוד ה- QR הסתיים",
      subscription_expired :"קוד ה- QR אינו זמין, מכיוון שהוא נמצא תחת תוכנית שפג תוקפה.",
      max_scan_reached :"קוד ה- QR אינו זמין, מכיוון שמגיעים לסריקה המרבית המותרת עבור התוכנית של קוד QR זה.",
      password_protected :"קוד ה- QR מוגן באמצעות סיסמה, אנא אמת את הסיסמה",
      validate :"לאמת",
      pleasesave :"קוד QR דינמי לא עובד לפני שהוא נשמר. אם אתה רואה דף זה, אנא שמור אותו.",
      invalid_password :"סיסמה לא חוקית",
      password_validation_error :"אירעה שגיאה בעת אימות הסיסמה.",
      invalid_username_password:"שם משתמש או סיסמה לא חוקיים.",
      login_error :"אירעה שגיאה בעת הכניסה.",
      scan_error :"אירעה שגיאה בעת סריקת קוד QR.",
      powered_by_top_qr :"מופעל על ידי TOP QR",
      powered_by_88E :"מופעל על ידי TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"הלך",
      invalid_operation:"פעולה לא חוקית.",
      submit_require_login:"אתה נדרש להתחבר כדי לשלוח נתונים.",
      submit_not_allowed:"אינך רשאי לשלוח נתונים.",
      ok:"אוקיי",
      cancel:"ביטל",
      download_file:"הורדה",
      download_forbidden:"אסור",
      phone_number_required:"לא ניתן לחייג למספר טלפון ריק.",
      email_required:'נדרשת כתובת דוא"ל.',
      email_copied:'כתובת הדוא"ל הועתקה.',
      navigation_disabled:"הניווט מושבת.",
      audio_not_support:"הסייר שלך אינו תומך בתג שמע.",
      video_not_support:"הסייר שלך אינו תומך בתג וידאו.",
      unkown:"ידוע",
      fail_play_media:"הפעלת המדיה נכשלה.",
      error_play_media:"אירעה שגיאה בעת הפעלת מדיה.",
      wechat_name:"לחץ כדי לקבל את השם Wechat.",
      form_unavailable_h5:"בקרת טפסים עובדת רק עם Wechat miniapp, אנא סרוק את קוד ה- QR שוב באמצעות Wechat.",
      upload_video:"העלה סרטון.",
      is_required:"נדרש.",
      cells_required:"תאים מסומנים אינם חוקיים.",
      click_sign:"לחץ כדי לחתום",
      upload_picture:"העלה תמונה",
      enter_number:"הזן מספר",
      enter_name:"הזן שם",
      enter_text:"הזן טקסט",
      enter_mobile:"הזן נייד",
      welcome_to_top_qr:"ברוכים הבאים ל- TOP QR",
      welcome_to_88E:"ברוכים הבאים ל- TOP QR",
      username_required:"שם משתמש נדרש.",
      password_required:"נדרשת סיסמה.",
      signing_in:"כניסה",
      sign_in:"הירשם",
      please_login:"אנא התחבר",
      invalid_user_or_password:"שם משתמש או סיסמה לא חוקיים.",
      fail_login:"ההתחברות נכשלה.",
      enter_location:"הזן מיקום",
      enter_id:"הזן מזהה",
      enter_employee_number:"הזן מספר עובד",
      male:"זכר",
      female:"נקבה",
      upload_file:"העלה קובץ",
      pick_cascade_data:"בחירת נתוני מפלים",
      must_check_one_item:"עליך לבדוק לפחות פריט אחד.",
      record:"שיא",
      pick_a_district:"בחר מחוז",
      enter_address:"הזן כתובת",
      serial_number:"מספר סידורי",
      current_value:"ערך",
      update_message:"עודכן על ידי xxx ב xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"לא היתה אפשרות לפתוח miniapp Wechat בדפדפן. אנא סרוק את קוד ה- QR באמצעות Wechat",
      select_language_title:"קוד QR זה תומך בשפות הבאות. אנא בחר שפה.", 
      geo_restricted: "ניתן לסרוק קוד QR זה רק באזור מוגבל."                                                                                                                          
    }
  },
  hy: {
    message: {
      qr_redirect_url :"QR կոդը կվերածվի url-ի, այն կարող է անվտանգ չլինել.",
      user_or_guest :"QR կոդը գործում է այլ կերպ՝ ըստ scanner-ի ինքնության: Դուք գրանցված օգտատեր եք, թե՞ հյուր:",
      input_username :"Մուտքագրեք username",
      input_password :"Մուտքագրեք գաղտնաբառը",
      login :"Մուտք",
      i_am_a_guest :"Ես հյուր եմ",
      loading_qr :"QR կոդի բեռնում ...",
      invalid_qr :"Անվավեր QR կոդը",
      campaign_not_start :"QR կոդի քարոզարշավը չի սկսվել",
      campaign_end :"QR կոդի քարոզարշավն ավարտվել է",
      subscription_expired :"QR կոդը անհասանելի է, քանի որ այն գտնվում է ծրագրի տակ, որի ժամկետը լրացել է:",
      max_scan_reached :"QR կոդը անհասանելի է, քանի որ այս QR կոդի պլանի համար թույլատրված առավելագույն սկալյար է հասնում:",
      password_protected :"QR կոդը գաղտնաբառը պաշտպանված է, խնդրում ենք վավերացնել գաղտնաբառը",
      validate :"Վալիդատի",
      pleasesave :"Դինամիկ QR կոդը չի աշխատում նախքան այն պահելը: Եթե տեսնում եք այս էջը, խնդրում ենք պահպանել այն:",
      invalid_password :"Անվավեր ծածկագիր",
      password_validation_error :"Սխալ է կատարվել գաղտնաբառը վավերացնելու ժամանակ:",
      invalid_username_password:"Անվավեր օգտագործողի անունը կամ գաղտնաբառը:",
      login_error :"Սխալը տեղի է ունեցել մուտք գործելիս:",
      scan_error :"Սխալը տեղի է ունեցել QR կոդը սկան անելիս:",
      powered_by_top_qr :"Powered by TOP QR",
      powered_by_88E :"Powered by TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Գնացեք",
      invalid_operation:"Անվավեր գործողություն:",
      submit_require_login:"Տվյալները ներկայացնելու համար անհրաժեշտ է մուտք գործել:",
      submit_not_allowed:"Ձեզ թույլ չի տրվում ներկայացնել տվյալներ:",
      ok:"Լավ",
      cancel:"Չեղարկել",
      download_file:"Ներբեռնել",
      download_forbidden:"Արգելված է",
      phone_number_required:"Դատարկ հեռախոսահամարը հնարավոր չէ զանգահարել:",
      email_required:"Պահանջվում է էլփոստի հասցե:",
      email_copied:"Էլ. փոստի հասցեն պատճենվել է:",
      navigation_disabled:"Նավագնացությունը հաշմանդամ է:",
      audio_not_support:"Ձեր հետախույզը չի աջակցում աուդիո թեգին:",
      video_not_support:"Ձեր հետախույզը չի աջակցում վիդեո թեգին:",
      unkown:"Անհայտ",
      fail_play_media:"Չհաջողվեց խաղալ մեդիայում:",
      error_play_media:"Սխալ է տեղի ունեցել մեդիայում խաղալիս:",
      wechat_name:"Wechat անունը ստանալու համար սեղմեք:",
      form_unavailable_h5:"Ֆորմատի վերահսկումը աշխատում է միայն Wechat miniapp-ով, խնդրում ենք կրկին սկանավորել QR կոդը Wechat-ով:",
      upload_video:"Վերբեռնեք տեսանյութը:",
      is_required:"պահանջվում է:",
      cells_required:"Ընդգծված բջիջներն անվավեր են:",
      click_sign:"Ստորագրելու համար սեղմեք",
      upload_picture:"Վերբեռնել նկարը",
      enter_number:"Մուտքագրեք համարը",
      enter_name:"Մուտքագրեք անունը",
      enter_text:"Մուտքագրեք տեքստը",
      enter_mobile:"Մտեք շարժական",
      welcome_to_top_qr:"Բարի գալուստ TOP QR",
      welcome_to_88E:"Բարի գալուստ TOP QR",
      username_required:"Պահանջվում է username:",
      password_required:"Պահանջվում է գաղտնաբառ:",
      signing_in:"Ստորագրությունը in",
      sign_in:"Գրանցել",
      please_login:"Խնդրում ենք մուտք գործել",
      invalid_user_or_password:"Անվավեր օգտագործողի անունը կամ գաղտնաբառը:",
      fail_login:"Չհաջողվեց մուտք գործել:",
      enter_location:"Մուտքագրեք տեղանքը",
      enter_id:"Մուտքագրեք ID",
      enter_employee_number:"Մուտքագրեք աշխատողի համարը",
      male:"Արական",
      female:"Իգական",
      upload_file:"Վերբեռնել ֆայլը",
      pick_cascade_data:"Ընտրեք կասկադի տվյալները",
      must_check_one_item:"Դուք պետք է ստուգեք առնվազն մեկ առարկա:",
      record:"Գրանցում",
      pick_a_district:"Ընտրեք շրջան",
      enter_address:"Մուտքագրեք հասցեն",
      serial_number:"Սերիական համարը",
      current_value:"Արժեք",
      update_message:"Xxxx-xx-xx-xx:xx:xx:xx",
      scan_with_wechat:"Wechat miniapp-ը հնարավոր չէր բացել բրաուզերում: Խնդրում ենք սկան անել QR կոդը Wechat-ով",
      select_language_title:"Այս QR կոդը աջակցում է հետեւել լեզուներին: Խնդրում ենք ընտրել որեւէ լեզու:",
      geo_restricted:"Այս QR կոդը կարելի է սկան անել միայն սահմանափակ տարածքում:"                                                                                                                                
    }
  },
  id: {
    message: {
      qr_redirect_url :"Kode QR akan dialihkan ke url berikut, mungkin tidak aman:",
      user_or_guest :"Kode QR berfungsi secara berbeda sesuai dengan identitas pemindai. Apakah Anda pengguna terdaftar atau tamu?",
      input_username :"Masukkan nama pengguna",
      input_password :"Masukkan kata sandi",
      login :"Login",
      i_am_a_guest :"Saya seorang tamu",
      loading_qr :"Memuat kode QR ...",
      invalid_qr :"Kode QR tidak valid",
      campaign_not_start :"Kampanye kode QR belum dimulai",
      campaign_end :"Kampanye kode QR telah berakhir",
      subscription_expired :"Kode QR tidak tersedia, karena berada di bawah paket yang telah kedaluwarsa.",
      max_scan_reached :"Kode QR tidak tersedia, karena pemindaian maksimum yang diizinkan untuk paket kode QR ini tercapai.",
      password_protected :"Kode QR dilindungi kata sandi, harap validasi kata sandi",
      validate :"Memvalidasi",
      pleasesave :"Kode QR Dinamis tidak berfungsi sebelum disimpan. Jika Anda melihat halaman ini, silakan simpan.",
      invalid_password :"Kata sandi tidak valid",
      password_validation_error :"Terjadi kesalahan saat memvalidasi kata sandi.",
      invalid_username_password:"Nama pengguna atau kata sandi tidak valid.",
      login_error :"Terjadi kesalahan saat login.",
      scan_error :"Terjadi kesalahan saat memindai kode QR.",
      powered_by_top_qr :"Didukung oleh TOP QR",
      powered_by_88E :"Didukung oleh TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Pergi",
      invalid_operation:"Operasi tidak valid.",
      submit_require_login:"Anda diharuskan login untuk mengirimkan data.",
      submit_not_allowed:"Anda tidak diizinkan untuk mengirimkan data.",
      ok:"Oke",
      cancel:"Membatalkan",
      download_file:"Mengunduh",
      download_forbidden:"Dilarang",
      phone_number_required:"Nomor telepon kosong tidak dapat dihubungi.",
      email_required:"Alamat email diperlukan.",
      email_copied:"Alamat email disalin.",
      navigation_disabled:"Navigasi dinonaktifkan.",
      audio_not_support:"Penjelajah Anda tidak mendukung tag audio.",
      video_not_support:"Penjelajah Anda tidak mendukung tag video.",
      unkown:"Diketahui",
      fail_play_media:"Gagal memutar media.",
      error_play_media:"Terjadi kesalahan saat memutar media.",
      wechat_name:"Klik untuk mendapatkan nama WeChat.",
      form_unavailable_h5:"Kontrol formulir hanya berfungsi dengan miniapp WeChat, silakan pindai kode QR lagi dengan WeChat.",
      upload_video:"Unggah video.",
      is_required:"diperlukan.",
      cells_required:"Sel yang disorot tidak valid.",
      click_sign:"Klik untuk menandatangani",
      upload_picture:"Unggah gambar",
      enter_number:"Masukkan nomor",
      enter_name:"Masukkan nama",
      enter_text:"Masukkan teks",
      enter_mobile:"Masukkan ponsel",
      welcome_to_top_qr:"Selamat datang di TOP QR",
      welcome_to_88E:"Selamat datang di TOP QR",
      username_required:"Nama pengguna diperlukan.",
      password_required:"Kata sandi diperlukan.",
      signing_in:"Masuk",
      sign_in:"Tandatangan",
      please_login:"Silakan login",
      invalid_user_or_password:"Nama pengguna atau kata sandi tidak valid.",
      fail_login:"Gagal login.",
      enter_location:"Masukkan lokasi",
      enter_id:"Masukkan ID",
      enter_employee_number:"Masukkan nomor karyawan",
      male:"Laki-laki",
      female:"Perempuan",
      upload_file:"Unggah file",
      pick_cascade_data:"Pilih data bertingkat",
      must_check_one_item:"Anda harus memeriksa setidaknya satu item.",
      record:"Rekor",
      pick_a_district:"Pilih distrik",
      enter_address:"Masukkan alamat",
      serial_number:"Nomor seri",
      current_value:"Nilai",
      update_message:"Diperbarui oleh xxx di xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Miniapp WeChat tidak dapat dibuka di browser. Silakan pindai kode QR dengan WeChat",
      select_language_title:"Kode QR ini mendukung bahasa berikut. Silakan pilih bahasa.", 
      geo_restricted:"Kode QR ini hanya dapat dipindai di area terlarang."                                                                                                                                    
    }
  },
  ka: {
    message: {
      qr_redirect_url :"QR კოდი გადამისამართდება შემდეგ url- ზე, ეს შეიძლება არ იყოს უსაფრთხო:",
      user_or_guest :"QR კოდი განსხვავებულად ფუნქციონირებს სკანერის ვინაობის მიხედვით. ხართ რეგისტრირებული მომხმარებელი ან სტუმარი?",
      input_username :"შეიყვანეთ მომხმარებლის სახელი",
      input_password :"შეიყვანეთ პაროლი",
      login :"შესვლა",
      i_am_a_guest :"მე ვარ სტუმარი",
      loading_qr :"QR კოდის ჩატვირთვა ...",
      invalid_qr :"არასწორი QR კოდი",
      campaign_not_start :"QR კოდის კამპანია არ დაწყებულა",
      campaign_end :"QR კოდის კამპანია დასრულდა",
      subscription_expired :"QR კოდი მიუწვდომელია, რადგან ის არის გეგმის ქვეშ, რომელიც ამოიწურა.",
      max_scan_reached :"QR კოდი მიუწვდომელია, რადგან ამ QR კოდის გეგმისთვის დაშვებული მაქსიმალური სკანირება მიღწეულია.",
      password_protected :"QR კოდი არის პაროლი დაცული, გთხოვთ, დაადასტუროთ პაროლი",
      validate :"Validate",
      pleasesave :"დინამიური QR კოდი არ მუშაობს მის შენახვამდე. თუ ხედავთ ამ გვერდს, გთხოვთ შეინახოთ იგი.",
      invalid_password :"არასწორი პაროლი",
      password_validation_error :"პაროლის დადასტურებისას მოხდა შეცდომა.",
      invalid_username_password:"არასწორი მომხმარებლის სახელი ან პაროლი.",
      login_error :"შესვლის დროს მოხდა შეცდომა.",
      scan_error :"QR კოდის სკანირებისას მოხდა შეცდომა.",
      powered_by_top_qr :"პროგრამირება TOP QR",
      powered_by_88E :"პროგრამირება TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"წადი",
      invalid_operation:"არასწორი ოპერაცია.",
      submit_require_login:"მონაცემების გამოსაგზავნად თქვენ უნდა შეხვიდეთ სისტემაში.",
      submit_not_allowed:"თქვენ არ გაქვთ უფლება მონაცემების გაგზავნა.",
      ok:"კარგი",
      cancel:"გაუქმება",
      download_file:"ჩამოტვირთვა",
      download_forbidden:"აკრძალული",
      phone_number_required:"ცარიელი ტელეფონის ნომერი არ შეიძლება აკრიფოთ.",
      email_required:"ელ.ფოსტის მისამართი აუცილებელია.",
      email_copied:"ელექტრონული ფოსტის მისამართი კოპირებულია.",
      navigation_disabled:"ნავიგაცია გამორთულია.",
      audio_not_support:"თქვენი მკვლევარი არ უჭერს მხარს აუდიო ტეგს.",
      video_not_support:"თქვენი მკვლევარი არ უჭერს მხარს ვიდეო ტეგს.",
      unkown:"გაურკვეველი",
      fail_play_media:"ვერ შეძლო მედიის თამაში.",
      error_play_media:"მედიის თამაშის დროს მოხდა შეცდომა.",
      wechat_name:"დააჭირეთ Wechat სახელის მისაღებად.",
      form_unavailable_h5:"ფორმის კონტროლი მუშაობს მხოლოდ Wechat miniapp– ით, გთხოვთ, კვლავ დაასკანიროთ QR კოდი Wechat– ით.",
      upload_video:"ატვირთეთ ვიდეო.",
      is_required:"საჭიროა.",
      cells_required:"ხაზგასმული უჯრედები არასწორია.",
      click_sign:"დააჭირეთ ხელმოწერას",
      upload_picture:"სურათის ატვირთვა",
      enter_number:"შეიყვანეთ ნომერი",
      enter_name:"შეიყვანეთ სახელი",
      enter_text:"შეიყვანეთ ტექსტი",
      enter_mobile:"შეიყვანეთ მობილური",
      welcome_to_top_qr:"კეთილი იყოს თქვენი მობრძანება TOP QR- ში",
      welcome_to_88E:"კეთილი იყოს თქვენი მობრძანება TOP QR- ში",
      username_required:"მომხმარებლის სახელი აუცილებელია.",
      password_required:"პაროლი აუცილებელია.",
      signing_in:"შესვლა",
      sign_in:"სისტემაში შესვლა",
      please_login:"გთხოვთ, შეხვიდეთ",
      invalid_user_or_password:"არასწორი მომხმარებლის სახელი ან პაროლი.",
      fail_login:"შესვლა ვერ მოხერხდა.",
      enter_location:"შეიყვანეთ ადგილმდებარეობა",
      enter_id:"შეიყვანეთ ID",
      enter_employee_number:"მიუთითეთ თანამშრომლის ნომერი",
      male:"მამრობითი",
      female:"ქალი",
      upload_file:"ფაილის დამატება",
      pick_cascade_data:"აირჩიეთ კასკადის მონაცემები",
      must_check_one_item:"თქვენ უნდა შეამოწმოთ მინიმუმ ერთი ნივთი.",
      record:"ჩაწერა",
      pick_a_district:"აირჩიეთ რაიონი",
      enter_address:"შეიყვანეთ მისამართი",
      serial_number:"სერიული ნომერი",
      current_value:"ღირებულება",
      update_message:"განახლებულია xxx xxx ზე xxxx-xx-xx xx: xx: xx",
      scan_with_wechat:"Wechat miniapp ბრაუზერში ვერ გაიხსნა. გთხოვთ, დაასკანიროთ QR კოდი Wechat– ით",
      select_language_title:"ეს QR კოდი მხარს უჭერს შემდეგ ენებს. გთხოვთ აირჩიოთ ენა.",
      geo_restricted:"ამ QR კოდის სკანირება შესაძლებელია მხოლოდ შეზღუდულ ტერიტორიაზე."                                                                                                                                         
    }
  },
  kk: {
    message: {
      qr_redirect_url :"QR коды келесі url мекенжайына қайта бағытталады, ол қауіпсіз болмауы мүмкін:",
      user_or_guest :"QR коды сканердің сәйкестігіне сәйкес басқаша жұмыс істейді. Сіз тіркелген пайдаланушы ма, әлде қонақ па?",
      input_username :"Пайдаланушы атын енгізу",
      input_password :"Құпия сөзді енгізу",
      login :"Кіру",
      i_am_a_guest :"Мен қонақпын",
      loading_qr :"QR кодын жүктеу...",
      invalid_qr :"Жарамсыз QR коды",
      campaign_not_start :"QR код науқаны басталмады",
      campaign_end :"QR код науқаны аяқталды",
      subscription_expired :"QR коды қол жетімді емес, себебі ол мерзімі өткен жоспар бойынша.",
      max_scan_reached :"QR коды қол жетімсіз, себебі осы QR кодының жоспары үшін рұқсат етілген максималды сканерлеуге қол жеткізіледі.",
      password_protected :"QR коды құпия сөзбен қорғалған, құпия сөзді тексеруіңізді сұраймыз",
      validate :"Тексеру",
      pleasesave :"Динамикалық QR коды сақталғанға дейін жұмыс істемейді. Егер осы бетті көрсеңіз, сақтауыңызды өтінемін.",
      invalid_password :"Жарамсыз құпия сөз",
      password_validation_error :"Құпия сөзді тексеру кезінде қате пайда болды.",
      invalid_username_password:"Жарамсыз пайдаланушы аты немесе құпия сөз.",
      login_error :"Кіру кезінде қате пайда болды.",
      scan_error :"QR кодын сканерлеу кезінде қате пайда болды.",
      powered_by_top_qr :"TOP QR арқылы қоректендірілген",
      powered_by_88E :"TOP QR арқылы қоректендірілген",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Go",
      invalid_operation:"Жарамсыз операция.",
      submit_require_login:"Деректерді жіберу үшін кіру қажет.",
      submit_not_allowed:"Сізге деректерді беруге рұқсат етілмейді.",
      ok:"Жақсы",
      cancel:"Болдырмау",
      download_file:"Жүктеу",
      download_forbidden:"Тыйым салынған",
      phone_number_required:"Бос телефон нөмірін теруге болмайды.",
      email_required:"Электрондық пошта мекенжайы қажет.",
      email_copied:"Электрондық пошта мекенжайы көшірілді.",
      navigation_disabled:"Навигация ажыратылады.",
      audio_not_support:"Саяхатшы аудио тегті қолдамайды.",
      video_not_support:"Саяхатшы бейне тегті қолдамайды.",
      unkown:"Беймәлім",
      fail_play_media:"БАҚ ойнай алмадым.",
      error_play_media:"Мультимедиада ойнату кезінде қате пайда болды.",
      wechat_name:"Wechat атауын алу үшін басыңыз.",
      form_unavailable_h5:"Пішінді басқару тек Wechat miniapp-пен жұмыс істейді, QR кодын Wechat көмегімен қайтадан сканерлеуіңізді сұраймыз.",
      upload_video:"Бейнені кері жүктеу.",
      is_required:"талап етіледі.",
      cells_required:"Бөлектелген ұяшықтар жарамсыз.",
      click_sign:"Қол қою үшін басу",
      upload_picture:"Суретті кері жүктеу",
      enter_number:"Нөмірді енгізу",
      enter_name:"Атауын енгізу",
      enter_text:"Мәтінді енгізу",
      enter_mobile:"Мобильді құрылғыны енгізу",
      welcome_to_top_qr:"TOP QR бағдарламасына қош келдіңіз",
      welcome_to_88E:"TOP QR бағдарламасына қош келдіңіз",
      username_required:"Пайдаланушы аты талап етіледі.",
      password_required:"Пароль қажет.",
      signing_in:"Кіру",
      sign_in:"Жүйеге кіру",
      please_login:"Кіруді өтінемін",
      invalid_user_or_password:"Жарамсыз пайдаланушы аты немесе құпия сөз.",
      fail_login:"Кіру жаңылысы.",
      enter_location:"Орынды енгізу",
      enter_id:"ID- ді енгізу",
      enter_employee_number:"Қызметкердің нөмірін енгізу",
      male:"Еркек",
      female:"Әйел",
      upload_file:"Файлды кері жүктеу",
      pick_cascade_data:"Каскад деректерін таңдау",
      must_check_one_item:"Кем дегенде бір элементті тексеру керек.",
      record:"Жазба",
      pick_a_district:"Ауданды таңдау",
      enter_address:"Адресті енгізу",
      serial_number:"Реттік нөмірі",
      current_value:"Мән",
      update_message:"XXX-XXX-XXX кезінде жаңартылған XXX-XX:XX",
      scan_with_wechat:"Wechat miniapp браузерде ашылмады. QR кодын Wechat көмегімен сканерлеуіңізді сұраймын",
      select_language_title:"Бұл QR коды келесі тілдерді қолдайды. Тілді таңдаңыз.",
      geo_restricted:"Бұл QR коды шектелген аумақта ғана сканерлеуге болады."                                                                                                                                              
    }
  },
  lt: {
    message: {
      qr_redirect_url :"QR kodas nukreips į šį URL, jis gali būti nesaugus:",
      user_or_guest :"QR kodas veikia skirtingai, atsižvelgiant į skaitytuvo tapatybę. Ar esate registruotas vartotojas ar svečias?",
      input_username :"Įveskite vartotojo vardą",
      input_password :"Įveskite slaptažodį",
      login :"Prisijungti",
      i_am_a_guest :"Aš esu svečias",
      loading_qr :"Įkeliamas QR kodas ...",
      invalid_qr :"Neteisingas QR kodas",
      campaign_not_start :"QR kodo kampanija neprasidėjo",
      campaign_end :"QR kodo kampanija baigėsi",
      subscription_expired :"QR kodas nepasiekiamas, nes jis yra pagal planą, kurio galiojimo laikas pasibaigęs.",
      max_scan_reached :"QR kodas nepasiekiamas, nes pasiekiamas maksimalus šio QR kodo plano nuskaitymas.",
      password_protected :"QR kodas yra apsaugotas slaptažodžiu, patvirtinkite slaptažodį",
      validate :"Patvirtinti",
      pleasesave :"Dinaminis QR kodas neveikia, kol jis nėra išsaugotas. Jei matote šį puslapį, išsaugokite jį.",
      invalid_password :"Neteisingas slaptažodis",
      password_validation_error :"Tvirtinant slaptažodį įvyko klaida.",
      invalid_username_password:"Neteisingas vartotojo vardas arba slaptažodis.",
      login_error :"Prisijungiant įvyko klaida.",
      scan_error :"Nuskaitant QR kodą įvyko klaida.",
      powered_by_top_qr :"Parengta pagal TOP QR",
      powered_by_88E :"Parengta pagal TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Eiti",
      invalid_operation:"Netinkama operacija.",
      submit_require_login:"Norėdami pateikti duomenis, turite prisijungti.",
      submit_not_allowed:"Jums neleidžiama pateikti duomenų.",
      ok:"Gerai",
      cancel:"Atšaukti",
      download_file:"Atsisiųsti",
      download_forbidden:"Draudžiama",
      phone_number_required:"Negalima rinkti tuščio telefono numerio.",
      email_required:"El. Pašto adresas yra būtinas.",
      email_copied:"El. pašto adresas buvo nukopijuotas.",
      navigation_disabled:"Navigacija išjungta.",
      audio_not_support:"Jūsų naršyklė nepalaiko garso žymos.",
      video_not_support:"Jūsų naršyklė nepalaiko vaizdo įrašo žymos.",
      unkown:"Nežinomas",
      fail_play_media:"Nepavyko paleisti medijos.",
      error_play_media:"Leidžiant laikmeną įvyko klaida.",
      wechat_name:"Spustelėkite, kad gautumėte \"Wechat\" pavadinimą.",
      form_unavailable_h5:"Formos valdymas veikia tik su \"Wechat miniapp\", dar kartą nuskaitykite QR kodą naudodami \"Wechat\".",
      upload_video:"Įkelkite vaizdo įrašą.",
      is_required:"yra būtinas.",
      cells_required:"Paryškinti langeliai yra netinkami.",
      click_sign:"Spustelėkite norėdami pasirašyti",
      upload_picture:"Paveikslėlio nusiuntimas",
      enter_number:"Įveskite numerį",
      enter_name:"Įveskite pavadinimą",
      enter_text:"Teksto įvedimas",
      enter_mobile:"Įeiti į mobilųjį telefoną",
      welcome_to_top_qr:"Sveiki atvykę į TOP QR",
      welcome_to_88E:"Sveiki atvykę į TOP QR",
      username_required:"Vartotojo vardas yra būtinas.",
      password_required:"Slaptažodis yra būtinas.",
      signing_in:"Prisijungimas",
      sign_in:"Prisijungti, prisijunk",
      please_login:"Prašome prisijungti",
      invalid_user_or_password:"Neteisingas vartotojo vardas arba slaptažodis.",
      fail_login:"Nepavyko prisijungti.",
      enter_location:"Įveskite vietą",
      enter_id:"Įveskite ID",
      enter_employee_number:"Įveskite darbuotojo numerį",
      male:"Vyrų",
      female:"Moteris",
      upload_file:"Įkelti failą",
      pick_cascade_data:"Pakopinių duomenų pasirinkimas",
      must_check_one_item:"Turite patikrinti bent vieną elementą.",
      record:"Įrašas",
      pick_a_district:"Pasirinkite rajoną",
      enter_address:"Įveskite adresą",
      serial_number:"Serijos numeris",
      current_value:"Vertė",
      update_message:"Atnaujinta xxx xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp nepavyko atidaryti naršyklėje. Nuskaitykite QR kodą naudodami \"Wechat\".",
      select_language_title:"Šis QR kodas palaiko šias kalbas. Pasirinkite kalbą.",
      geo_restricted:"Šį QR kodą galima nuskaityti tik apribotoje zonoje"                                                                                                                                                   
    }
  },
  lv: {
    message: {
      qr_redirect_url :"QR kods tiks novirzīts uz šādu URL, tas var nebūt drošs:",
      user_or_guest :"QR kods darbojas atšķirīgi atkarībā no skenera identitātes. Vai esat reģistrēts lietotājs vai viesis?",
      input_username :"Ievadiet lietotājvārdu",
      input_password :"Ievadiet paroli",
      login :"Pieteikšanās",
      i_am_a_guest :"Es esmu viesis",
      loading_qr :"QR koda ielāde ...",
      invalid_qr :"Nederīgs QR kods",
      campaign_not_start :"QR koda kampaņa nav sākta",
      campaign_end :"QR koda kampaņa ir beigusies",
      subscription_expired :"QR kods nav pieejams, jo tas ir saskaņā ar plānu, kura derīguma termiņš ir beidzies.",
      max_scan_reached :"QR kods nav pieejams, jo ir sasniegta maksimālā atļautā skenēšana šī QR koda plānam.",
      password_protected :"QR kods ir aizsargāts ar paroli, lūdzu, apstipriniet paroli",
      validate :"Pārbaudītu",
      pleasesave :"Dinamiskais QR kods nedarbojas, pirms tas nav saglabāts. Ja redzat šo lapu, lūdzu, saglabājiet to.",
      invalid_password :"Nederīga parole",
      password_validation_error :"Validējot paroli, radās kļūda.",
      invalid_username_password:"Nederīgs lietotājvārds vai parole.",
      login_error :"Pieteikšanās laikā radās kļūda.",
      scan_error :"Skenējot QR kodu, radās kļūda.",
      powered_by_top_qr :"Darbina TOP QR",
      powered_by_88E :"Darbina TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Iet",
      invalid_operation:"Nederīga darbība.",
      submit_require_login:"Lai iesniegtu datus, jums ir jāpiesakās.",
      submit_not_allowed:"Jums nav atļauts iesniegt datus.",
      ok:"Labi",
      cancel:"Atcelt",
      download_file:"Lejupielādēt",
      download_forbidden:"Aizliegts",
      phone_number_required:"Tukšu tālruņa numuru nevar sastādīt.",
      email_required:"E-pasta adrese ir obligāta.",
      email_copied:"E-pasta adrese tika kopēta.",
      navigation_disabled:"Navigācija ir atspējota.",
      audio_not_support:"Jūsu pētnieks neatbalsta audio tagu.",
      video_not_support:"Jūsu pārlūks neatbalsta video tagu.",
      unkown:"Nepazīstams",
      fail_play_media:"Neizdevās atskaņot multividi.",
      error_play_media:"Atskaņojot datu nesēju, radās kļūda.",
      wechat_name:"Noklikšķiniet, lai iegūtu Wechat vārdu.",
      form_unavailable_h5:"Veidlapu kontrole darbojas tikai ar Wechat miniapp, lūdzu, vēlreiz skenējiet QR kodu ar Wechat.",
      upload_video:"Augšupielādējiet video.",
      is_required:"ir nepieciešams.",
      cells_required:"Iezīmētās šūnas nav derīgas.",
      click_sign:"Noklikšķiniet, lai parakstītu",
      upload_picture:"Augšupielādēt attēlu",
      enter_number:"Ievadiet numuru",
      enter_name:"Ievadiet vārdu",
      enter_text:"Ievadiet tekstu",
      enter_mobile:"Ieiet mobilajā ierīcē",
      welcome_to_top_qr:"Laipni lūdzam TOP QR",
      welcome_to_88E:"Laipni lūdzam TOP QR",
      username_required:"Lietotājvārds ir nepieciešams.",
      password_required:"Parole ir nepieciešama.",
      signing_in:"Pierakstīšanās",
      sign_in:"Pieteikties",
      please_login:"Lūdzu, piesakieties",
      invalid_user_or_password:"Nederīgs lietotājvārds vai parole.",
      fail_login:"Neizdevās pieteikties.",
      enter_location:"Ievadiet atrašanās vietu",
      enter_id:"Ievadiet ID",
      enter_employee_number:"Ievadiet darbinieka numuru",
      male:"Vīriešu",
      female:"Mātīte",
      upload_file:"Augšupielādēt failu",
      pick_cascade_data:"Kaskādes datu izvēle",
      must_check_one_item:"Jums jāpārbauda vismaz viens vienums.",
      record:"Rekords",
      pick_a_district:"Izvēlieties rajonu",
      enter_address:"Ievadiet adresi",
      serial_number:"Sērijas numurs",
      current_value:"Vērtība",
      update_message:"Atjaunināts ar xxx pie xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp nevarēja atvērt pārlūkprogrammā. Lūdzu, skenējiet QR kodu ar Wechat",
      select_language_title:"Šis QR kods atbalsta šādas valodas. Lūdzu, izvēlieties valodu.", 
      geo_restricted:"Šo QR kodu var skenēt tikai ierobežotā zonā."                                                                                                                                                       
    }
  },
  ms: {
    message: {
      qr_redirect_url :"Kod QR akan dialihkan ke url berikut, mungkin tidak selamat:",
      user_or_guest :"Kod QR berfungsi secara berbeza mengikut identiti pengimbas. Adakah anda pengguna berdaftar atau tetamu?",
      input_username :"Masukkan nama pengguna",
      input_password :"Masukkan kata laluan",
      login :"Log masuk",
      i_am_a_guest :"Saya seorang tetamu",
      loading_qr :"Memuatkan kod QR ...",
      invalid_qr :"Kod QR tidak sah",
      campaign_not_start :"Kempen kod QR belum bermula",
      campaign_end :"Kempen kod QR telah berakhir",
      subscription_expired :"Kod QR tidak tersedia, kerana ia berada di bawah rancangan yang telah tamat tempoh.",
      max_scan_reached :"Kod QR tidak tersedia, kerana imbasan maksimum yang dibenarkan untuk rancangan kod QR ini dicapai.",
      password_protected :"Kod QR dilindungi kata laluan, sila sahkan kata laluan",
      validate :"Mengesahkan",
      pleasesave :"Kod QR dinamik tidak berfungsi sebelum disimpan. Jika anda melihat halaman ini, sila simpannya.",
      invalid_password :"Kata laluan tidak sah",
      password_validation_error :"Ralat berlaku semasa mengesahkan kata laluan.",
      invalid_username_password:"Nama pengguna atau kata laluan tidak sah.",
      login_error :"Ralat berlaku semasa logining.",
      scan_error :"Ralat berlaku semasa mengimbas kod QR.",
      powered_by_top_qr :"Dikuasai oleh TOP QR",
      powered_by_88E :"Dikuasai oleh TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Pergi",
      invalid_operation:"Operasi tidak sah.",
      submit_require_login:"Anda dikehendaki log masuk untuk menghantar data.",
      submit_not_allowed:"Anda tidak dibenarkan menghantar data.",
      ok:"Ok",
      cancel:"Batal",
      download_file:"Muat turun",
      download_forbidden:"Dilarang",
      phone_number_required:"Nombor telefon kosong tidak boleh didail.",
      email_required:"Alamat e-mel diperlukan.",
      email_copied:"Alamat e-mel telah disalin.",
      navigation_disabled:"Navigasi dinyahdayakan.",
      audio_not_support:"Penjelajah anda tidak menyokong tag audio.",
      video_not_support:"Penjelajah anda tidak menyokong tag video.",
      unkown:"Tidak diketahui",
      fail_play_media:"Gagal memainkan media.",
      error_play_media:"Ralat berlaku semasa bermain media.",
      wechat_name:"Klik untuk mendapatkan nama Wechat.",
      form_unavailable_h5:"Kawalan borang hanya berfungsi dengan aplikasi mini Wechat, sila imbas kod QR sekali lagi dengan Wechat.",
      upload_video:"Muat naik video.",
      is_required:"diperlukan.",
      cells_required:"Sel yang diserlahkan tidak sah.",
      click_sign:"Klik untuk menandatangani",
      upload_picture:"Muat naik gambar",
      enter_number:"Masukkan nombor",
      enter_name:"Masukkan nama",
      enter_text:"Masukkan teks",
      enter_mobile:"Masukkan telefon bimbit",
      welcome_to_top_qr:"Selamat datang ke TOP QR",
      welcome_to_88E:"Selamat datang ke TOP QR",
      username_required:"Nama pengguna diperlukan.",
      password_required:"Kata laluan diperlukan.",
      signing_in:"Mendaftar masuk",
      sign_in:"Dafar masuk",
      please_login:"Sila log masuk",
      invalid_user_or_password:"Nama pengguna atau kata laluan tidak sah.",
      fail_login:"Gagal log masuk.",
      enter_location:"Masukkan lokasi",
      enter_id:"Masukkan ID",
      enter_employee_number:"Masukkan nombor pekerja",
      male:"Jejaka",
      female:"Perempuan",
      upload_file:"Muat naik fail",
      pick_cascade_data:"Pilih data lata",
      must_check_one_item:"Anda mesti menyemak sekurang-kurangnya satu item.",
      record:"Rekod",
      pick_a_district:"Pilih daerah",
      enter_address:"Masukkan alamat",
      serial_number:"Nombor siri",
      current_value:"Nilai",
      update_message:"Dikemaskini oleh xxx pada xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Aplikasi mini Wechat tidak dapat dibuka dalam penyemak imbas. Sila imbas kod QR dengan Wechat",
      select_language_title:"Kod QR ini menyokong bahasa berikut. Sila pilih bahasa.", 
      geo_restricted:"Kod QR ini hanya boleh diimbas di kawasan larangan."                                                                                                                                                            
    }
  },
  sk: {
    message: {
      qr_redirect_url :"QR kód presmeruje na nasledujúcu adresu URL, nemusí to byť bezpečné:",
      user_or_guest :"QR kód funguje odlišne podľa identity skenera. Ste registrovaný užívateľ alebo hosť?",
      input_username :"Zadajte používateľské meno",
      input_password :"Zadajte heslo",
      login :"Prihlásenie",
      i_am_a_guest :"Som hosť",
      loading_qr :"Načítava sa QR kód ...",
      invalid_qr :"Neplatný QR kód",
      campaign_not_start :"Kampaň s QR kódom sa ešte nezačala",
      campaign_end :"Kampaň s QR kódom sa skončila",
      subscription_expired :"QR kód nie je k dispozícii, pretože je v pláne, ktorého platnosť vypršala.",
      max_scan_reached :"QR kód nie je k dispozícii, pretože sa dosiahne maximálne skenovanie povolené pre plán tohto QR kódu.",
      password_protected :"QR kód je chránený heslom, overte heslo",
      validate :"Overiť",
      pleasesave :"Dynamický QR kód pred uložením nefunguje. Ak sa vám zobrazí táto stránka, uložte ju.",
      invalid_password :"Neplatné heslo",
      password_validation_error :"Pri overovaní hesla sa vyskytla chyba.",
      invalid_username_password:"Neplatné používateľské meno alebo heslo.",
      login_error :"Pri prihlasovaní sa vyskytla chyba.",
      scan_error :"Pri skenovaní QR kódu sa vyskytla chyba.",
      powered_by_top_qr :"Poháňané TOP QR",
      powered_by_88E :"Poháňané TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Ísť",
      invalid_operation:"Neplatná operácia.",
      submit_require_login:"Ak chcete odoslať údaje, musíte sa prihlásiť.",
      submit_not_allowed:"Údaje nie je dovolené odosielať.",
      ok:"Ok",
      cancel:"Zrušiť",
      download_file:"Stiahnuť",
      download_forbidden:"Zakázaný",
      phone_number_required:"Prázdne telefónne číslo nie je možné vytočiť.",
      email_required:"E-mailová adresa je povinná.",
      email_copied:"E-mailová adresa bola skopírovaná.",
      navigation_disabled:"Navigácia je zakázaná.",
      audio_not_support:"Váš prieskumník nepodporuje zvukové značky.",
      video_not_support:"Váš prieskumník nepodporuje značku videa.",
      unkown:"Neznámy",
      fail_play_media:"Nepodarilo sa prehrať médiá.",
      error_play_media:"Pri prehrávaní médií sa vyskytla chyba.",
      wechat_name:"Kliknutím získate názov Wechat.",
      form_unavailable_h5:"Ovládanie formulárov funguje iba s miniaplikáciou Wechat, naskenujte QR kód znova pomocou Wechat.",
      upload_video:"Nahrať video.",
      is_required:"sa vyžaduje.",
      cells_required:"Zvýraznené bunky sú neplatné.",
      click_sign:"Kliknutím sa podpíšete",
      upload_picture:"Nahrať obrázok",
      enter_number:"Zadajte číslo",
      enter_name:"Zadajte názov",
      enter_text:"Zadanie textu",
      enter_mobile:"Zadajte mobil",
      welcome_to_top_qr:"Vitajte v TOP QR",
      welcome_to_88E:"Vitajte v TOP QR",
      username_required:"Vyžaduje sa používateľské meno.",
      password_required:"Vyžaduje sa heslo.",
      signing_in:"Prihlásenie",
      sign_in:"Zaregistrovať sa",
      please_login:"Prihláste sa prosím",
      invalid_user_or_password:"Neplatné používateľské meno alebo heslo.",
      fail_login:"Nepodarilo sa prihlásiť.",
      enter_location:"Zadajte polohu",
      enter_id:"Zadajte ID",
      enter_employee_number:"Zadajte číslo zamestnanca",
      male:"Samec",
      female:"Samica",
      upload_file:"Nahrať súbor",
      pick_cascade_data:"Výber kaskádových údajov",
      must_check_one_item:"Musíte skontrolovať aspoň jednu položku.",
      record:"Rekord",
      pick_a_district:"Vyberte si okres",
      enter_address:"Zadajte adresu",
      serial_number:"Sériové číslo",
      current_value:"Hodnota",
      update_message:"Aktualizované xxx na xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Miniaplikáciu Wechat sa nepodarilo otvoriť v prehliadači. Naskenujte QR kód pomocou Wechat",
      select_language_title:"Tento QR kód podporuje nasledujúce jazyky. Prosím vyberte si jazyk.",
      geo_restricted: "Tento QR kód je možné naskenovať iba v zakázanej oblasti."                                                                                                                                                                  
    }
  },
  sl: {
    message: {
      qr_redirect_url :"QR koda se bo preusmerila na naslednji URL, morda ni varna:",
      user_or_guest :"QR koda deluje drugače glede na identiteto skenerja. Ste registrirani uporabnik ali gost?",
      input_username :"Vnesite uporabniško ime",
      input_password :"Vnesite geslo",
      login :"Prijavo",
      i_am_a_guest :"Jaz sem gostja.",
      loading_qr :"Nalaganje QR kode ...",
      invalid_qr :"Neveljavna QR koda",
      campaign_not_start :"Oglaševalska akcija QR kode se ni začela",
      campaign_end :"Kampanja QR kode se je končala",
      subscription_expired :"QR koda ni na voljo, ker je v skladu z načrtom, ki je potekel.",
      max_scan_reached :"QR koda ni na voljo, ker je dosežen največji dovoljen pregled za načrt te QR kode.",
      password_protected :"QR koda je zaščitena z geslom, preverite geslo",
      validate :"Potrditev",
      pleasesave :"Dinamična QR koda ne deluje, preden je shranjena. Če vidite to stran, jo shranite.",
      invalid_password :"Neveljavno geslo",
      password_validation_error :"Med preverjanjem gesla je prišlo do napake.",
      invalid_username_password:"Neveljavno uporabniško ime ali geslo.",
      login_error :"Med prijavo je prišlo do napake.",
      scan_error :"Med skeniranjem QR kode je prišlo do napake.",
      powered_by_top_qr :"Powered by TOP QR",
      powered_by_88E :"Powered by TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Iti",
      invalid_operation:"Neveljavna operacija.",
      submit_require_login:"Za pošiljanje podatkov se morate prijaviti.",
      submit_not_allowed:"Podatkov ne smete pošiljati.",
      ok:"V redu",
      cancel:"Odpovedati",
      download_file:"Prenesti",
      download_forbidden:"Prepovedan",
      phone_number_required:"Prazne telefonske številke ni mogoče klicati.",
      email_required:"E-poštni naslov je potreben.",
      email_copied:"E-poštni naslov je bil kopiran.",
      navigation_disabled:"Krmarjenje je onemogoceno.",
      audio_not_support:"Vaš raziskovalec ne podpira zvočne oznake.",
      video_not_support:"Vaš raziskovalec ne podpira videooglaske.",
      unkown:"Neznan",
      fail_play_media:"Predvajanje predstavnosti ni uspelo.",
      error_play_media:"Med predvajanjem predstavnosti je prišlo do napake.",
      wechat_name:"Kliknite, če želite dobiti wechat ime.",
      form_unavailable_h5:"Kontrola obrazca deluje samo z Wechat miniapp, prosimo, skenirajte QR kodo znova z Wechat.",
      upload_video:"Naložite videoposnetek.",
      is_required:"zahtevana.",
      cells_required:"Označene celice niso veljavne.",
      click_sign:"Kliknite, če želite podpisati",
      upload_picture:"Nalaganje slike",
      enter_number:"Vnesite številko",
      enter_name:"Vnesite ime",
      enter_text:"Vnesite besedilo",
      enter_mobile:"Vnesite mobilni telefon",
      welcome_to_top_qr:"Dobrodošli v TOP QR",
      welcome_to_88E:"Dobrodošli v TOP QR",
      username_required:"Zahtevano je uporabniško ime.",
      password_required:"Geslo je potrebno.",
      signing_in:"Prijava",
      sign_in:"Prijava",
      please_login:"Prosimo, prijavite se.",
      invalid_user_or_password:"Neveljavno uporabniško ime ali geslo.",
      fail_login:"Prijava ni uspela.",
      enter_location:"Vnesite lokacijo",
      enter_id:"Vnesite ID",
      enter_employee_number:"Vnesite številko zaposlenega",
      male:"Moški",
      female:"Ženska",
      upload_file:"Nalaganje datoteke",
      pick_cascade_data:"Izberi kaskadne podatke",
      must_check_one_item:"Preveriti morate vsaj en element.",
      record:"Rekord",
      pick_a_district:"Izberite okrožje",
      enter_address:"Vnesite naslov",
      serial_number:"Serijska številka",
      current_value:"Vrednost",
      update_message:"Posodobljeno s strani xxx na xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp ni bilo mogoče odpreti v brskalniku. Prosimo, skenirajte QR kodo z Wechat",
      select_language_title:"Ta QR koda podpira naslednje jezike. Izberite jezik.",
      geo_restricted:"To kodo QR je mogoče optično prebrati samo na omejenem območju."                                                                                                                                                                       
    }
  },
  sr: {
    message: {
      qr_redirect_url :"QР кôд ће се преусмерити на следећу УРЛ адресу, можда није безбедан:",
      user_or_guest :"QР кôд функционише другачије у складу са идентитетом скенера. Да ли сте регистровани корисник или гост?",
      input_username :"Унесите корисничко име",
      input_password :"Унесите лозинку",
      login :"Пријављивање",
      i_am_a_guest :"Ја сам гост",
      loading_qr :"Учитавање QР кода ...",
      invalid_qr :"Неважећи QР кôд",
      campaign_not_start :"QР код кампања није почела",
      campaign_end :"Кампања QР кода је завршена",
      subscription_expired :"QР кôд није доступан јер је под планом који је истекао.",
      max_scan_reached :"QР кôд није доступан јер је дозвољено максимално скенирање за план овог QР кода.",
      password_protected :"QР кôд је заштићен лозинком, проверите лозинку",
      validate :"Проверавање",
      pleasesave :"Динамички QР кôд не ради пре него што се сачува. Ако видите ову страницу, сачувајте је.",
      invalid_password :"Неважећа лозинка",
      password_validation_error :"Дошло је до грешке током провере ваљаности лозинке.",
      invalid_username_password:"Неважеће корисничко име или лозинка.",
      login_error :"Дошло је до грешке током пријављивања.",
      scan_error :"Дошло је до грешке током скенирања QР кода.",
      powered_by_top_qr :"Поwеред бy TOP QR",
      powered_by_88E :"Поwеред бy TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Ићи",
      invalid_operation:"Неважећа операција.",
      submit_require_login:"Од вас се захтева да се пријавите да бисте проследили податке.",
      submit_not_allowed:"Није вам дозвољено да прослеђујете податке.",
      ok:"У реду",
      cancel:"Откажи",
      download_file:"Преузимање",
      download_forbidden:"Забрањено",
      phone_number_required:"Није могуће бирати празан телефонски број.",
      email_required:"Потребна је е-адреса.",
      email_copied:"Е -адреса је копирана.",
      navigation_disabled:"Навигација је онемогућена.",
      audio_not_support:"Еxплорер не подржава аудио ознаку.",
      video_not_support:"Еxплорер не подржава видео ознаку.",
      unkown:"Непознат",
      fail_play_media:"Репродукција медија није успела.",
      error_play_media:"Дошло је до грешке током репродукције медија.",
      wechat_name:"Кликните да бисте добили Wецхат име.",
      form_unavailable_h5:"Контрола обрасца функционише само са Wецхат миниаппом, поново скенирајте QР код помоћу Wецхат-а.",
      upload_video:"Отпреми видео.",
      is_required:"је обавезно.",
      cells_required:"Истакнуте ћелије су неважеће.",
      click_sign:"Кликните да бисте потписали",
      upload_picture:"Отпремање слике",
      enter_number:"Унесите број",
      enter_name:"Унесите име",
      enter_text:"Уношење текста",
      enter_mobile:"Унесите мобилни",
      welcome_to_top_qr:"Добродошли у TOP QR",
      welcome_to_88E:"Добродошли у TOP QR",
      username_required:"Потребно је корисничко име.",
      password_required:"Лозинка је обавезна.",
      signing_in:"Пријављивање",
      sign_in:"Упиши се",
      please_login:"Молимо вас да се пријавите",
      invalid_user_or_password:"Неважеће корисничко име или лозинка.",
      fail_login:"Пријављивање није успело.",
      enter_location:"Унесите локацију",
      enter_id:"Унесите ИД",
      enter_employee_number:"Унесите број запосленог",
      male:"Муљкарац",
      female:"Ћенски",
      upload_file:"Отпремање датотеке",
      pick_cascade_data:"Издвајање каскадих података",
      must_check_one_item:"Морате проверити најмање једну ставку.",
      record:"Запис",
      pick_a_district:"Изаберите округ",
      enter_address:"Унесите адресу",
      serial_number:"Серијски број",
      current_value:"Вредност",
      update_message:"Упдатед бy xxx ат xxxx-xx-xx xx:xx:xx:xx",
      scan_with_wechat:"Wецхат миниапп није могао бити отворен у прегледачу. Скенирајте QР код помоћу Wецхата",
      select_language_title:"Овај QР кôд подржава следеће језике. Изаберите језик.",
      geo_restricted:"Овај QР код се може скенирати само у забрањеној области."                                                                                                                                                                            
    }
  },
  tg: {
    message: {
      qr_redirect_url :"Рамзи QR ба URL-и зерин равона мешавад, он метавонад бехатар набошад:",
      user_or_guest :"Рамзи QR вобаста ба шахсияти сканер гуногун кор мекунад. Оё шумо корбари сабтиномшуда ё меҳмон ҳастед?",
      input_username :"Номи корбарро ворид кунед",
      input_password :"Рамзро ворид кунед",
      login :"Даромадан",
      i_am_a_guest :"Ман меҳмон ҳастам",
      loading_qr :"Рамзи QR бор карда мешавад...",
      invalid_qr :"Рамзи QR нодуруст",
      campaign_not_start :"Маъракаи QR-код оғоз нашудааст",
      campaign_end :"Маъракаи рамзи QR ба охир расид",
      subscription_expired :"Рамзи QR дастнорас аст, зеро он дар доираи нақшаи мӯҳлаташ гузаштааст.",
      max_scan_reached :"Рамзи QR дастнорас аст, зеро ҳадди скан барои нақшаи ин рамзи QR дастрас шудааст.",
      password_protected :"Рамзи QR бо парол муҳофизат карда шудааст, лутфан паролро тасдиқ кунед",
      validate :"Тасдиқ кардан",
      pleasesave :"Рамзи динамикӣ QR пеш аз захира кардани он кор намекунад. Агар шумо ин саҳифаро бинед, лутфан онро захира кунед.",
      invalid_password :"Рамзи нодуруст",
      password_validation_error :"Ҳангоми тасдиқи парол хатогӣ рӯй дод.",
      invalid_username_password:"Номи корбар ё парол нодуруст.",
      login_error :"Ҳангоми ворид шудан хатогӣ рӯй дод.",
      scan_error :"Ҳангоми скан кардани коди QR хатогӣ рух дод.",
      powered_by_top_qr :"Аз ҷониби TOP QR таъмин карда шудааст",
      powered_by_88E :"Аз ҷониби TOP QR таъмин карда шудааст",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Бирав",
      invalid_operation:"Амалиёти беэътибор.",
      submit_require_login:"Барои пешниҳоди маълумот аз шумо лозим аст, ки ворид шавед.",
      submit_not_allowed:"Ба шумо иҷозат дода намешавад, ки маълумотро пешниҳод кунед.",
      ok:"Дуруст",
      cancel:"Бекор кардан",
      download_file:"Зеркашӣ кунед",
      download_forbidden:"Манъ",
      phone_number_required:"Рақами телефони холӣ наметавонад занг занад.",
      email_required:"Суроғаи почтаи электронӣ лозим аст.",
      email_copied:"Суроғаи почтаи электронӣ нусхабардорӣ карда шуд.",
      navigation_disabled:"Навигатсия ғайрифаъол аст.",
      audio_not_support:"Тафтиши шумо барчаспҳои аудиоиро дастгирӣ намекунад.",
      video_not_support:"Explorer шумо теги видеоро дастгирӣ намекунад.",
      unkown:"Номаълум",
      fail_play_media:"Навозиши медиа.",
      error_play_media:"Ҳангоми бозӣ кардани медиа хатогӣ рӯй дод.",
      wechat_name:"Барои гирифтани номи Wechat клик кунед.",
      form_unavailable_h5:"Назорати форма танҳо бо miniapp Wechat кор мекунад, лутфан рамзи QR-ро дубора бо Wechat скан кунед.",
      upload_video:"Видеоро бор кунед.",
      is_required:"талаб мешавад.",
      cells_required:"Ячейкаҳои таъкидшуда нодурустанд.",
      click_sign:"Барои имзо клик кунед",
      upload_picture:"Тасвирро бор кунед",
      enter_number:"Рақамро ворид кунед",
      enter_name:"Номро ворид кунед",
      enter_text:"Матн ворид кунед",
      enter_mobile:"Мобилӣ ворид кунед",
      welcome_to_top_qr:"Хуш омадед ба TOP QR",
      welcome_to_88E:"Хуш омадед ба TOP QR",
      username_required:"Номи корбар лозим аст.",
      password_required:"Рамз лозим аст.",
      signing_in:"Воридшавӣ",
      sign_in:"даромад",
      please_login:"Лутфан ворид шавед",
      invalid_user_or_password:"Номи корбар ё парол нодуруст.",
      fail_login:"Ворид шудан натавонист.",
      enter_location:"Ҷойгиршавӣ ворид кунед",
      enter_id:"ID-ро ворид кунед",
      enter_employee_number:"Рақами кормандро ворид кунед",
      male:"Мард",
      female:"Зан",
      upload_file:"Файлро бор кунед",
      pick_cascade_data:"Маълумоти каскадро интихоб кунед",
      must_check_one_item:"Шумо бояд ҳадди аққал як ашёро тафтиш кунед.",
      record:"Сабт кардан",
      pick_a_district:"Ноҳияро интихоб кунед",
      enter_address:"Суроғаро ворид кунед",
      serial_number:"Шумораи пай дар пай",
      current_value:"Арзиш",
      update_message:"Навсозӣ аз ҷониби xxx дар xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"Wechat miniapp дар браузер кушода нашуд. Лутфан рамзи QR-ро бо Wechat скан кунед",
      select_language_title:"Ин рамзи QR забонҳои зеринро дастгирӣ мекунад. Лутфан забонеро интихоб кунед.", 
      geo_restricted:"Ин рамзи QR-ро танҳо дар минтақаи маҳдуд скан кардан мумкин аст."                                                                                                                                                                              
    }
  },
  th: {
    message: {
      qr_redirect_url :"รหัส QR จะเปลี่ยนเส้นทางไปยัง URL ต่อไปนี้ อาจไม่ปลอดภัย:",
      user_or_guest :"คิวอาร์โค้ดทำงานแตกต่างกันไปตามเอกลักษณ์ของเครื่องสแกน คุณเป็นผู้ใช้ที่ลงทะเบียนหรือแขก?",
      input_username :"ป้อนชื่อผู้ใช้",
      input_password :"ใส่รหัสผ่าน",
      login :"เข้าสู่ระบบ",
      i_am_a_guest :"ฉันเป็นแขก",
      loading_qr :"กำลังโหลดคิวอาร์โค้ด ...",
      invalid_qr :"รหัส QR ไม่ถูกต้อง",
      campaign_not_start :"แคมเปญคิวอาร์โค้ดยังไม่เริ่มต้น",
      campaign_end :"แคมเปญรหัส QR สิ้นสุดลงแล้ว",
      subscription_expired :"รหัส QR ไม่สามารถใช้งานได้เนื่องจากอยู่ภายใต้แผนที่หมดอายุ",
      max_scan_reached :"รหัส QR ไม่สามารถใช้งานได้ เนื่องจากถึงจำนวนการสแกนสูงสุดที่อนุญาตสำหรับแผนของรหัส QR นี้แล้ว",
      password_protected :"รหัส QR มีการป้องกันด้วยรหัสผ่าน กรุณาตรวจสอบรหัสผ่าน",
      validate :"ตรวจสอบความถูกต้อง",
      pleasesave :"QR Code แบบไดนามิกใช้งานไม่ได้ก่อนที่จะบันทึก หากคุณเห็นหน้านี้โปรดบันทึก",
      invalid_password :"รหัสผ่านไม่ถูกต้อง",
      password_validation_error :"เกิดข้อผิดพลาดขณะตรวจสอบรหัสผ่าน",
      invalid_username_password:"ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง.",
      login_error :"เกิดข้อผิดพลาดขณะเข้าสู่ระบบ",
      scan_error :"เกิดข้อผิดพลาดขณะสแกนคิวอาร์โค้ด",
      powered_by_top_qr :"ขับเคลื่อนโดย TOP QR",
      powered_by_88E :"ขับเคลื่อนโดย TOP QR",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"ไป",
      invalid_operation:"การดำเนินการไม่ถูกต้อง",
      submit_require_login:"คุณต้องเข้าสู่ระบบเพื่อส่งข้อมูล",
      submit_not_allowed:"คุณไม่ได้รับอนุญาตให้ส่งข้อมูล",
      ok:"ตกลง",
      cancel:"ยกเลิก",
      download_file:"ดาวน์โหลด",
      download_forbidden:"ต้องห้าม",
      phone_number_required:"ไม่สามารถโทรออกหมายเลขโทรศัพท์ที่ว่างเปล่าได้",
      email_required:"ต้องระบุที่อยู่อีเมล",
      email_copied:"ที่อยู่อีเมลถูกคัดลอก",
      navigation_disabled:"การนำทางถูกปิดใช้งาน",
      audio_not_support:"Explorer ของคุณไม่รองรับแท็กเสียง",
      video_not_support:"Explorer ของคุณไม่รองรับแท็กวิดีโอ",
      unkown:"ไม่ทราบ",
      fail_play_media:"ไม่สามารถเล่นสื่อ",
      error_play_media:"เกิดข้อผิดพลาดขณะเล่นสื่อ",
      wechat_name:"คลิกเพื่อรับชื่อ Wechat",
      form_unavailable_h5:"การควบคุมแบบฟอร์มใช้งานได้กับ Wechat miniapp เท่านั้น โปรดสแกนรหัส QR อีกครั้งด้วย Wechat",
      upload_video:"อัปโหลดวิดีโอ",
      is_required:"ต้องระบุ.",
      cells_required:"เซลล์ที่ไฮไลต์ไม่ถูกต้อง",
      click_sign:"คลิกเพื่อลงชื่อ",
      upload_picture:"อัปโหลดรูปภาพ",
      enter_number:"ป้อนหมายเลข",
      enter_name:"ใส่ชื่อ",
      enter_text:"ป้อนข้อความ",
      enter_mobile:"ใส่มือถือ",
      welcome_to_top_qr:"ยินดีต้อนรับสู่ TOP QR",
      welcome_to_88E:"ยินดีต้อนรับสู่ TOP QR",
      username_required:"ต้องระบุชื่อผู้ใช้",
      password_required:"ต้องการรหัสผ่าน.",
      signing_in:"กำลังลงชื่อเข้าใช้",
      sign_in:"เข้าสู่ระบบ",
      please_login:"กรุณาเข้าสู่ระบบ",
      invalid_user_or_password:"ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง.",
      fail_login:"ไม่สามารถเข้าสู่ระบบ",
      enter_location:"ป้อนตำแหน่ง",
      enter_id:"ป้อน ID",
      enter_employee_number:"ป้อนหมายเลขพนักงาน",
      male:"ชาย",
      female:"หญิง",
      upload_file:"อัพโหลดไฟล์",
      pick_cascade_data:"เลือกข้อมูลน้ำตก",
      must_check_one_item:"คุณต้องตรวจสอบอย่างน้อยหนึ่งรายการ",
      record:"บันทึก",
      pick_a_district:"เลือกอำเภอ",
      enter_address:"ป้อนที่อยู่",
      serial_number:"หมายเลขซีเรียล",
      current_value:"ค่า",
      update_message:"อัปเดตโดย xxx ที่ xxxx-xx-xx xx:xx:xx",
      scan_with_wechat:"ไม่สามารถเปิด Wechat miniapp ในเบราว์เซอร์ กรุณาสแกนรหัส QR ด้วย Wechat",
      select_language_title:"รหัส QR นี้รองรับภาษาต่อไปนี้ กรุณาเลือกภาษา", 
      geo_restricted:"รหัส QR นี้สามารถสแกนได้ในพื้นที่หวงห้ามเท่านั้น"                                                                                                                                                                                   
    }
  },
  tr: {
    message: {
      qr_redirect_url :"QR kodu aşağıdaki URL'ye yönlendirecektir, güvenli olmayabilir:",
      user_or_guest :"QR kodu, tarayıcının kimliğine göre farklı şekilde çalışır. Kayıtlı bir kullanıcı mısınız yoksa misafir misiniz?",
      input_username :"Kullanıcı adını girin",
      input_password :"Şifre girin",
      login :"Oturum açma",
      i_am_a_guest :"Ben misafirim",
      loading_qr :"QR kodu yükleniyor ...",
      invalid_qr :"Geçersiz QR kodu",
      campaign_not_start :"QR kod kampanyası başlamadı",
      campaign_end :"QR kod kampanyası sona erdi",
      subscription_expired :"QR kodu kullanılamaz, çünkü süresi dolmuş bir plan altındadır.",
      max_scan_reached :"QR kodu kullanılamaz, çünkü bu QR kodunun planı için izin verilen maksimum taramaya ulaşılmıştır.",
      password_protected :"QR kodu şifre korumalıdır, lütfen şifreyi doğrulayın",
      validate :"Doğrulamak",
      pleasesave :"Dinamik QR Kodu kaydedilmeden önce çalışmaz. Bu sayfayı görürseniz, lütfen kaydedin.",
      invalid_password :"Geçersiz şifre",
      password_validation_error :"Parola doğrulanırken bir hata oluştu.",
      invalid_username_password:"Geçersiz kullanıcı adı veya şifre.",
      login_error :"Oturum açarken bir hata oluştu.",
      scan_error :"QR kodu taranırken bir hata oluştu.",
      powered_by_top_qr :"TOP QR ile güçlendirilmiştir",
      powered_by_88E :"TOP QR ile güçlendirilmiştir",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Gitmek",
      invalid_operation:"Geçersiz işlem.",
      submit_require_login:"Veri göndermek için giriş yapmanız gerekmektedir.",
      submit_not_allowed:"Veri göndermenize izin verilmez.",
      ok:"Tamam",
      cancel:"İptal",
      download_file:"İndirmek",
      download_forbidden:"Yasak",
      phone_number_required:"Boş telefon numarası aranamaz.",
      email_required:"E-posta adresi gereklidir.",
      email_copied:"E-posta adresi kopyalandı.",
      navigation_disabled:"Navigasyon devre dışı.",
      audio_not_support:"Gezgininiz ses etiketini desteklemiyor.",
      video_not_support:"Gezgininiz video etiketini desteklemiyor.",
      unkown:"Bilinmeyen",
      fail_play_media:"Medya oynatılamadı.",
      error_play_media:"Medya yürütülürken bir hata oluştu.",
      wechat_name:"Wechat adını almak için tıklayın.",
      form_unavailable_h5:"Form kontrolü yalnızca Wechat miniapp ile çalışır, lütfen QR kodunu Wechat ile tekrar tarayın.",
      upload_video:"Video yükleyin.",
      is_required:"gereklidir.",
      cells_required:"Vurgulanan hücreler geçersiz.",
      click_sign:"İmzalamak için tıklayın",
      upload_picture:"Resim yükle",
      enter_number:"Numara girin",
      enter_name:"Adı girin",
      enter_text:"Metin girin",
      enter_mobile:"Mobil cihaz girin",
      welcome_to_top_qr:"TOP QR'ye hoş geldiniz",
      welcome_to_88E:"TOP QR'ye hoş geldiniz",
      username_required:"Kullanıcı adı gereklidir.",
      password_required:"Şifre gereklidir.",
      signing_in:"Oturum açma",
      sign_in:"Oturum Aç",
      please_login:"Lütfen giriş yapın",
      invalid_user_or_password:"Geçersiz kullanıcı adı veya şifre.",
      fail_login:"Oturum açılamadı.",
      enter_location:"Konum girin",
      enter_id:"Kimlik girin",
      enter_employee_number:"Çalışan numarasını girin",
      male:"Erkek",
      female:"Dişi",
      upload_file:"Dosya yükle",
      pick_cascade_data:"Kaskad verileri seçme",
      must_check_one_item:"En az bir öğeyi kontrol etmelisiniz.",
      record:"Kayıt",
      pick_a_district:"Bir bölge seçin",
      enter_address:"Adres girin",
      serial_number:"Seri numarası",
      current_value:"Değer",
      update_message:"xxx tarafından xxxx-xx-xx xx:xx:xx tarihinde güncellenmiştir",
      scan_with_wechat:"Wechat mini uygulaması tarayıcıda açılamadı. Lütfen QR kodunu Wechat ile tarayın",
      select_language_title:"Bu QR kodu aşağıdaki dilleri destekler. Lütfen bir dil seçin.", 
      geo_restricted:"Bu QR kodu yalnızca kısıtlı alanda taranabilir."                                                                                                                                                                                        
    }
  },
  uz: {
    message: {
      qr_redirect_url :"QR-kod quyidagi URL manziliga yo'naltiriladi, u xavfsiz bo'lmasligi mumkin:",
      user_or_guest :"QR-kod skanerning shaxsiga ko'ra boshqacha ishlaydi. Siz ro'yxatdan o'tgan foydalanuvchimisiz yoki mehmonmisiz?",
      input_username :"Foydalanuvchi nomini kiriting",
      input_password :"Maxfiy soʻzni kiriting",
      login :"Kirish",
      i_am_a_guest :"Men mehmonman",
      loading_qr :"QR-kod yuklanmoqda ...",
      invalid_qr :"Xato QR-kod",
      campaign_not_start :"QR-kod kampaniyasi boshlanmagan",
      campaign_end :"QR-kod kampaniyasi yakunlandi",
      subscription_expired :"QR-kod mavjud emas, chunki u muddati tugagan reja asosida.",
      max_scan_reached :"QR-kod mavjud emas, chunki ushbu QR-kodning rejasi uchun ruxsat etilgan maksimal skanerga erishiladi.",
      password_protected :"QR kodi parol bilan himoyalangan, iltimos maxfiy soʻzni toʻgʻrilang",
      validate :"Bagʻalau",
      pleasesave :"Dynamic QR Code saqlanmasidan oldin ishlamaydi. Agar siz ushbu sahifani ko'rsangiz, iltimos uni saqlang.",
      invalid_password :"Maxfiy soʻz haqiqiy emas",
      password_validation_error :"Maxfiy soʻzni tekshirishda xato roʻy berdi.",
      invalid_username_password:"Foydalanuvchi yoki maxfiy soʻz haqiqiy emas.",
      login_error :"Roʻyxatdan oʻtayotganda xato roʻy berdi.",
      scan_error :"QR-kodni skanlashda xato roʻy berdi.",
      powered_by_top_qr :"TOP QR bo'yicha quvvatlanadi",
      powered_by_88E :"TOP QR bo'yicha quvvatlanadi",
      title_top_qr :"TOP QR",
      title_88E :"TOP QR",
      go:"Oʻtish",
      invalid_operation:"Xato amal qilish.",
      submit_require_login:"Ma'lumotlarni taqdim etish uchun login qilishingiz talab etiladi.",
      submit_not_allowed:"Ma'lumotlarni topshirishga ruxsat berilmaydi.",
      ok:"Xo'p",
      cancel:"Bekor qilish",
      download_file:"Yuklab olish",
      download_forbidden:"Taqiqlangan",
      phone_number_required:"Bo'sh telefon raqamini terib bo'lmaydi.",
      email_required:"Elektron pochta manzili talab qilinadi.",
      email_copied:"Elektron pochta manzili ko'chirib olindi.",
      navigation_disabled:"Navigatsiya oʻchirilgan.",
      audio_not_support:"Ekskavatoringiz audio tegni qo'llab-quvvatlamaydi.",
      video_not_support:"Ekskavatoringiz video tegini qo'llab-quvvatlamaydi.",
      unkown:"Nomaʼlum",
      fail_play_media:"Media oʻynab boʻlmadi.",
      error_play_media:"Media oynalayotganda xato roʻy berdi.",
      wechat_name:"Wechat nomini olish uchun bosing.",
      form_unavailable_h5:"Form nazorati faqat Wechat miniapp bilan ishlaydi, iltimos, QR-kodni Wechat bilan qayta skanerlang.",
      upload_video:"Video yuklash.",
      is_required:"talab etiladi.",
      cells_required:"Ajratilgan kataklar haqiqiy emas.",
      click_sign:"Imzolash uchun bosing",
      upload_picture:"Rasmni yuklash",
      enter_number:"Raqamni kiriting",
      enter_name:"Nomini kiriting",
      enter_text:"Matnni kiriting",
      enter_mobile:"Mobil kiriting",
      welcome_to_top_qr:"TOP QR ga xush kelibsiz",
      welcome_to_88E:"TOP QR ga xush kelibsiz",
      username_required:"Foydalanuvchi nomi talab qilinadi.",
      password_required:"Maxfiy soʻz talab qilinadi.",
      signing_in:"Kirish kirish",
      sign_in:"Tizimga kiring",
      please_login:"Iltimos, tizimga kiring",
      invalid_user_or_password:"Foydalanuvchi yoki maxfiy soʻz haqiqiy emas.",
      fail_login:"Tizimga kirish muvaffaqiyatsiz tugadi.",
      enter_location:"Manzilni kiriting",
      enter_id:"Identifikatorni kiriting",
      enter_employee_number:"Xodim raqamini kiriting",
      male:"Erkak",
      female:"Ayol",
      upload_file:"Faylni yuklash",
      pick_cascade_data:"Kaskad maʼlumotlarini terish",
      must_check_one_item:"Siz kamida bitta elementni tekshirishingiz kerak.",
      record:"Qayd qilish",
      pick_a_district:"Viloyatni tanlang",
      enter_address:"Manzilni kiriting",
      serial_number:"Seriya raqami",
      current_value:"Qiymat",
      update_message:"xxxx-xx-xx xx:xx:xx da xxx bo'yicha yangilandi",
      scan_with_wechat:"Wechat miniapp brauzerda ochib bo'lmadi. Qr kodni Wechat bilan skanerlang iltimos",
      select_language_title:"Ushbu QR-kod quyidagi tillarni qo'llab-quvvatlaydi. Iltimos tilni tanlang.",
      geo_restricted:"Ushbu QR-kodni faqat cheklangan hududda skanerlash mumkin"                                                                                                                                                                                              
    }
  },
  mn: {
    message: {
      qr_redirect_url:"ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠨᠢ ᠳᠣᠣᠷᠠᠬᠢ ᠰᠦᠯᠵᠢᠶᠡᠨ ᠦ ᠬᠠᠶᠢᠭ ᠲᠤ ᠬᠦᠷᠲᠡᠯ᠎ᠡ ᠬᠠᠨᠳᠤᠵᠤ ᠂ ᠠᠮᠤᠷ ᠲᠦᠪᠰᠢᠨ ᠪᠤᠰᠤ ᠪᠠᠶᠢᠵᠤ ᠮᠡᠳᠡᠨ᠎ᠡ ᠃",
      user_or_guest:"QR ᠨᠣᠮᠧᠷ ᠤᠨ ᠴᠢᠳᠠᠪᠬᠢ ᠨᠢ ᠰᠢᠷᠪᠢᠯᠲᠡ ᠶᠢᠨ ᠪᠠᠭᠠᠵᠢ ᠶᠢᠨ ᠪᠡᠶ᠎ᠡ ᠭᠠᠷᠤᠯ ᠢ ᠦᠨᠳᠦᠰᠦᠯᠡᠨ ᠠᠳᠠᠯᠢ ᠦᠭᠡᠢ ᠃ ᠲᠠ ᠳᠠᠩᠰᠠᠯᠠᠭᠤᠯᠤᠭᠰᠠᠨ ᠬᠡᠷᠡᠭ᠍ᠯᠡᠭ᠍ᠴᠢ ᠶᠤᠮ ᠤᠤ ᠡᠰᠡᠬᠦᠯ᠎ᠡ ᠵᠣᠴᠢᠨ ᠢᠶᠠᠷ ᠰᠤᠷᠪᠤᠯᠵᠢᠯᠠᠬᠤ ᠤᠤ ?",
      input_username:"ᠬᠡᠷᠡᠭᠯᠡᠭᠴᠢ ᠶᠢᠨ ᠨᠡᠷ᠎ᠡ ᠶᠢ ᠣᠷᠣᠭᠤᠯᠤᠨ᠎ᠠ ᠃",
      input_password:"ᠨᠢᠭᠤᠴᠠ ᠨᠣᠮᠧᠷ ᠣᠷᠣᠭᠤᠯᠬᠤ ᠃",
      login:"ᠲᠡᠮᠳᠡᠭ᠍ᠯᠡᠬᠦ ᠃",
      i_am_a_guest:"ᠪᠢ ᠪᠣᠯ ᠵᠣᠴᠢᠨ ᠃",
      loading_qr:"ᠶᠠᠭ ᠬᠤᠶᠠᠷᠲᠤ ᠨᠣᠮᠧᠷ ᠨᠡᠮᠡᠵᠦ ᠁",
      invalid_qr:"ᠬᠦᠴᠦᠨ ᠦᠭᠡᠢ ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠃",
      campaign_not_start:"ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠤᠨ ᠠᠵᠢᠯᠯᠠᠭ᠎ᠠ ᠬᠠᠷᠠᠬᠠᠨ ᠡᠬᠢᠯᠡᠭᠡᠳᠦᠶ ᠪᠠᠶᠢᠭᠰᠠᠭᠠᠷ ᠃",
      campaign_end:"ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠤᠨ ᠠᠵᠢᠯᠯᠠᠭ᠎ᠠ ᠨᠢᠭᠡᠨᠲᠡ ᠳᠠᠭᠤᠰᠴᠠᠢ ᠃",
      subscription_expired:"ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠢ ᠬᠡᠷᠡᠭ᠍ᠯᠡᠵᠦ ᠪᠣᠯᠬᠤ ᠦᠭᠡᠢ ᠂ ᠤᠴᠢᠷ ᠨᠢ ᠲᠡᠷᠡ ᠨᠢᠭᠡᠨᠲᠡ ᠬᠤᠭᠤᠴᠠᠭ᠎ᠠ ᠨᠢ ᠬᠡᠲᠦᠷᠡᠭ᠍ᠰᠡᠨ ᠲᠥᠯᠥᠪᠯᠡᠭᠡ ᠳᠣᠣᠷ᠎ᠠ ᠪᠠᠢ᠌ᠨ᠎ᠠ ᠃",
      max_scan_reached:"QR ᠨᠣᠮᠧᠷ ᠢ ᠬᠡᠷᠡᠭ᠍ᠯᠡᠵᠦ ᠪᠣᠯᠬᠤ ᠦᠭᠡᠢ ᠂ ᠤᠴᠢᠷ ᠨᠢ ᠨᠢᠭᠡᠨᠲᠡ ᠡᠨᠡ QR ᠨᠣᠮᠧᠷ ᠤᠨ ᠲᠥᠯᠥᠪᠯᠡᠭᠡ ᠶᠢᠨ ᠵᠥᠪᠰᠢᠶᠡᠷᠡᠭ᠍ᠰᠡᠨ ᠬᠠᠮᠤᠭ ᠶᠡᠬᠡ ᠰᠢᠷᠪᠢᠯᠲᠡ ᠶᠢᠨ ᠤᠳᠠᠭ᠎ᠠ ᠳᠤ ᠬᠦᠷᠴᠡᠢ ᠃",
      not_allowed:"ᠲᠠ ᠡᠨᠡ ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠢ ᠰᠤᠷᠪᠤᠯᠵᠢᠯᠠᠵᠤ ᠪᠣᠯᠬᠤ ᠦᠭᠡᠢ᠃",
      qr_closed:"ᠡᠨᠡ ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠨᠢᠭᠡᠨᠲᠡ ᠬᠠᠭᠠᠭᠳᠠᠵᠠᠢ ᠃",
      password_protected:"ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠨᠢ ᠨᠢᠭᠤᠴᠠ ᠨᠣᠮᠧᠷ ᠢ ᠬᠠᠮᠠᠭᠠᠯᠠᠭᠠᠷᠠᠢ ᠂ ᠨᠢᠭᠤᠴᠠ ᠨᠣᠮᠧᠷ ᠢ ᠰᠢᠯᠭᠠᠨ ᠭᠡᠷᠡᠴᠢᠯᠡᠵᠦ ᠦᠵᠡᠭᠡᠷᠡᠢ ᠃",
      validate:"ᠮᠣᠣᠳ᠋ ᠃",
      pleasesave:"ᠬᠥᠳᠡᠯᠦᠩᠭᠦᠶ ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠢ ᠬᠠᠳᠠᠭᠠᠯᠠᠬᠤ ᠠᠴᠠ ᠡᠮᠦᠨ᠎ᠡ ᠦᠢᠯᠡᠳᠦᠯ ᠭᠠᠷᠭᠠᠵᠤ ᠳᠡᠶᠢᠯᠬᠦ ᠦᠭᠡᠢ ᠃ ᠬᠡᠷᠪᠡ ᠲᠠ ᠡᠨᠡ ᠨᠢᠭᠤᠷ ᠢ ᠣᠯᠵᠤ ᠦᠵᠡᠪᠡᠯ ᠲᠡᠭᠦᠨ ᠢ ᠬᠠᠳᠠᠭᠠᠯᠠᠵᠤ ᠦᠵᠡᠭᠡᠷᠡᠢ ᠃",
      invalid_password:"ᠨᠢᠭᠤᠴᠠ ᠨᠣᠮᠧᠷ ᠨᠢ ᠬᠦᠴᠦᠨ ᠦᠭᠡᠢ ᠃",
      password_validation_error:"ᠨᠢᠭᠤᠴᠠ ᠨᠣᠮᠧᠷ ᠢ ᠰᠢᠯᠭᠠᠨ ᠭᠡᠷᠡᠴᠢᠯᠡᠬᠦ ᠦᠶ᠎ᠡ ᠳᠦ ᠪᠤᠷᠤᠭᠤ ᠭᠠᠷᠭᠠᠨ᠎ᠠ ᠃",
      invalid_username_password:"ᠬᠡᠷᠡᠭᠯᠡᠭᠴᠢ ᠶᠢᠨ ᠨᠡᠷ᠎ᠡ ᠪᠤᠶᠤ ᠨᠢᠭᠤᠴᠠ ᠨᠣᠮᠧᠷ ᠨᠢ ᠬᠦᠴᠦᠨ ᠦᠭᠡᠢ᠃",
      login_error:"ᠲᠡᠮᠳᠡᠭ᠍ᠯᠡᠬᠦ ᠦᠶ᠎ᠡ ᠳᠦ ᠪᠤᠷᠤᠭᠤ ᠭᠠᠷᠤᠨ᠎ᠠ ᠃",
      scan_error:"ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠰᠢᠷᠪᠢᠬᠦ ᠦᠶ᠎ᠡ ᠳᠦ ᠪᠤᠷᠤᠭᠤ ᠭᠠᠷᠤᠨ᠎ᠠ ᠃",
      powered_by_top_qr:"TOP QR ᠳᠡᠮᠵᠢᠯᠭᠡ ᠬᠠᠩᠭᠠᠨ᠎ᠠ ᠃",
      powered_by_88E:"TOP QR ᠳᠡᠮᠵᠢᠯᠭᠡ ᠬᠠᠩᠭᠠᠨ᠎ᠠ ᠃",
      title_top_qr:"TOP QR",
      title_88E:"TOP QR",
      go:"ᠣᠴᠢᠨ᠎ᠠ᠃",
      invalid_operation:"ᠬᠦᠴᠦᠨ ᠦᠭᠡᠢ ᠠᠵᠢᠯᠯᠠᠭᠤᠯᠬᠤ",
      submit_require_login:"ᠲᠠ ᠲᠡᠮᠳᠡᠭ᠍ᠯᠡᠪᠡᠯ ᠰᠠᠶ ᠢ ᠲᠣᠭ᠎ᠠ ᠪᠠᠷᠢᠮᠲᠠ ᠪᠠᠨ ᠲᠤᠰᠢᠶᠠᠵᠤ ᠳᠡᠢ᠌ᠯᠦᠨ᠎ᠡ᠃",
      submit_not_allowed:"ᠲᠠ ᠲᠣᠭ᠎ᠠ ᠪᠠᠷᠢᠮᠲᠠ ᠪᠠᠨ ᠲᠤᠰᠢᠶᠠᠵᠤ ᠪᠣᠯᠬᠤ ᠦᠭᠡᠢ᠃",
      ok:"ᠪᠠᠰᠠ ᠪᠣᠯᠣᠨ᠎ᠠ ᠃",
      cancel:"ᠬᠦᠴᠦᠨ ᠦᠭᠡᠶ ᠪᠣᠯᠭᠠᠨ᠎ᠠ᠃",
      download_file:"ᠪᠠᠭᠤᠯᠭᠠᠨ᠎ᠠ ᠃",
      download_forbidden:"ᠴᠠᠭᠠᠵᠠᠯᠠᠨ᠎ᠠ",
      phone_number_required:"ᠬᠣᠭᠣᠰᠣᠨ ᠤᠲᠠᠰᠤᠨ ᠤ ᠨᠣᠮᠧᠷ ᠢ ᠤᠲᠠᠰᠤᠳᠠᠬᠤ ᠶᠢᠨ ᠠᠷᠭ᠎ᠠ ᠦᠭᠡᠢ ᠃",
      email_required:"ᠡᠯᠧᠺᠲ᠋ᠷᠣᠨ ᠰᠢᠤᠳᠠᠨ ᠤ ᠬᠠᠶᠢᠭ ᠨᠢ ᠵᠠᠪᠠᠯ ᠲᠠᠭᠯᠠᠬᠤ ᠵᠦᠢᠯ ᠪᠣᠯᠣᠨ᠎ᠠ ᠃",
      email_copied:"ᠡᠯᠧᠺᠲ᠋ᠷᠣᠨ ᠰᠢᠤᠳᠠᠨ ᠤ ᠬᠠᠶᠢᠭ ᠢ ᠨᠢᠭᠡᠨᠲᠡ ᠪᠠᠭᠤᠯᠭᠠᠵᠠᠢ ᠃",
      navigation_disabled:"ᠵᠠᠮᠴᠢᠯᠠᠭᠴᠢ ᠨᠢᠭᠡᠨᠲᠡ ᠴᠠᠭᠠᠵᠠᠯᠠᠵᠠᠢ ᠃",
      audio_not_support:"ᠲᠠᠨ ᠤ ᠦᠵᠡᠭᠦᠯᠦᠭᠦᠷ ᠳᠠᠭᠤᠨ ᠤ ᠳᠠᠪᠲᠠᠮᠵᠢ ᠶᠢᠨ ᠲᠡᠮᠳᠡᠭ᠍ ᠢ ᠳᠡᠮᠵᠢᠬᠦ ᠦᠭᠡᠢ ᠃",
      video_not_support:"ᠲᠠᠨ ᠤ ᠦᠵᠡᠭᠦᠯᠦᠭᠦᠷ ᠬᠠᠷᠠᠭᠠᠨ ᠳᠠᠪᠲᠠᠮᠵᠢ ᠶᠢᠨ ᠲᠡᠮᠳᠡᠭ ᠢ ᠳᠡᠮᠵᠢᠬᠦ ᠦᠭᠡᠢ ᠃",
      unkown:"ᠮᠡᠳᠡᠬᠦ ᠦᠭᠡᠢ ᠃",
      fail_play_media:"ᠵᠠᠭᠤᠴᠢᠯᠠᠭᠤᠷ ᠨᠡᠪᠲᠡᠷᠡᠭᠦᠯᠬᠦ ᠶᠢᠨ ᠠᠷᠭ᠎ᠠ ᠦᠭᠡᠢ ᠃",
      error_play_media:"ᠵᠠᠭᠤᠴᠢᠯᠠᠭᠤᠷ ᠨᠡᠪᠲᠡᠷᠡᠭᠦᠯᠬᠦ ᠦᠶ᠎ᠡ ᠳᠦ ᠪᠤᠷᠤᠭᠤ ᠭᠠᠷᠭᠠᠨ᠎ᠠ ᠃",
      wechat_name:"ᠸᠢᠴᠠᠲ ᠤᠨ ᠨᠡᠷᠡᠶᠢᠳᠦᠯ ᠢ ᠳᠠᠭᠤᠳᠠᠨ ᠣᠯᠵᠤ",
      form_unavailable_h5:"ᠬᠦᠰᠦᠨᠦᠭᠲᠦ ᠶᠢᠨ ᠬᠠᠭᠤᠳᠠᠰᠤ ᠶᠢ ᠡᠵᠡᠮᠳᠡᠬᠦ ᠨᠢ ᠵᠥᠪᠬᠡᠨ ᠸᠢᠴᠠᠲ ᠤᠨ ᠵᠢᠵᠢᠭ ᠫᠷᠤᠭ᠍ᠷᠠᠮ ᠳᠤ ᠲᠣᠬᠢᠷᠠᠨ᠎ᠠ ᠂ ᠸᠢᠴᠠᠲ ᠢᠶᠠᠷ ᠳᠠᠬᠢᠨ ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠰᠢᠷᠪᠢᠵᠦ ᠥᠭᠭᠦᠭᠡᠷᠡᠢ ᠃",
      upload_video:"ᠬᠠᠷᠠᠭᠠᠨ ᠳᠠᠪᠲᠠᠮᠵᠢ ᠶᠢ ᠳᠡᠭᠡᠭ᠍ᠰᠢ ᠳᠠᠮᠵᠢᠭᠤᠯᠬᠤ",
      is_required:"ᠵᠠᠪᠠᠯ ᠬᠡᠷᠡᠭ᠍ᠴᠡᠭᠡ ᠲᠡᠢ ᠶᠠᠪᠤᠳᠠᠯ ᠃",
      cells_required:"ᠲᠣᠪᠣᠶᠢᠮ᠎ᠠ ᠢᠯᠡᠷᠡᠭᠦᠯᠦᠭᠰᠡᠨ ᠨᠢᠭᠡᠴᠢ ᠨᠢ ᠬᠦᠴᠦᠨ ᠦᠭᠡᠢ ᠃",
      click_sign:"ᠭᠠᠷ ᠤᠨ ᠦᠰᠦᠭ᠍ ᠵᠢᠷᠤᠵᠤ",
      upload_picture:"ᠵᠢᠷᠤᠭ ᠢ ᠳᠡᠭᠡᠭ᠍ᠰᠢ ᠳᠠᠮᠵᠢᠭᠤᠯᠤᠶ᠎ᠠ",
      enter_number:"ᠲᠣᠭ᠎ᠠ ᠶᠢ ᠣᠷᠣᠭᠤᠯᠬᠤ",
      enter_name:"ᠨᠡᠷᠡᠶᠢᠳᠦᠯ ᠢ ᠣᠷᠣᠭᠤᠯᠬᠤ",
      enter_text:"ᠪᠢᠴᠢᠭ᠌ ᠣᠷᠣᠭᠤᠯᠬᠤ",
      enter_mobile:"ᠭᠠᠷ ᠤᠲᠠᠰᠤᠨ ᠳᠤ ᠣᠷᠣᠵᠤ",
      welcome_to_top_qr:"TOP QR ᠳᠤ ᠢᠷᠡᠬᠦ ᠶᠢ ᠪᠠᠶᠠᠷᠯᠠᠨ ᠤᠭᠲᠤᠨ᠎ᠠ ᠃",
      welcome_to_88E:"TOP QR ᠳᠤ ᠢᠷᠡᠬᠦ ᠶᠢ ᠪᠠᠶᠠᠷᠯᠠᠨ ᠤᠭᠲᠤᠨ᠎ᠠ ᠃",
      username_required:"ᠬᠡᠷᠡᠭᠯᠡᠭᠴᠢ ᠶᠢᠨ ᠨᠡᠷ᠎ᠡ ᠨᠢ ᠵᠠᠪᠠᠯ ᠲᠠᠭᠯᠠᠬᠤ ᠵᠦᠢᠯ ᠭᠡᠵᠦ ᠨᠡᠷᠡᠯᠡᠳᠡᠭ ᠃",
      password_required:"ᠨᠢᠭᠤᠴᠠ ᠨᠣᠮᠧᠷ ᠪᠣᠯ ᠴᠢᠬᠤᠯᠠ ᠲᠠᠢ ᠶᠤᠮ ᠃",
      signing_in:"ᠲᠡᠮᠳᠡᠭ᠍ᠯᠡᠬᠦ ᠃",
      sign_in:"ᠲᠡᠮᠳᠡᠭ᠍ᠯᠡᠬᠦ ᠃",
      please_login:"ᠲᠡᠮᠳᠡᠭ᠍ᠯᠡᠭᠡᠷᠡᠢ ᠃",
      invalid_user_or_password:"ᠬᠡᠷᠡᠭᠯᠡᠭᠴᠢ ᠶᠢᠨ ᠨᠡᠷ᠎ᠡ ᠪᠤᠶᠤ ᠨᠢᠭᠤᠴᠠ ᠨᠣᠮᠧᠷ ᠨᠢ ᠬᠦᠴᠦᠨ ᠦᠭᠡᠢ᠃",
      fail_login:"ᠲᠡᠮᠳᠡᠭ᠍ᠯᠡᠯ ᠢᠯᠠᠭᠳᠠᠵᠠᠢ ᠃",
      enter_location:"ᠣᠷᠣᠭᠤᠯᠬᠤ ᠪᠠᠶᠢᠷᠢ ᠃",
      enter_id:"ID ᠶᠢ ᠣᠷᠣᠭᠤᠯᠬᠤ ᠃",
      enter_employee_number:"ᠠᠵᠢᠯᠲᠠᠨ ᠠᠵᠢᠯᠴᠢᠨ ᠤ ᠳ᠋ᠤᠭᠠᠷ ᠢ ᠣᠷᠣᠭᠤᠯᠤᠨ᠎ᠠ ᠃",
      male:"ᠡᠷᠡᠯᠬᠡᠭ᠌ ᠃",
      female:"ᠡᠮᠡᠭᠲᠡᠢ ᠃",
      upload_file:"ᠪᠢᠴᠢᠭ᠌ ᠮᠠᠲ᠋ᠧᠷᠢᠶᠠᠯ ᠢ ᠳᠡᠭᠡᠭ᠍ᠰᠢ ᠳᠠᠮᠵᠢᠭᠤᠯᠬᠤ",
      pick_cascade_data:"ᠱᠠᠲᠤᠨ ᠤ ᠬᠣᠯᠪᠣᠭᠠᠲᠤ ᠲᠣᠭ᠎ᠠ ᠪᠠᠷᠢᠮᠲᠠ ᠶᠢ ᠰᠣᠩᠭᠣᠨ᠎ᠠ ᠃",
      must_check_one_item:"ᠲᠠ ᠡᠷᠬᠡᠪᠰᠢ ᠠᠳᠠᠭ ᠲᠠᠭᠠᠨ ᠨᠢᠭᠡ ᠫᠷᠤᠭ᠌ᠷᠠᠮ ᠪᠠᠢ᠌ᠴᠠᠭᠠᠬᠤ ᠬᠡᠷᠡᠭ᠍ᠲᠡᠢ᠃",
      record:"ᠲᠡᠮᠳᠡᠭᠯᠡᠯ ᠃",
      pick_a_district:"ᠨᠢᠭᠡ ᠭᠠᠵᠠᠷ ᠣᠷᠣᠨ ᠢ ᠰᠣᠩᠭᠣᠨ᠎ᠠ ᠃",
      enter_address:"ᠬᠠᠶᠢᠭ ᠢ ᠣᠷᠣᠭᠤᠯᠬᠤ ᠃",
      serial_number:"ᠳᠡᠰ ᠳᠠᠷᠠᠭᠠᠯᠠᠯ ᠤᠨ ᠨᠣᠮᠧᠷ ᠃",
      current_value:"ᠦᠨ᠎ᠡ ᠥᠷᠲᠡᠭ᠍ ᠃",
      update_message:"xxx ᠡᠴᠡ xxxx-xx-xx xx xx ᠳᠤ ᠰᠢᠨᠡᠳᠭᠡᠨ᠎ᠡ ᠃",
      scan_with_wechat:"ᠸᠢᠴᠠᠲ ᠤᠨ ᠵᠢᠵᠢᠭ ᠫᠷᠤᠭ᠍ᠷᠠᠮ ᠨᠢ ᠦᠵᠡᠭᠦᠯᠦᠭᠴᠢ ᠶᠢᠨ ᠳᠤᠮᠳᠠ ᠨᠡᠭᠡᠭᠡᠵᠦ ᠳᠡᠶᠢᠯᠬᠦ ᠦᠭᠡᠢ ᠃ ᠸᠢᠴᠠᠲ ᠢᠶᠠᠷ ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠰᠢᠷᠪᠢᠭᠡᠷᠡᠢ ᠃",
      select_language_title:"ᠡᠨᠡ ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠨᠢ ᠳᠣᠣᠷᠠᠬᠢ ᠬᠡᠯᠡ ᠶᠢ ᠳᠡᠮᠵᠢᠨ᠎ᠡ ᠃ ᠨᠢᠭᠡ ᠵᠦᠢᠯ ᠦᠨ ᠬᠡᠯᠡ ᠶᠢ ᠰᠣᠩᠭᠣᠭᠠᠷᠠᠢ ᠃",
      geo_restricted:"ᠡᠨᠡ ᠬᠣᠶᠠᠷ ᠨᠣᠮᠧᠷ ᠨᠢ ᠵᠥᠪᠬᠡᠨ ᠬᠢᠵᠠᠭᠠᠷᠯᠠᠬᠤ ᠣᠷᠣᠨ ᠳᠤ ᠰᠢᠷᠪᠢᠯᠲᠡ ᠬᠢᠵᠦ ᠳᠡᠶᠢᠯᠦᠨ᠎ᠡ ᠃"                                                                                                                                                                                                         
    }
  },
  bo: {
    message: {
      qr_redirect_url:"ཨང་གཉིས་པ་དེ་གཙོ་བོ་གཤམ་གྱི་དྲ་ཚིགས་སུ་གཏན་འཁེལ་བྱས་ནས་བདེ་འཇགས་མིན་པ་འདྲ།",
      user_or_guest:"QRཡི་བྱེད་ནུས་ནི་བཤེར་ཆས་ཀྱི་ཐོབ་ཐང་གཞིར་བཟུང་ནས་མི་འདྲ་བ་ཡིན། ཁྱེད་རང་ཐོ་འགོད་བྱེད་མཁན་ཡིན་ནམ་འཚམས་འདྲི་ཞུ་མཁན་ཡིན།",
      input_username:"བེད་སྤྱོད་བྱེད་མཁན་གྱི་མིང་ནང་འཇུག་བྱེད་པ།",
      input_password:"གསང་གྲངས་ནང་འཇུག་བྱེད་པ།",
      login:"ཐོ་རུ་བཀོད་པ།",
      i_am_a_guest:"ང་ནི་མགྲོན་པོ་ཡིན།",
      loading_qr:"ད་ལྟ་རྩ་གཉིས་ཀྱི་ཨང་གྲངས་སྣོན་བཞིན་ཡོད།",
      invalid_qr:"རྩིས་འགྲོ་མེད་པའི་ཨང་གཉིས་པ།",
      campaign_not_start:"གཉིས་ཨང་གཉིས་པའི་བྱེད་སྒོ་ད་དུང་འགོ་ཚུགས་མེད།",
      campaign_end:"ཨང་གཉིས་པའི་བྱེད་སྒོ་མཇུག་འགྲིལ་ཟིན་པ་རེད",
      subscription_expired:"རྩ་གཉིས་ཨང་གྲངས་བཀོལ་མི་རུང་། རྒྱུ་མཚན་ནི་དེ་དུས་ལས་ཡོལ་ཟིན་པའི་འཆར་གཞིའི་འོག་ཏུ་གནས་པས་རེད།",
      max_scan_reached:"QRཡིས་བཀོལ་སྤྱོད་བྱེད་མི་རུང་། རྒྱུ་མཚན་ནི་QRཡི་འཆར་གཞིར་བཀོད་པའི་བཤར་ཕབ་ཐེངས་གྲངས་ཆེ་ཤོས་ལ་སླེབས་ཡོད་པས་རེད།",
      not_allowed:"ཁྱེད་རང་གིས་དོན་ཚན་འདི་གཉིས་ལ་འཚམས་འདྲི་བྱས་མི་ཆོག།",
      qr_closed:"དེ་གཉིས་ཀྱི་ཨང་གྲངས་སྒོ་བརྒྱབ་ཟིན།",
      password_protected:"ཨང་གཉིས་པར་གསང་བའི་སྲུང་སྐྱོབ་ཐོབ་པས་གསང་གྲངས་ལ་ཚོད་ལྟས་ར་སྤྲོད་གནང་རོགས།",
      validate:"驗證།།",
      pleasesave:"འགུལ་རྣམ་གཉིས་ཀྱིས་ཉར་ཚགས་མ་བྱས་གོང་ལ་ནུས་པ་འདོན་མི་ཐུབ། གལ་ཏེ་ཁྱེད་ཀྱིས་ཤོག་ངོས་འདི་མཐོང་ན་དེ་ཉར་ཚགས་བྱེད་རོགས།",
      invalid_password:"གསང་བ་རྩིས་འགྲོ་མེད།",
      password_validation_error:"གསང་བ་ཚོད་ལྟས་ར་སྤྲོད་བྱེད་སྐབས་ནོར་འཁྲུལ་བྱུང་བ།",
      invalid_username_password:"སྤྱོད་མཁན་གྱི་མིང་ངམ་གསང་གྲངས་རྩིས་འགྲོ་མེད།",
      login_error:"ཐོ་འགོད་བྱེད་སྐབས་ནོར་འཁྲུལ་བྱུང་བ།",
      scan_error:"དོན་ཚན་ཉིས་བརྒྱ་དང་གཉིས་པའི་སྐབས་སུ་ནོར་འཁྲུལ་བྱུང་བ།",
      powered_by_top_qr:"TOP QR ་རྒྱབ་སྐྱོར་འདོན་སྤྲོད་བྱ།",
      powered_by_88E:"TOP QR ་རྒྱབ་སྐྱོར་འདོན་སྤྲོད་བྱ།",
      title_top_qr:"TOP QR",
      title_88E:"TOP QR",
      go:"འགྲོ་གི་ཡོད།",
      invalid_operation:"ནུས་པ་མེད་པར་བཀོལ་སྤྱོད་བྱེད་པ།",
      submit_require_login:"ཁྱེད་རང་གིས་ཐོ་འགོད་བྱས་ན་གཞི་ནས་གཞི་གྲངས་འདོན་སྤྲོད་བྱེད་ཐུབ།",
      submit_not_allowed:"ཁྱེད་རང་གིས་གཞི་གྲངས་འདོན་སྤྲོད་བྱས་མི་ཆོག།",
      ok:"ད་དུང་འགྲིག་གི་རེད།",
      cancel:"མེད་པར་བཟོ་དགོས།",
      download_file:"ཕབ་ལེན་བྱེད་པ།",
      download_forbidden:"བཀག་སྡོམ་བྱ།",
      phone_number_required:"ཁ་པར་ཨང་གྲངས་སྟོང་པར་གཏོང་ཐབས་མེད།",
      email_required:"གློག་རྡུལ་འཕྲིན་ཡིག་ས་གནས་ནི་ངེས་པར་དུ་ཁ་སྐོང་བྱ་དགོས།",
      email_copied:"གློག་རྡུལ་འཕྲིན་ཡིག་ས་གནས་བསྐྱར་བཟོ་བྱས་ཟིན།",
      navigation_disabled:"ཕྱོགས་སྟོན་བེད་སྤྱོད་བྱས་མི་ཆོག",
      audio_not_support:"ཁྱེད་ཀྱི་བཤར་ཆས་ཀྱིས་སྒྲ་རླབས་ཤོག་བྱང་ལ་རྒྱབ་སྐྱོར་མི་བྱེད།",
      video_not_support:"ཁྱེད་ཀྱི་བཤར་ཆས་ཀྱིས་བརྙན་རིས་ཀྱི་ཤོག་བྱང་ལ་རྒྱབ་སྐྱོར་མི་བྱེད།",
      unkown:"མ་ཤེས་པ།",
      fail_play_media:"སྨྱན་སྦྱོར་གཏོང་ཐབས་མེད།",
      error_play_media:"སྨྱན་སྦྱོར་གཏོང་སྐབས་ནོར་འཁྲུལ་བྱུང་བ།",
      wechat_name:"འཕྲིན་ཕྲན་གྱི་མིང་རེག་པ།",
      form_unavailable_h5:"རེའུ་མིག་གི་ཚོད་འཛིན་དེ་སྐད་འཕྲིན་ཆུང་བའི་གོ་རིམ་ཁོ་ནར་སྤྱད་འཐུས་པ་དང་། འཕྲིན་ཕྲན་ཐོག་ནས་ཡང་བསྐྱར་ཨང་གྲངས་གཉིས་ཞིབ་བཤེར་བྱེད་རོགས།",
      upload_video:"བརྙན་འཕྲིན་གོང་ལ་གཏོང་བ།",
      is_required:"དགོས་ངེས་ཤིག་རེད།",
      cells_required:"མངོན་གསལ་དོད་པའི་ཚན་པའི་ཐོབ་ཐང་ལ་ནུས་པ་མེད།",
      click_sign:"མིང་རྟགས་འགོད་པ།",
      upload_picture:"རི་མོ་ཡར་བཀྱག་པ།",
      enter_number:"ནང་འདྲེན་གྱི་གྲངས་ཀ།",
      enter_name:"ནང་འཇུག་གི་མིང་།",
      enter_text:"དཔེ་དེབ་ནང་འཇུག་བྱེད་པ།",
      enter_mobile:"ལག་ཁྱེར་ཁ་པར་དུ་སླེབས་པ།",
      welcome_to_top_qr:"TOP QR་ལ་ཕེབས་པར་དགའ་བསུ་ཞུ།",
      welcome_to_88E:"TOP QR་ལ་ཕེབས་པར་དགའ་བསུ་ཞུ།",
      username_required:"སྤྱོད་མཁན་གྱི་མིང་ནི་ངེས་པར་དུ་ཁ་སྐོང་བྱ་དགོས།",
      password_required:"གསང་བ་ནི་དགོས་ངེས་ཤིག་རེད།",
      signing_in:"ཐོ་རུ་བཀོད་པ།",
      sign_in:"ཐོ་རུ་བཀོད་པ།",
      please_login:"ཐོ་འགོད་གནང་རོགས།",
      invalid_user_or_password:"སྤྱོད་མཁན་གྱི་མིང་ངམ་གསང་གྲངས་རྩིས་འགྲོ་མེད།",
      fail_login:"ཐོ་འགོད་བྱས་ནས་ཕམ་ཁ་བྱུང་",
      enter_location:"གོ་གནས་སུ་འཇུག་དགོས།",
      enter_id:"IDནང་འཇུག་བྱེད་པ།",
      enter_employee_number:"ལས་བཟོ་བའི་ཨང་གྲངས་ནང་འཇུག་བྱེད་པ།",
      male:"ཕོ་རྒོད།",
      female:"བུད་མེད།",
      upload_file:"ཡིག་ཆ་གོང་ལ་འབུལ་དགོས།",
      pick_cascade_data:"རིམ་པ་མཉམ་འབྲེལ་གྱི་གཞི་གྲངས་འདེམས་སྒྲུག་བྱ།",
      must_check_one_item:"ཁྱེད་རང་གིས་ངེས་པར་དུ་རྣམ་གྲངས་གཅིག་ལ་ཞིབ་བཤེར་བྱ་དགོས།",
      record:"ཟིན་ཐོར་འགོད་དགོས།",
      pick_a_district:"ས་ཁུལ་གཅིག་གདམ་གསེས་བྱ་དགོས།",
      enter_address:"ས་གནས་ནང་འཇུག་བྱེད་པ།",
      serial_number:"གོ་རིམ།",
      current_value:"རིན་ཐང་།",
      update_message:"xxxཡིས་xxx-xx-xཡིས་གསར་སྒྱུར་བྱེད་བཞིན་ཡོད།",
      scan_with_wechat:"འཕྲིན་ཕྲན་གྱི་གོ་རིམ་ཆུང་ཆུང་དེ་བཤར་ཆས་ཀྱི་ཁྲོད་ནས་ཕྱེ་མི་ཐུབ། འཕྲིན་ཕྲན་གྱིས་ཨང་གྲངས་གཉིས་པར་ཞིབ་བཤེར་བྱེད་རོགས།",
      select_language_title:"འདི་གཉིས་ཀྱིས་གཤམ་གྱི་སྐད་ཆར་རྒྱབ་སྐྱོར་བྱེད་ཀྱིན་ཡོད། ཁྱེད་ཀྱིས་སྐད་རིགས་ཤིག་འདེམས་རོགས།",
      geo_restricted:"དེ་གཉིས་ཀྱི་ཨང་གྲངས་ནིས་ཁོངས་སུ་བཤེར་བཤེར་བྱེད་པར་ཚོད་འཛིན་བྱེད་དགོས།"                                                                                                                                                                                                             
    }
  },
  ug: {
    message: {
      qr_redirect_url:"QR كودى تۆۋەندىكى ئادرېسقا يۆتكەيدۇ، بىخەتەر بولماسلىقى مۇمكىن",
      user_or_guest:"QR كودىنىڭ ئىقتىدارى سكاننېرنىڭ سالاھىيىتىگە ئاساسەن ئوخشاش بولمايدۇ. سىز رويخەتكە ئالدۇرغان ئابونىتمۇ ياكى مېھمانمۇ؟",
      input_username:"ئىشلەتكۈچى نامىنى كىرگۈز",
      input_password:"پارول كىرگۈز",
      login:"كىرىش",
      i_am_a_guest:"مەن مېھمان",
      loading_qr:"QR كودى قاچىلىنىۋاتىدۇ ...",
      invalid_qr:"ئىناۋەتسىز QR كودى",
      campaign_not_start:"QR كود تەشۋىقاتى تېخى باشلىمىدى",
      campaign_end:"QR كود تەشۋىقاتى ئاخىرلاشتى",
      subscription_expired:"QR كودى ئىشلەتكىلى بولمايدۇ، چۈنكى ۋاقتى ئۆتۈپ كەتكەن بىر پىلان ئاستىدا ئىدى.",
      max_scan_reached:"QR كودى ئىشلەتكىلى بولمايدۇ، چۈنكى بۇ QR كودى پىلانىغا ئەڭ چوڭ سىكاننېرلاشقا يول قويۇلىدۇ.",
      not_allowed:"بۇ QR نى زىيارەت قىلىشىڭىز چەكلىنىدۇ.",
      qr_closed:"بۇ QR كودى تاقالدى.",
      password_protected:"QR كودى مەخپى نۇمۇر قوغدىلىدۇ، مەخپى نۇمۇرنى ئىناۋەتلىك قىلىڭ",
      validate:"ئىناۋەتلىك قىلىش",
      pleasesave:"دىنامىكىلىق QR كودى ساقلىنىشتىن بۇرۇن ئىشلىمەيدۇ. بۇ بەتنى كۆرسىڭىز ساقلىۋېلىڭ.",
      invalid_password:"ئىناۋەتسىز پارول",
      password_validation_error:"پارولنى دەلىللەش جەريانىدا خاتالىق كۆرۈلدى.",
      invalid_username_password:"ئىناۋەتسىز ئىشلەتكۈچى نامى ياكى مەخپىي نومۇرى.",
      login_error:"تىزىملىتىپ كىرىش جەريانىدا خاتالىق كۆرۈلدى.",
      scan_error:"QR كودىنى سىكاننېرلىغاندا خاتالىق كۆرۈلدى.",
      powered_by_top_qr:"Powered by TOP_QR",
      powered_by_88E:"Powered by TOP QR",
      title_top_qr:"TOP QR",
      title_88E:"TOP QR",
      go:"ماڭ",
      invalid_operation:"ئىناۋەتسىز مەشخۇلات",
      submit_require_login:"سانلىق مەلۇمات يوللاش ئۈچۈن تىزىملىتىپ كىرىشىڭىز كېرەك.",
      submit_not_allowed:"سىز سانلىق مەلۇمات يوللاشقا يول قويۇلمايدۇ.",
      ok:"ماقۇل",
      cancel:"ئەمەلدىن قالدۇرۇش",
      download_file:"چۈشۈرۈش",
      download_forbidden:"چەكلەنگەن ئىشلار",
      phone_number_required:"قۇرۇق تېلېفون نومۇرىنى ئۇرغىلى بولمايدۇ.",
      email_required:"ئېلخەت ئادرېسى تەلەپ قىلىنىدۇ.",
      email_copied:"ئېلخەت ئادرېسى كۆچۈرۈلگەن.",
      navigation_disabled:"يول باشلاش چەكلەنگەن.",
      audio_not_support:"ئېكسپېدىتسىيەچىڭىز ئاۋاز بەلگىسىنى قوللىمايدۇ.،",
      video_not_support:"ئېكسپېدىتسىيەچىڭىز كۆرۈنمە چاستوتا بەلگىسىنى قوللىمايدۇ.،",
      unkown:"نامەلۇم",
      fail_play_media:"ۋاسىتە ئويناش مەغلۇپ بولدى.",
      error_play_media:"مېدىيا ئويناۋاتقاندا خاتالىق يۈز بەردى.",
      wechat_name:"ئۈندىدار نامىنى ئېلىش ئۈچۈن چېكىڭ.،",
      form_unavailable_h5:"جەدۋەل كونترول قىلىش پەقەت ئۈندىدار miniapp بىلەنلا ئىشلەيدۇ، QR كودىنى ئۈندىدار ئارقىلىق قايتا سىكاننېرلاڭ.،",
      upload_video:"ۋىدېئو يوللاش .،",
      is_required:"تەلەپ قىلىنىدۇ.،",
      cells_required:"گەۋدىلىك ھۈجەيرە ئىناۋەتسىز .",
      click_sign:"چېكىپ ئىمزا قويۇپ ،",
      upload_picture:"رەسىم يوللاش ،",
      enter_number:"نومۇر كىرگۈزۈڭ ،",
      enter_name:"ئىسىمنى كىرگۈزۈپ ،",
      enter_text:"تېكىست كىرگۈزۈڭ ،",
      enter_mobile:"كۆچمە كىرسە ،",
      welcome_to_top_qr:"TOP QR غا كەلگىنىڭىزنى قارشى ئالىمىز",
      welcome_to_88E:"TOP QR غا كەلگىنىڭىزنى قارشى ئالىمىز",
      username_required:"ئىشلەتكۈچى نامى تەلەپ قىلىنىدۇ.",
      password_required:"مەخپىي نومۇر تەلەپ قىلىنىدۇ.",
      signing_in:"تىزىمغا كىرىش",
      sign_in:"تىزىملاش",
      please_login:"كىرىشكە تىزىملىتىڭ",
      invalid_user_or_password:"ئىناۋەتسىز ئىشلەتكۈچى نامى ياكى مەخپىي نومۇرى.",
      fail_login:"تىزىملىتىپ كىرگەندىن كېيىن مەغلۇپ بولدى.",
      enter_location:"ئورۇن كىرگۈزۈش",
      enter_id:"كىملىك كىرگۈزۈش",
      enter_employee_number:"ئىشچى-خىزمەتچىلەر نومۇرىنى كىرگۈزۈڭ",
      male:"ئەركەك",
      female:"قىز بالا-شاھرۇھخان",
      upload_file:"ھۆججەت يۈكلەش",
      pick_cascade_data:"كەسمە سانلىق مەلۇماتنى تاللاش",
      must_check_one_item:"سىز چوقۇم ئاز دېگەندە بىر تۈرنى تەكشۈرۈپ بېقىشىڭىز كېرەك.",
      record:"خاتىرىلى",
      pick_a_district:"بىر رايون تاللاڭ",
      enter_address:"ئادرېسنى كىرگۈزۈڭ",
      serial_number:"قاتار نومۇرى",
      current_value:"قىممەت",
      update_message:"xxx تەرىپىدىن يېڭىلاندى xxxx-xx-xx xx",
      scan_with_wechat:"ئۈندىدار miniapp نى تور كۆرگۈچتە ئاچقىلى بولمىدى. ئۈندىدار ئارقىلىق QR كودىنى سىكاننېرلاڭ",
      select_language_title:"بۇ QR كودى تۆۋەندىكى تىللارنى قوللايدۇ. تىل تاللاڭ.",
      geo_restricted:"بۇ QR كودى پەقەت چەكلەنگەن رايوندا سكاننېرلىغىلى بولىدۇ.",                                                                                                                                                                                                                   
    }
  },
  mww: {
    message: {
      qr_redirect_url:"Tus QR code yuav redirect tom qab url, nws yuav tsis muaj kev ruaj ntseg",
      user_or_guest:"Tus QR code functions txawv raws li scanner tus kheej. Koj puas yog ib tug neeg sau npe los yog ib tug qhua?",
      input_username:"Sau tus neeg siv cov neeg siv",
      input_password:"Sau lo lus zais",
      login:"login",
      i_am_a_guest:"Kuv yog ib tug qhua",
      loading_qr:"Loading QR code...",
      invalid_qr:"Invalid QR code",
      campaign_not_start:"Cov kev sib tw QR code tsis tau pib",
      campaign_end:"Cov kev sib tw QR code muaj lawm",
      subscription_expired:"Tus QR code yog unavailable, vim nws yog nyob rau hauv ib lub hom phiaj uas muaj expired.",
      max_scan_reached:"Tus QR code yog unavailable, vim ntau scan pub rau lub hom phiaj ntawm no QR code yog mus txog.",
      not_allowed:"Koj tsis pub mus xyuas no QR.",
      qr_closed:"No QR code kaw.",
      password_protected:"Tus QR code yog password tiv thaiv, thov validate password",
      validate:"validate",
      pleasesave:"Dynamic QR Code tsis ua hauj lwm ua ntej nws rua. Yog koj pom nplooj ntawv no, thov txuag nws.",
      invalid_password:"Invalid password",
      password_validation_error:"Ib qho yuam kev tshwm sim thaum validating password.",
      invalid_username_password:"Invalid username los yog password.",
      login_error:"Ib qho yuam kev tshwm sim thaum logining.",
      scan_error:"Ib qho yuam kev tshwm sim thaum scanning QR code.",
      powered_by_top_qr:"Powered los ntawm TOP QR",
      powered_by_88E:"Powered los ntawm TOP QR",
      title_top_qr:"TOP QR",
      title_88E:"TOP QR",
      go:"Mus",
      invalid_operation:"Invalid lag luam.",
      submit_require_login:"Koj yuav tsum tau nkag mus rau login xa cov ntaub ntawv.",
      submit_not_allowed:"Koj tsis muaj cai xa cov ntaub ntawv.",
      ok:"Ua li",
      cancel:"raug muab tso tseg",
      download_file:"Download tau",
      download_forbidden:"Forbidden",
      phone_number_required:"Tas cov xov tooj yuav tsis raug dialed.",
      email_required:"Email chaw nyob yuav tsum tau txhaj.",
      email_copied:"Email chaw nyob yog luam.",
      navigation_disabled:"Navigation yog xiam oob qhab.",
      audio_not_support:"Koj explorer tsis txhawb audio tag.,",
      video_not_support:"Koj explorer tsis txhawb yees duab tag.,",
      unkown:"tsis paub",
      fail_play_media:"Tejyam uas ua si tawm.",
      error_play_media:"Ib qho yuam kev tshwm sim thaum uas ua si tawm.",
      wechat_name:"Nyem tau Wechat name.,",
      form_unavailable_h5:"Daim ntawv tswj tej hauj lwm tsuas nrog Wechat miniapp, thov scan lub QR code dua nrog Wechat.,",
      upload_video:"Upload yees duab.,",
      is_required:"yuav tsum tau txhaj.",
      cells_required:"Highlighted hlwb yog invalid.,",
      click_sign:"Nyem qhov kos npe,",
      upload_picture:"Upload duab,",
      enter_number:"Sau tus nab npawb,",
      enter_name:"Sau npe, npe",
      enter_text:"Sau phau ntawv,",
      enter_mobile:"Sau mobile,",
      welcome_to_top_qr:"Txais tos TOP QR",
      welcome_to_88E:"Txais tos TOP QR",
      username_required:"Tus neeg siv yuav tsum tau txhaj.",
      password_required:"Yuav tsum muaj lo lus zais.",
      signing_in:"Kos npe rau hauv",
      sign_in:"Sau npe nkag mus",
      please_login:"Thov login",
      invalid_user_or_password:"Invalid username los yog password.",
      fail_login:"Tejyam uas login.",
      enter_location:"Sau qhov chaw",
      enter_id:"SAU ID",
      enter_employee_number:"Sau tus neeg ua hauj lwm rau tus xov tooj",
      male:"Txiv",
      female:"Poj",
      upload_file:"Upload ntaub ntawv",
      pick_cascade_data:"De cascade cov ntaub ntawv",
      must_check_one_item:"Koj yuav tsum ntsuam xyuas yam tsawg ib yam khoom.",
      record:"Ntaubntawv",
      pick_a_district:"De ib lub cheeb tsam tsev kawm ntawv",
      enter_address:"Sau qhov chaw nyob",
      serial_number:"Serial nab npawb",
      current_value:"Nqi",
      update_message:"Kho tshiab los ntawm xxx ntawm xxx-xx-xx xx",
      scan_with_wechat:"Wechat miniapp yuav tsis tau qhib rau browser. Thov scan lub QR code nrog Wechat",
      select_language_title:"No QR code txhawb raws li cov lus. Thov xaiv ib hom lus.",
      geo_restricted:"No QR code yuav tsuas scanned nyob rau hauv cheeb tsam txwv."                                                                                                                                                                                                                       
    }
  },
  yue: {
    message: {
      qr_redirect_url:"二維碼將跳转到以下網址，該網址可能不安全：",
      user_or_guest:"該二維碼設置為不同嘅掃碼者掃出嘅內容不盡相同，請問你係註冊用戶還是遊客？",
      input_username:"請輸入用戶名",
      input_password:"請輸入密碼",
      login:"登錄",
      i_am_a_guest:"我係遊客",
      loading_qr:"正在加载二維碼...",
      invalid_qr:"無效嘅二維碼",
      campaign_not_start:"二維碼活動還未開始",
      campaign_end:"二維碼活動已結束",
      subscription_expired:"該二維碼無法掃碼，因為其對應嘅套餐已過期。",
      max_scan_reached:"該二維碼無法掃碼，因為掃碼量有達到該二維碼嘅最大掃碼量。",
      password_protected:"該二維碼受密碼保護，請驗證密碼。",
      validate:"驗證",
      pleasesave:"動態二維碼需要保存才可以正常顯示，如果您看到本頁面，請先保存動態二維碼。",
      invalid_password:"密碼錯誤",
      password_validation_error:"驗證密碼時發生錯誤。",
      invalid_username_password:"無效嘅用戶名或密碼。",
      login_error:"登錄時發生錯誤。",
      scan_error:"掃碼時發生錯誤。",
      powered_by_top_qr:"技術支持TOP QR",
      powered_by_88E:"技術支持88二維碼",
      title_top_qr:"TOP QR",
      title_88E:"88二維碼",
      go:"前往訪問",
      invalid_operation:"非法操作。",
      submit_require_login:"你需要登錄才能提交數據。",
      submit_not_allowed:"你無權提交數據。",
      ok:"確認",
      cancel:"取消",
      download_file:"下載文件",
      download_forbidden:"禁止下載",
      phone_number_required:"無法撥打空電話號碼。",
      email_required:"郵箱地址必填。",
      email_copied:"郵箱地址已複製。",
      navigation_disabled:"禁止導航。",
      audio_not_support:"瀏覽器唔撐audio標籤。",
      video_not_support:"瀏覽器唔撐video標籤。",
      unkown:"未知",
      fail_play_media:"播放失敗。",
      error_play_media:"播放時發生錯誤。",
      wechat_name:"單擊讀取微信名。",
      form_unavailable_h5:"表單控件只能喺微信細程序度使用，請用微信掃碼番。",
      upload_video:"上傳視頻",
      is_required:"必填。",
      cells_required:"突出顯示嘅單位格必填。",
      click_sign:"單擊以簽名",
      upload_picture:"上傳圖片",
      enter_number:"請輸入數字",
      enter_name:"請輸入姓名",
      enter_text:"請輸入文本",
      enter_mobile:"請輸入手機號",
      welcome_to_top_qr:"歡迎使用TOP QR",
      welcome_to_88E:"歡迎使用88二維碼",
      username_required:"用戶名必填。",
      password_required:"密碼必填。",
      signing_in:"正在登錄",
      sign_in:"登錄",
      please_login:"請登錄",
      invalid_user_or_password:"無效嘅用戶名或密碼。",
      fail_login:"登錄失敗。",
      enter_location:"請輸入位置",
      enter_id:"請輸入身份證號碼",
      enter_employee_number:"請輸入工號",
      male:"男",
      female:"女",
      upload_file:"上傳文件",
      pick_cascade_data:"選擇多級數據",
      must_check_one_item:"你必須至少選擇一項。",
      record:"錄音",
      pick_a_district:"請選擇省市區",
      enter_address:"請輸入地址",
      serial_number:"序列號",
      current_value:"當前數值",
      update_message:"xxx于xxxx-xx-xx xx：xx：xx更新",
      scan_with_wechat:"微信細程序無法喺瀏覽器中打開，請用微信掃碼。",
      select_language_title:"本二維碼支持下列語言，請選擇一種語言。",
      geo_restricted:"該二維碼僅可在指定的地理區域掃描。"                                                                                                                                                                                                                            
    }
  },
}

// 2. Create i18n instance with options
const i18n = createI18n({
  locale: 'hant', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
  // If you need to specify other options, you can set other options
  // ...
})



const app=createApp(App);

app.config.globalProperties.$common = common

app.use(VueClipboard, {
    autoSetContainer: true,
    appendToBody: true,
  }).use(PrimeVue).use(ConfirmationService).use(DialogService).use(ToastService).use(common).use(router).use(i18n).mount('#app')